/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
! function(t, e, s, i, o, n, r) {
    "use strict";

    function a(t) {
        t.querySelectorAll(".form-field").forEach((t => {
            const e = t.querySelector("label"),
                s = t.querySelector("input, textarea");
            e && s && (s.addEventListener("keyup", (t => {
                "" !== t.target.value ? e.classList.add("label--float") : e.classList.remove("label--float")
            })), s.value && s.value.length && e.classList.add("label--float"))
        }))
    }! function() {
        const t = {
            NODE_ENV: "production"
        };
        try {
            if (process) return process.env = Object.assign({}, process.env), void Object.assign(process.env, t)
        } catch (t) {}
        globalThis.process = {
            env: t
        }
    }(), window.theme = window.theme || {}, window.theme.sizes = {
        mobile: 480,
        small: 750,
        large: 990,
        widescreen: 1400
    }, window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    let l = p();

    function c() {
        const t = {};
        return t.windowHeight = Math.min(window.screen.height, window.innerHeight), t.footerHeight = m('[data-section-type*="footer"]'), t.headerHeight = m("[data-header-height]"), t.stickyHeaderHeight = document.querySelector("[data-header-sticky]") ? t.headerHeight : 0, t.collectionNavHeight = m("[data-collection-nav]"), t.logoHeight = function() {
            const t = m("[data-footer-logo]");
            return t > 0 ? t + 20 : 0
        }(), t
    }

    function h() {
        document.addEventListener("theme:resize", u), d()
    }

    function d() {
        const {
            windowHeight: t,
            headerHeight: e,
            logoHeight: s,
            footerHeight: i,
            collectionNavHeight: o
        } = c();
        document.documentElement.style.setProperty("--full-height", `${t}px`), document.documentElement.style.setProperty("--three-quarters", t * (3 / 4) + "px"), document.documentElement.style.setProperty("--two-thirds", t * (2 / 3) + "px"), document.documentElement.style.setProperty("--one-half", t / 2 + "px"), document.documentElement.style.setProperty("--one-third", t / 3 + "px"), document.documentElement.style.setProperty("--collection-nav-height", `${o}px`), document.documentElement.style.setProperty("--header-height", `${e}px`), document.documentElement.style.setProperty("--footer-height", `${i}px`), document.documentElement.style.setProperty("--content-full", t - e - s / 2 + "px"), document.documentElement.style.setProperty("--content-min", t - e - i + "px"), document.querySelector("[data-tracking-consent].popup-cookies--bottom") && document.documentElement.style.setProperty("--cookie-bar-height", `${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`)
    }

    function u() {
        const {
            windowHeight: t,
            headerHeight: e,
            logoHeight: s,
            footerHeight: i,
            collectionNavHeight: o
        } = c(), n = p();
        (n !== l || window.innerWidth > window.theme.sizes.mobile) && (document.documentElement.style.setProperty("--full-height", `${t}px`), document.documentElement.style.setProperty("--three-quarters", t * (3 / 4) + "px"), document.documentElement.style.setProperty("--two-thirds", t * (2 / 3) + "px"), document.documentElement.style.setProperty("--one-half", t / 2 + "px"), document.documentElement.style.setProperty("--one-third", t / 3 + "px"), l = n), document.documentElement.style.setProperty("--collection-nav-height", `${o}px`), document.documentElement.style.setProperty("--header-height", `${e}px`), document.documentElement.style.setProperty("--footer-height", `${i}px`), document.documentElement.style.setProperty("--content-full", t - e - s / 2 + "px"), document.documentElement.style.setProperty("--content-min", t - e - i + "px"), document.querySelector("[data-tracking-consent].popup-cookies--bottom") && document.documentElement.style.setProperty("--cookie-bar-height", `${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`)
    }

    function p() {
        return window.matchMedia("(orientation: portrait)").matches ? "portrait" : window.matchMedia("(orientation: landscape)").matches ? "landscape" : void 0
    }

    function m(t) {
        const e = document.querySelector(t);
        return e ? e.offsetHeight : 0
    }

    function v(t, e) {
        let s;
        return function() {
            if (t) {
                const i = () => t.apply(this, arguments);
                clearTimeout(s), s = setTimeout(i, e)
            }
        }
    }

    function g() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    }

    function f() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    }

    function y() {
        return g() >= window.theme.sizes.small
    }

    function b() {
        return g() < window.theme.sizes.small
    }
    window.initialWindowHeight = Math.min(window.screen.height, window.innerHeight);
    let w = g(),
        E = f();
    let S = window.scrollY,
        L = null,
        k = null,
        A = null,
        C = null,
        T = 0;

    function q(e) {
        setTimeout((() => {
            T && clearTimeout(T), t.disablePageScroll(e.detail, {
                allowTouchMove: t => "TEXTAREA" === t.tagName
            }), document.documentElement.setAttribute("data-scroll-locked", "")
        }))
    }

    function x(t) {
        const e = t.detail;
        e ? T = setTimeout(M, e) : M()
    }

    function M() {
        t.clearQueueScrollLocks(), t.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked")
    }
    const P = (t, e = "", s) => {
        const i = s || document.createElement("div");
        return i.classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t)
    };

    function I(t) {
        t.querySelectorAll(".rte table").forEach((t => {
            P(t, "rte__table-wrapper"), t.setAttribute("data-scroll-lock-scrollable", "")
        }));
        t.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach((t => {
            P(t, "rte__video-wrapper")
        }))
    }

    function H(t) {
        const e = t.querySelectorAll("[data-aria-toggle]");
        e.length && e.forEach((t => {
            t.addEventListener("click", (function(t) {
                t.preventDefault();
                const e = t.currentTarget;
                e.setAttribute("aria-expanded", "false" == e.getAttribute("aria-expanded") ? "true" : "false");
                const s = e.getAttribute("aria-controls"),
                    i = document.querySelector(`#${s}`),
                    o = () => {
                        i.classList.remove("expanding"), i.removeEventListener("transitionend", o)
                    },
                    n = () => {
                        i.classList.add("expanding"), i.removeEventListener("transitionstart", n)
                    };
                i.addEventListener("transitionstart", n), i.addEventListener("transitionend", o), i.classList.toggle("expanded")
            }))
        }))
    }
    const O = "is-loading",
        B = "img.is-loading";

    function D(t, e) {
        e = e || {};
        var s = t.tabIndex;
        t.tabIndex = -1, t.dataset.tabIndex = s, t.focus(), void 0 !== e.className && t.classList.add(e.className), t.addEventListener("blur", (function i(o) {
            o.target.removeEventListener(o.type, i), t.tabIndex = s, delete t.dataset.tabIndex, void 0 !== e.className && t.classList.remove(e.className)
        }))
    }

    function F(t) {
        return Array.prototype.slice.call(t.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled")).filter((function(t) {
            return !(!(t.offsetWidth || t.offsetHeight || t.getClientRects().length) || (e = t, s = window.getComputedStyle(e), "none" === s.display || "hidden" === s.visibility));
            var e, s
        }))
    }
    var $ = {};

    function _(t, e) {
        e = e || {};
        var s = F(t),
            i = e.elementToFocus || t,
            o = s[0],
            n = s[s.length - 1];
        N(), $.focusin = function(e) {
            t !== e.target && !t.contains(e.target) && o && o === e.target && o.focus(), e.target !== t && e.target !== n && e.target !== o || document.addEventListener("keydown", $.keydown)
        }, $.focusout = function() {
            document.removeEventListener("keydown", $.keydown)
        }, $.keydown = function(e) {
            "Tab" === e.code && (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()), e.target !== t && e.target !== o || !e.shiftKey || (e.preventDefault(), n.focus()))
        }, document.addEventListener("focusout", $.focusout), document.addEventListener("focusin", $.focusin), D(i, e)
    }

    function N() {
        document.removeEventListener("focusin", $.focusin), document.removeEventListener("focusout", $.focusout), document.removeEventListener("keydown", $.keydown)
    }

    function R() {
        window.accessibility.lastElement && document.body.classList.contains("is-focused") && setTimeout((() => {
            var t;
            null === (t = window.accessibility.lastElement) || void 0 === t || t.focus()
        }))
    }
    var z = Object.freeze({
        __proto__: null,
        forceFocus: D,
        focusHash: function(t) {
            t = t || {};
            var e = window.location.hash,
                s = document.getElementById(e.slice(1));
            if (s && t.ignore && s.matches(t.ignore)) return !1;
            e && s && D(s, t)
        },
        bindInPageLinks: function(t) {
            return t = t || {}, Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((function(e) {
                if ("#" === e.hash || "" === e.hash) return !1;
                if (t.ignore && e.matches(t.ignore)) return !1;
                if (s = e.hash.substr(1), null === document.getElementById(s)) return !1;
                var s, i = document.querySelector(e.hash);
                return !!i && (e.addEventListener("click", (function() {
                    D(i, t)
                })), !0)
            }))
        },
        focusable: F,
        trapFocus: _,
        removeTrapFocus: N,
        autoFocusLastElement: R,
        accessibleLinks: function(t, e) {
            if ("string" != typeof t) throw new TypeError(t + " is not a String.");
            if (0 !== (t = document.querySelectorAll(t)).length) {
                (e = e || {}).messages = e.messages || {};
                var s, i, o, n = {
                        newWindow: e.messages.newWindow || "Opens in a new window.",
                        external: e.messages.external || "Opens external website.",
                        newWindowExternal: e.messages.newWindowExternal || "Opens external website in a new window."
                    },
                    r = e.prefix || "a11y",
                    a = {
                        newWindow: r + "-new-window-message",
                        external: r + "-external-message",
                        newWindowExternal: r + "-new-window-external-message"
                    };
                t.forEach((function(t) {
                    var e = t.getAttribute("target"),
                        s = t.getAttribute("rel"),
                        i = function(t) {
                            return t.hostname !== window.location.hostname
                        }(t),
                        o = "_blank" === e,
                        n = null === s || -1 === s.indexOf("noopener");
                    if (o && n) {
                        var r = null === s ? "noopener" : s + " noopener";
                        t.setAttribute("rel", r)
                    }
                    i && o ? t.setAttribute("aria-describedby", a.newWindowExternal) : i ? t.setAttribute("aria-describedby", a.external) : o && t.setAttribute("aria-describedby", a.newWindow)
                })), s = n, i = document.createElement("ul"), o = Object.keys(s).reduce((function(t, e) {
                    return t + "<li id=" + a[e] + ">" + s[e] + "</li>"
                }), ""), i.setAttribute("hidden", !0), i.innerHTML = o, document.body.appendChild(i)
            }
        }
    });
    const W = 'input[type="search"]',
        U = '[aria-selected="true"] a',
        V = 'button[type="reset"]',
        j = "hidden";
    let X = class extends HTMLElement {
        toggleResetButton() {
            const t = this.resetButton.classList.contains(j);
            this.input.value.length > 0 && t ? this.resetButton.classList.remove(j) : 0 !== this.input.value.length || t || this.resetButton.classList.add(j)
        }
        onChange() {
            this.toggleResetButton()
        }
        shouldResetForm() {
            return !document.querySelector(U)
        }
        onFormReset(t) {
            t.preventDefault(), this.shouldResetForm() && (this.input.value = "", this.toggleResetButton(), t.target.querySelector(W).focus())
        }
        constructor() {
            super(), this.input = this.querySelector(W), this.resetButton = this.querySelector(V), this.input && (this.input.form.addEventListener("reset", this.onFormReset.bind(this)), this.input.addEventListener("input", v((t => {
                this.onChange(t)
            }), 300).bind(this)))
        }
    };
    customElements.define("header-search-form", X);
    const J = '[role="option"]',
        Y = '[aria-selected="true"]',
        Q = "[data-popular-searches]",
        G = "predictive-search",
        K = "[data-predictive-search-results]",
        Z = "[data-predictive-search-status]",
        tt = 'input[type="search"]',
        et = "[data-popdown]",
        st = "[data-predictive-search-live-region-count-value]",
        it = "[data-search-results-groups-wrapper]",
        ot = "[data-predictive-search-search-for-text]",
        nt = "#shopify-section-predictive-search",
        rt = '[aria-selected="true"] a',
        at = '[aria-selected="true"] a, button[aria-selected="true"]';
    let lt = class extends X {
        connectedCallback() {
            this.input.addEventListener("focus", this.onFocus.bind(this)), this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.addEventListener("keyup", this.onKeyup.bind(this)), this.addEventListener("keydown", this.onKeydown.bind(this))
        }
        getQuery() {
            return this.input.value.trim()
        }
        onChange() {
            super.onChange();
            const t = this.getQuery();
            var e;
            this.searchTerm && t.startsWith(this.searchTerm) || (null === (e = this.querySelector(it)) || void 0 === e || e.remove());
            this.updateSearchForTerm(this.searchTerm, t), this.searchTerm = t, this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.reset()
        }
        onFormSubmit(t) {
            this.getQuery().length && !this.querySelector(rt) || t.preventDefault()
        }
        onFormReset(t) {
            super.onFormReset(t), super.shouldResetForm() && (this.searchTerm = "", this.abortController.abort(), this.abortController = new AbortController, this.closeResults(!0))
        }
        shouldResetForm() {
            return !document.querySelector(rt)
        }
        onFocus() {
            const t = this.getQuery();
            t.length && (this.searchTerm !== t ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm))
        }
        onFocusOut() {
            setTimeout((() => {
                this.contains(document.activeElement) || this.close()
            }))
        }
        onKeyup(t) {
            switch (this.getQuery().length || this.close(!0), t.preventDefault(), t.code) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption()
            }
        }
        onKeydown(t) {
            "ArrowUp" !== t.code && "ArrowDown" !== t.code || t.preventDefault()
        }
        updateSearchForTerm(t, e) {
            const s = this.querySelector(ot),
                i = null == s ? void 0 : s.innerText;
            if (i) {
                var o;
                if ((null === (o = i.match(new RegExp(t, "g"))) || void 0 === o ? void 0 : o.length) > 1) return;
                const n = i.replace(t, e);
                s.innerText = n
            }
        }
        switchOption(t) {
            if (!this.getAttribute("open")) return;
            const e = "up" === t,
                s = this.querySelector(Y),
                i = Array.from(this.querySelectorAll(J)).filter((t => null !== t.offsetParent));
            let o = 0;
            if (e && !s) return;
            let n = -1,
                r = 0;
            for (; - 1 === n && r <= i.length;) i[r] === s && (n = r), r++;
            if (this.statusElement.textContent = "", !e && s ? o = n === i.length - 1 ? 0 : n + 1 : e && (o = 0 === n ? i.length - 1 : n - 1), o === n) return;
            const a = i[o];
            a.setAttribute("aria-selected", !0), s && s.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", a.id)
        }
        selectOption() {
            const t = this.querySelector(at);
            t && t.click()
        }
        getSearchResults(t) {
            const e = t.replace(" ", "-").toLowerCase();
            this.setLiveRegionLoadingState(), this.cachedResults[e] ? this.renderSearchResults(this.cachedResults[e]) : fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(t)}&section_id=predictive-search`, {
                signal: this.abortController.signal
            }).then((t => {
                if (!t.ok) {
                    var e = new Error(t.status);
                    throw this.close(), e
                }
                return t.text()
            })).then((t => {
                const s = (new DOMParser).parseFromString(t, "text/html").querySelector(nt).innerHTML;
                this.allPredictiveSearchInstances.forEach((t => {
                    t.cachedResults[e] = s
                })), this.renderSearchResults(s)
            })).catch((t => {
                if (20 !== (null == t ? void 0 : t.code)) throw this.close(), t
            }))
        }
        setLiveRegionLoadingState() {
            this.statusElement = this.statusElement || this.querySelector(Z), this.loadingText = this.loadingText || this.getAttribute("data-loading-text"), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", !0)
        }
        setLiveRegionText(t) {
            this.statusElement.setAttribute("aria-hidden", "false"), this.statusElement.textContent = t, setTimeout((() => {
                this.statusElement.setAttribute("aria-hidden", "true")
            }), 1e3)
        }
        renderSearchResults(t) {
            this.predictiveSearchResults.innerHTML = t, this.setAttribute("results", !0), this.setLiveRegionResults(), this.open()
        }
        setLiveRegionResults() {
            this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(st).textContent)
        }
        open() {
            this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), this.isOpen = !0
        }
        close(t = !1) {
            this.closeResults(t), this.isOpen = !1
        }
        closeResults(t = !1) {
            var e;
            t && (this.input.value = "", this.removeAttribute("results"));
            const s = this.querySelector(Y);
            s && s.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", ""), this.removeAttribute("loading"), this.removeAttribute("open"), this.input.setAttribute("aria-expanded", !1), null === (e = this.predictiveSearchResults) || void 0 === e || e.removeAttribute("style")
        }
        reset() {
            this.predictiveSearchResults.innerHTML = "", this.input.val = "", this.a11y.removeTrapFocus(), this.popularSearches && (this.input.dispatchEvent(new Event("blur", {
                bubbles: !1
            })), this.a11y.trapFocus(this.searchPopdown, {
                elementToFocus: this.input
            }))
        }
        constructor() {
            var t;
            super(), this.a11y = z, this.abortController = new AbortController, this.allPredictiveSearchInstances = document.querySelectorAll(G), this.cachedResults = {}, this.input = this.querySelector(tt), this.isOpen = !1, this.predictiveSearchResults = this.querySelector(K), this.searchPopdown = this.closest(et), this.popularSearches = null === (t = this.searchPopdown) || void 0 === t ? void 0 : t.querySelector(Q), this.searchTerm = ""
        }
    };
    const ct = "[data-popout-list]",
        ht = "[data-popout-toggle]",
        dt = "[data-popout-toggle-text]",
        ut = "[data-popout-input]",
        pt = "[data-popout-option]",
        mt = "[data-product-image]",
        vt = "[data-grid-item]",
        gt = "popout-list--visible",
        ft = "is-visible",
        yt = "is-active",
        bt = "select-popout--top",
        wt = "aria-expanded",
        Et = "aria-current",
        St = "data-value",
        Lt = "data-popout-toggle-text",
        kt = "submit";
    let At = class extends HTMLElement {
            connectedCallback() {
                this.popoutList = this.querySelector(ct), this.popoutToggle = this.querySelector(ht), this.popoutToggleText = this.querySelector(dt), this.popoutInput = this.querySelector(ut), this.popoutOptions = this.querySelectorAll(pt), this.productGridItem = this.popoutList.closest(vt), this.fireSubmitEvent = this.hasAttribute(kt), this.popupToggleFocusoutEvent = t => this.onPopupToggleFocusout(t), this.popupListFocusoutEvent = t => this.onPopupListFocusout(t), this.popupToggleClickEvent = t => this.onPopupToggleClick(t), this.keyUpEvent = t => this.onKeyUp(t), this.bodyClickEvent = t => this.onBodyClick(t), this._connectOptions(), this._connectToggle(), this._onFocusOut(), this.popupListMaxWidth()
            }
            onPopupToggleClick(t) {
                const e = "true" === t.currentTarget.getAttribute(wt);
                if (this.productGridItem) {
                    const t = this.productGridItem.querySelector(mt);
                    t && t.classList.toggle(ft, !e), this.popoutList.style.maxHeight = `${Math.abs(this.popoutToggle.getBoundingClientRect().bottom-this.productGridItem.getBoundingClientRect().bottom)}px`
                }
                t.currentTarget.setAttribute(wt, !e), this.popoutList.classList.toggle(gt), this.popupListMaxWidth(), this.toggleListPosition(), document.body.addEventListener("click", this.bodyClickEvent)
            }
            onPopupToggleFocusout(t) {
                this.contains(t.relatedTarget) || this._hideList()
            }
            onPopupListFocusout(t) {
                const e = t.currentTarget.contains(t.relatedTarget);
                this.popoutList.classList.contains(gt) && !e && this._hideList()
            }
            toggleListPosition() {
                const t = "true" === this.querySelector(ht).getAttribute(wt),
                    e = window.innerHeight,
                    s = this.popoutList.getBoundingClientRect().bottom,
                    i = () => {
                        this.classList.remove(bt), this.popoutList.removeEventListener("transitionend", i)
                    };
                t ? e < s && this.classList.add(bt) : this.popoutList.addEventListener("transitionend", i)
            }
            popupListMaxWidth() {
                this.popoutList.style.setProperty("--max-width", "100vw"), requestAnimationFrame((() => {
                    this.popoutList.style.setProperty("--max-width", `${parseInt(document.body.clientWidth-this.popoutList.getBoundingClientRect().left)}px`)
                }))
            }
            popupOptionsClick(t) {
                if ("#" === t.target.closest(pt).attributes.href.value) {
                    t.preventDefault();
                    const e = t.currentTarget.hasAttribute(St) ? t.currentTarget.getAttribute(St) : "";
                    if (this.popoutInput.value = e, this.popoutInput.disabled && this.popoutInput.removeAttribute("disabled"), this.fireSubmitEvent) this._submitForm(e);
                    else {
                        const s = t.currentTarget.parentElement,
                            i = this.popoutList.querySelector(`.${yt}`),
                            o = this.popoutList.querySelector(`[${Et}]`);
                        this.popoutInput.dispatchEvent(new Event("change")), i && (i.classList.remove(yt), s.classList.add(yt)), "quantity" != this.popoutInput.name || s.nextSibling || this.classList.add(yt), o && o.hasAttribute(`${Et}`) && (o.removeAttribute(`${Et}`), t.currentTarget.setAttribute(`${Et}`, "true")), "" !== e && (this.popoutToggleText.innerHTML = e, this.popoutToggleText.hasAttribute(Lt) && "" !== this.popoutToggleText.getAttribute(Lt) && this.popoutToggleText.setAttribute(Lt, e)), this.onPopupToggleFocusout(t), this.onPopupListFocusout(t)
                    }
                }
            }
            onKeyUp(t) {
                "Escape" === t.code && (this._hideList(), this.popoutToggle.focus())
            }
            onBodyClick(t) {
                const e = this.contains(t.target);
                this.popoutList.classList.contains(gt) && !e && this._hideList()
            }
            _connectToggle() {
                this.popoutToggle.addEventListener("click", this.popupToggleClickEvent)
            }
            _connectOptions() {
                this.popoutOptions.length && this.popoutOptions.forEach((t => {
                    t.addEventListener("click", (t => this.popupOptionsClick(t)))
                }))
            }
            _onFocusOut() {
                this.addEventListener("keyup", this.keyUpEvent), this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent), this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent)
            }
            _submitForm() {
                const t = this.closest("form");
                t && t.submit()
            }
            _hideList() {
                this.popoutList.classList.remove(gt), this.popoutToggle.setAttribute(wt, !1), this.toggleListPosition(), document.body.removeEventListener("click", this.bodyClickEvent)
            }
            constructor() {
                super()
            }
        },
        Ct = class extends HTMLElement {
            connectedCallback() {
                this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
                    bubbles: !0
                }), this.buttonClickEvent = this.onButtonClick.bind(this), this.onQuantityChangeEvent = this.onQuantityChange.bind(this), this.input.addEventListener("change", this.onQuantityChangeEvent), this.querySelectorAll("button").forEach((t => t.addEventListener("click", this.buttonClickEvent)))
            }
            onButtonClick(t) {
                t.preventDefault();
                const e = this.input.value,
                    s = "BUTTON" == t.target.nodeName ? t.target : t.target.closest("button");
                "increase" === s.name && this.input.stepUp(), "decrease" === s.name && this.input.stepDown(), e !== this.input.value && this.input.dispatchEvent(this.changeEvent)
            }
            onQuantityChange() {
                "updates[]" == this.input.name && this.updateCart()
            }
            updateCart() {
                "" !== this.quantityValue && this.dispatchEvent(new CustomEvent("theme:cart:update", {
                    bubbles: !0,
                    detail: {
                        id: this.input.dataset.id,
                        quantity: this.input.value
                    }
                }))
            }
            constructor() {
                super()
            }
        };
    const Tt = "[data-aos]:not(.aos-animate)",
        qt = "[data-aos-anchor]",
        xt = "[data-aos]:not([data-aos-anchor]):not(.aos-animate)",
        Mt = "aos-animate",
        Pt = {
            attributes: !1,
            childList: !0,
            subtree: !0
        };
    let It = [];
    const Ht = t => {
            for (const e of t)
                if ("childList" === e.type) {
                    const t = e.target,
                        s = t.querySelectorAll(Tt),
                        i = t.querySelectorAll(qt);
                    s.length && s.forEach((t => {
                        Ot.observe(t)
                    })), i.length && Dt(i)
                }
        },
        Ot = new IntersectionObserver(((t, e) => {
            t.forEach((t => {
                t.isIntersecting && (t.target.classList.add(Mt), e.unobserve(t.target))
            }))
        }), {
            root: null,
            rootMargin: "0px",
            threshold: [0, .1, .25, .5, .75, 1]
        }),
        Bt = new IntersectionObserver(((t, e) => {
            t.forEach((t => {
                if (t.intersectionRatio) {
                    const s = t.target.querySelectorAll(Tt);
                    s.length && s.forEach((t => {
                        t.classList.add(Mt)
                    })), e.unobserve(t.target)
                }
            }))
        }), {
            root: null,
            rootMargin: "0px",
            threshold: [.1, .25, .5, .75, 1]
        });

    function Dt(t) {
        t.length && t.forEach((t => {
            const e = t.dataset.aosAnchor;
            if (e && -1 === It.indexOf(e)) {
                const t = document.querySelector(e);
                t && (Bt.observe(t), It.push(e))
            }
        }))
    }
    const Ft = "img",
        $t = "template",
        _t = "srcset";
    let Nt = class extends HTMLElement {
        connectedCallback() {
            if (this.isRendered) return;
            const t = new IntersectionObserver((e => {
                e.forEach((e => {
                    if (e.intersectionRatio > 0) {
                        const e = this.querySelector($t),
                            s = null == e ? void 0 : e.content.firstElementChild.cloneNode(!0);
                        this.appendChild(s), this.reloadSrcset(this), t.disconnect()
                    }
                }))
            }), {
                threshold: [.01, .25, .5, .75, 1]
            });
            t.observe(this), this.isRendered = !0
        }
        reloadSrcset(t) {
            t && t.querySelectorAll(Ft).forEach((t => {
                const e = t.getAttribute(_t);
                t.setAttribute(_t, ""), t.setAttribute(_t, e)
            }))
        }
        constructor() {
            super(), this.isRendered = !1
        }
    };
    const Rt = "[data-deferred-media-button]",
        zt = "video, model-viewer, iframe",
        Wt = '[data-host="youtube"]',
        Ut = '[data-host="vimeo"]',
        Vt = "[data-grid-item]",
        jt = ".shopify-section",
        Xt = "template",
        Jt = "video",
        Yt = "product-model",
        Qt = "loaded",
        Gt = "autoplay";
    let Kt = class extends HTMLElement {
        connectedCallback() {
            this.productGridItem && (this.section.addEventListener("mouseover", this.mouseOverEvent, {
                once: !0
            }), this.addEventListener("mouseenter", this.mouseEnterEvent), this.addEventListener("mouseleave", this.mouseLeaveEvent))
        }
        disconnectedCallback() {
            this.productGridItem && (this.section.removeEventListener("mouseover", this.mouseOverEvent, {
                once: !0
            }), this.removeEventListener("mouseenter", this.mouseEnterEvent), this.removeEventListener("mouseleave", this.mouseLeaveEvent))
        }
        mouseEnterActions() {
            this.hovered = !0, this.videoActions(), this.getAttribute(Qt) || this.loadContent()
        }
        mouseLeaveActions() {
            this.hovered = !1, this.videoActions()
        }
        videoActions() {
            if (this.getAttribute(Qt)) {
                const t = this.querySelector(Wt),
                    e = this.querySelector(Ut),
                    s = t || e,
                    i = this.querySelector(Jt);
                if (s) {
                    let t = this.hovered ? "playVideo" : "pauseVideo",
                        i = `{"event":"command","func":"${t}","args":""}`;
                    e && (t = this.hovered ? "play" : "pause", i = `{"method":"${t}"}`), s.contentWindow.postMessage(i, "*"), s.addEventListener("load", (t => {
                        this.videoActions()
                    }))
                } else i && (this.hovered ? i.play() : i.pause())
            }
        }
        loadContent(t = !0) {
            if (this.pauseAllMedia(), !this.getAttribute(Qt)) {
                const e = document.createElement("div"),
                    s = this.querySelector(Xt).content.firstElementChild.cloneNode(!0);
                e.appendChild(s), this.setAttribute(Qt, !0);
                const i = this.appendChild(e.querySelector(zt));
                t && i.focus(), "VIDEO" == i.nodeName && i.getAttribute(Gt) && i.play(), this.productGridItem && this.videoActions()
            }
        }
        pauseAllMedia() {
            document.querySelectorAll(Wt).forEach((t => {
                t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
            })), document.querySelectorAll(Ut).forEach((t => {
                t.contentWindow.postMessage('{"method":"pause"}', "*")
            })), document.querySelectorAll(Jt).forEach((t => t.pause())), document.querySelectorAll(Yt).forEach((t => {
                t.modelViewerUI && t.modelViewerUI.pause()
            }))
        }
        constructor() {
            super();
            const t = this.querySelector(Rt);
            null == t || t.addEventListener("click", this.loadContent.bind(this)), this.section = this.closest(jt), this.productGridItem = this.closest(Vt), this.hovered = !1, this.mouseEnterEvent = () => this.mouseEnterActions(), this.mouseLeaveEvent = () => this.mouseLeaveActions()
        }
    };
    const Zt = "is-visible";
    class te {
        init() {
            var t;
            const e = {
                root: this.container,
                threshold: [.01, .5, .75, .99]
            };
            this.observer = new IntersectionObserver((t => {
                t.forEach((t => {
                    t.intersectionRatio >= .99 ? t.target.classList.add(Zt) : t.target.classList.remove(Zt)
                }))
            }), e), null === (t = this.container.querySelectorAll(this.itemSelector)) || void 0 === t || t.forEach((t => {
                this.observer.observe(t)
            }))
        }
        destroy() {
            this.observer.disconnect()
        }
        constructor(t, e) {
            t && e && (this.observer = null, this.container = t, this.itemSelector = e, this.init())
        }
    }
    const ee = "is-dragging",
        se = "is-enabled",
        ie = "is-scrolling",
        oe = "is-visible",
        ne = "[data-grid-item]";
    class re {
        handleMouseDown(t) {
            t.preventDefault(), this.isDown = !0, this.startX = t.pageX - this.slider.offsetLeft, this.scrollLeft = this.slider.scrollLeft, this.cancelMomentumTracking()
        }
        handleMouseLeave() {
            this.isDown && (this.isDown = !1, this.beginMomentumTracking())
        }
        handleMouseUp() {
            this.isDown = !1, this.beginMomentumTracking()
        }
        handleMouseMove(t) {
            if (!this.isDown) return;
            t.preventDefault();
            const e = 1 * (t.pageX - this.slider.offsetLeft - this.startX),
                s = this.slider.scrollLeft,
                i = e > 0 ? 1 : -1;
            this.slider.classList.add(ee, ie), this.slider.scrollLeft = this.scrollLeft - e, this.slider.scrollLeft !== s && (this.velX = this.slider.scrollLeft - s || i)
        }
        handleMouseWheel() {
            this.cancelMomentumTracking(), this.slider.classList.remove(ie)
        }
        beginMomentumTracking() {
            this.isScrolling = !1, this.slider.classList.remove(ee), this.cancelMomentumTracking(), this.scrollToSlide()
        }
        cancelMomentumTracking() {
            cancelAnimationFrame(this.scrollAnimation)
        }
        scrollToSlide() {
            if (!this.velX && !this.isScrolling) return;
            const t = this.slider.querySelector(`${ne}.${oe}`);
            if (!t) return;
            const e = parseInt(window.getComputedStyle(t).marginRight) || 0,
                s = t.offsetWidth + e,
                i = t.offsetLeft,
                o = this.velX > 0 ? 1 : -1,
                n = Math.floor(Math.abs(this.velX) / 100) || 1;
            this.startPosition = this.slider.scrollLeft, this.distance = i - this.startPosition, this.startTime = performance.now(), this.isScrolling = !0, o < 0 && this.velX < s && (this.distance -= s * n), o > 0 && this.velX < s && (this.distance += s * n), this.scrollAnimation = requestAnimationFrame(this.scrollStep)
        }
        scrollStep() {
            const t = performance.now() - this.startTime,
                e = parseFloat(this.easeOutCubic(Math.min(t, this.duration))).toFixed(1);
            this.slider.scrollLeft = e, t < this.duration ? this.scrollAnimation = requestAnimationFrame(this.scrollStep) : (this.slider.classList.remove(ie), this.velX = 0, this.isScrolling = !1)
        }
        easeOutCubic(t) {
            return t /= this.duration, t--, this.distance * (t * t * t + 1) + this.startPosition
        }
        destroy() {
            this.slider.classList.remove(se), this.slider.removeEventListener("mousedown", this.handleMouseDown), this.slider.removeEventListener("mouseleave", this.handleMouseLeave), this.slider.removeEventListener("mouseup", this.handleMouseUp), this.slider.removeEventListener("mousemove", this.handleMouseMove), this.slider.removeEventListener("wheel", this.handleMouseWheel)
        }
        constructor(t) {
            this.slider = t, this.isDown = !1, this.startX = 0, this.scrollLeft = 0, this.velX = 0, this.scrollAnimation = null, this.isScrolling = !1, this.duration = 800, this.scrollStep = this.scrollStep.bind(this), this.scrollToSlide = this.scrollToSlide.bind(this), this.handleMouseDown = this.handleMouseDown.bind(this), this.handleMouseLeave = this.handleMouseLeave.bind(this), this.handleMouseUp = this.handleMouseUp.bind(this), this.handleMouseMove = this.handleMouseMove.bind(this), this.handleMouseWheel = this.handleMouseWheel.bind(this), this.slider.addEventListener("mousedown", this.handleMouseDown), this.slider.addEventListener("mouseleave", this.handleMouseLeave), this.slider.addEventListener("mouseup", this.handleMouseUp), this.slider.addEventListener("mousemove", this.handleMouseMove), this.slider.addEventListener("wheel", this.handleMouseWheel, {
                passive: !0
            }), this.slider.classList.add(se)
        }
    }
    const ae = "[data-button-arrow]",
        le = "[data-collection-image]",
        ce = "[data-column-image]",
        he = "[data-product-image]",
        de = "[data-grid-item]",
        ue = "[data-grid-slider]",
        pe = "data-button-prev",
        me = "data-button-next",
        ve = "align-arrows",
        ge = "slider__arrows",
        fe = "is-visible";
    class ye extends HTMLElement {
        connectedCallback() {
            this.init(), this.addEventListener("theme:grid-slider:init", this.init)
        }
        init() {
            this.slider = this.querySelector(ue), this.slides = this.querySelectorAll(de), this.buttons = this.querySelectorAll(ae), this.toggleSlider(), document.addEventListener("theme:resize:width", this.toggleSlider)
        }
        toggleSlider() {
            if (!(this.slider.clientWidth < this.getSlidesWidth()) || !y() && window.theme.touch) this.destroy();
            else {
                if (this.isInitialized) return;
                this.slidesObserver = new te(this.slider, de), this.initArrows(), this.isInitialized = !0, this.draggableSlider = new re(this.slider)
            }
        }
        initArrows() {
            if (!this.buttons.length) {
                const t = document.createElement("div");
                t.classList.add(ge), t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next, this.append(t), this.buttons = this.querySelectorAll(ae), this.buttonPrev = this.querySelector(`[${pe}]`), this.buttonNext = this.querySelector(`[${me}]`)
            }
            this.toggleArrowsObserver(), this.hasAttribute(ve) && (this.positionArrows(), this.arrowsResizeObserver()), this.buttons.forEach((t => {
                t.addEventListener("click", this.onButtonArrowClick)
            }))
        }
        buttonArrowClickEvent(t) {
            t.preventDefault();
            const e = this.slider.querySelector(`${de}.${fe}`);
            let s = null;
            t.target.hasAttribute(pe) && (s = null == e ? void 0 : e.previousElementSibling), t.target.hasAttribute(me) && (s = null == e ? void 0 : e.nextElementSibling), this.goToSlide(s)
        }
        removeArrows() {
            var t;
            null === (t = this.querySelector(`.${ge}`)) || void 0 === t || t.remove()
        }
        goToSlide(t) {
            t && this.slider.scrollTo({
                top: 0,
                left: t.offsetLeft,
                behavior: "smooth"
            })
        }
        getSlidesWidth() {
            var t;
            return (null === (t = this.slider.querySelector(de)) || void 0 === t ? void 0 : t.clientWidth) * this.slider.querySelectorAll(de).length
        }
        toggleArrowsObserver() {
            if (this.buttonPrev && this.buttonNext) {
                const t = this.slides.length,
                    e = this.slides[0],
                    s = this.slides[t - 1],
                    i = {
                        attributes: !0,
                        childList: !1,
                        subtree: !1
                    },
                    o = t => {
                        for (const i of t)
                            if ("attributes" === i.type) {
                                const t = i.target,
                                    o = Boolean(t.classList.contains(fe));
                                t == e && (this.buttonPrev.disabled = o), t == s && (this.buttonNext.disabled = o)
                            }
                    };
                e && s && (this.firstLastSlidesObserver = new MutationObserver(o), this.firstLastSlidesObserver.observe(e, i), this.firstLastSlidesObserver.observe(s, i))
            }
        }
        positionArrows() {
            const t = this.slider.querySelector(he) || this.slider.querySelector(le) || this.slider.querySelector(ce) || this.slider;
            t && this.style.setProperty("--button-position", t.clientHeight / 2 + "px")
        }
        arrowsResizeObserver() {
            document.addEventListener("theme:resize:width", this.positionArrows)
        }
        disconnectedCallback() {
            this.destroy(), document.removeEventListener("theme:resize:width", this.toggleSlider)
        }
        destroy() {
            var t, e;
            this.isInitialized = !1, null === (t = this.draggableSlider) || void 0 === t || t.destroy(), this.draggableSlider = null, null === (e = this.slidesObserver) || void 0 === e || e.destroy(), this.slidesObserver = null, this.removeArrows(), document.removeEventListener("theme:resize:width", this.positionArrows)
        }
        constructor() {
            super(), this.isInitialized = !1, this.draggableSlider = null, this.positionArrows = this.positionArrows.bind(this), this.onButtonArrowClick = t => this.buttonArrowClickEvent(t), this.slidesObserver = null, this.firstLastSlidesObserver = null, this.isDragging = !1, this.toggleSlider = this.toggleSlider.bind(this)
        }
    }
    const be = "time",
        we = "[data-days]",
        Ee = "[data-hours]",
        Se = "[data-minutes]",
        Le = "[data-seconds]",
        ke = ".shopify-section",
        Ae = "data-expiration-behavior",
        Ce = "show-message",
        Te = "hidden",
        qe = "hide-section",
        xe = "show-message";
    let Me = class extends HTMLElement {
        connectedCallback() {
            isNaN(this.endDate) || this.endDate <= Date.now() ? this.onComplete() : this.interval = setInterval(this.update, 1e3)
        }
        disconnectedCallback() {
            this.stopTimer()
        }
        convertTime(t) {
            const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
            t -= e * this.daysInMs;
            const s = this.formatDigits(parseInt(t / this.hoursInMs, 10));
            t -= s * this.hoursInMs;
            const i = this.formatDigits(parseInt(t / this.minutesInMs, 10));
            t -= i * this.minutesInMs;
            return {
                days: e,
                hours: s,
                minutes: i,
                seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10))
            }
        }
        formatDigits(t) {
            return t < 10 && (t = "0" + t), t
        }
        render(t) {
            this.days.textContent = t.days, this.hours.textContent = t.hours, this.minutes.textContent = t.minutes, this.seconds.textContent = t.seconds
        }
        stopTimer() {
            clearInterval(this.interval)
        }
        onComplete() {
            var t, e;
            (this.render({
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            }), this.shouldHideOnComplete) && (null === (t = this.shopifySection) || void 0 === t || t.classList.add(Te));
            this.shouldShowMessage && (null === (e = this.classList) || void 0 === e || e.add(Ce))
        }
        update() {
            const t = (new Date).getTime(),
                e = this.endDate - t;
            e <= 0 && (this.stopTimer(), this.onComplete());
            const s = this.convertTime(e);
            this.render(s)
        }
        constructor() {
            super(), this.shopifySection = this.closest(ke), this.expirationBehavior = this.getAttribute(Ae), this.time = this.querySelector(be), this.days = this.querySelector(we), this.hours = this.querySelector(Ee), this.minutes = this.querySelector(Se), this.seconds = this.querySelector(Le), this.endDate = Date.parse(this.time.dateTime), this.daysInMs = 864e5, this.hoursInMs = this.daysInMs / 24, this.minutesInMs = this.hoursInMs / 60, this.secondsInMs = this.minutesInMs / 60, this.shouldHideOnComplete = this.expirationBehavior === qe, this.shouldShowMessage = this.expirationBehavior === xe, this.update = this.update.bind(this)
        }
    };
    window.requestIdleCallback = window.requestIdleCallback || function(t) {
            var e = Date.now();
            return setTimeout((function() {
                t({
                    didTimeout: !1,
                    timeRemaining: function() {
                        return Math.max(0, 50 - (Date.now() - e))
                    }
                })
            }), 1)
        }, window.cancelIdleCallback = window.cancelIdleCallback || function(t) {
            clearTimeout(t)
        }, window.theme.settings.enableAnimations && (! function() {
            const t = document.querySelectorAll(xt);
            t.length && t.forEach((t => {
                Ot.observe(t)
            }))
        }(), function() {
            const t = document.querySelectorAll(qt);
            t.length && Dt(t)
        }(), new MutationObserver(Ht).observe(document.body, Pt), document.addEventListener("shopify:section:unload", (t => {
            var e;
            const s = "#" + (null === (e = t.target.querySelector("[data-section-id]")) || void 0 === e ? void 0 : e.id),
                i = It.indexOf(s); - 1 !== i && It.splice(i, 1)
        }))), window.addEventListener("resize", v((function() {
            document.dispatchEvent(new CustomEvent("theme:resize", {
                bubbles: !0
            })), w !== g() && (document.dispatchEvent(new CustomEvent("theme:resize:width", {
                bubbles: !0
            })), w = g()), E !== f() && (document.dispatchEvent(new CustomEvent("theme:resize:height", {
                bubbles: !0
            })), E = f())
        }), 50)),
        function() {
            let t;
            window.addEventListener("scroll", (function() {
                t && window.cancelAnimationFrame(t), t = window.requestAnimationFrame((function() {
                    ! function() {
                        const t = window.scrollY;
                        t > S ? (k = !0, L = !1) : t < S ? (k = !1, L = !0) : (L = null, k = null), S = t, document.dispatchEvent(new CustomEvent("theme:scroll", {
                            detail: {
                                up: L,
                                down: k,
                                position: t
                            },
                            bubbles: !1
                        })), L && !A && document.dispatchEvent(new CustomEvent("theme:scroll:up", {
                            detail: {
                                position: t
                            },
                            bubbles: !1
                        })), k && !C && document.dispatchEvent(new CustomEvent("theme:scroll:down", {
                            detail: {
                                position: t
                            },
                            bubbles: !1
                        })), C = k, A = L
                    }()
                }))
            }), {
                passive: !0
            }), window.addEventListener("theme:scroll:lock", q), window.addEventListener("theme:scroll:unlock", x)
        }(), "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? (document.documentElement.className = document.documentElement.className.replace("no-touch", "supports-touch"), window.theme.touch = !0) : window.theme.touch = !1, d(), document.addEventListener("load", (t => {
            "img" == t.target.tagName.toLowerCase() && t.target.classList.contains(O) && (t.target.classList.remove(O), t.target.parentNode.classList.remove(O), t.target.parentNode.parentNode.classList.contains(O) && t.target.parentNode.parentNode.classList.remove(O))
        }), !0), window.addEventListener("DOMContentLoaded", (() => {
            h(), H(document), a(document), I(document), document.querySelectorAll(B).forEach((t => {
                t.complete && (t.classList.remove(O), t.parentNode.classList.remove(O), t.parentNode.parentNode.classList.contains(O) && t.parentNode.parentNode.classList.remove(O))
            })), document.body.classList.add("is-loaded"), requestIdleCallback((() => {
                Shopify.visualPreviewMode && document.documentElement.classList.add("preview-mode")
            }))
        })), document.addEventListener("shopify:section:load", (t => {
            const e = t.target;
            a(e), I(e), H(document), h()
        })), customElements.get("popout-select") || customElements.define("popout-select", At), customElements.get("quantity-counter") || customElements.define("quantity-counter", Ct), customElements.get("predictive-search") || customElements.define("predictive-search", lt), customElements.get("deferred-image") || customElements.define("deferred-image", Nt), customElements.get("deferred-media") || customElements.define("deferred-media", Kt), customElements.get("grid-slider") || customElements.define("grid-slider", ye), customElements.get("countdown-timer") || customElements.define("countdown-timer", Me);
    const Pe = (t, e = !1, s = "block") => {
        t && (e ? t.style.removeProperty("display") : t.style.display = s)
    };
    Shopify.Products = function() {
        const t = {
            howManyToShow: 4,
            howManyToStoreInMemory: 10,
            wrapperId: "recently-viewed-products",
            section: null,
            onComplete: null
        };
        let e = [],
            s = null,
            i = null;
        const o = new Date,
            n = new Date;
        n.setTime(o.getTime() + 7776e6);
        const r = {
                configuration: {
                    expires: n.toGMTString(),
                    path: "/",
                    domain: window.location.hostname,
                    sameSite: "none",
                    secure: !0
                },
                name: "shopify_recently_viewed",
                write: function(t) {
                    const e = t.join(" ");
                    document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`
                },
                read: function() {
                    let t = [],
                        e = null;
                    return -1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t => t.startsWith(this.name))) && (e = document.cookie.split("; ").find((t => t.startsWith(this.name))).split("=")[1]), null !== e && (t = e.split(" ")), t
                },
                destroy: function() {
                    document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`
                },
                remove: function(t) {
                    const e = this.read(),
                        s = e.indexOf(t); - 1 !== s && (e.splice(s, 1), this.write(e))
                }
            },
            a = (e, s, o, n) => {
                s.length && e < t.howManyToShow ? fetch(`${window.theme.routes.root}products/${s[0]}?section_id=api-product-grid-item`).then((t => t.text())).then((t => {
                    const i = 100 * e,
                        r = o.id ? `#${o.id}` : "",
                        l = document.createElement("div");
                    let c = t;
                    c = c.includes("||itemAnimationDelay||") ? c.replaceAll("||itemAnimationDelay||", i) : c, c = c.includes("||itemAnimationAnchor||") ? c.replaceAll("||itemAnimationAnchor||", r) : c, l.innerHTML = c, o.innerHTML += l.querySelector("[data-api-content]").innerHTML, s.shift(), e++, a(e, s, o, n)
                })).catch((() => {
                    r.remove(s[0]), s.shift(), a(e, s, o, n)
                })) : ((e, s) => {
                    Pe(e, !0);
                    const o = r.read().length;
                    if (Shopify.recentlyViewed && i && o && o < i && e.children.length) {
                        let t = [],
                            s = [],
                            i = 0;
                        for (const e in Shopify.recentlyViewed) {
                            i += 1;
                            const o = Shopify.recentlyViewed[e].split(" "),
                                n = parseInt(e.split("_")[1]);
                            t = [...t, ...o], (r.read().length === n || i === Object.keys(Shopify.recentlyViewed).length && !s.length) && (s = [...s, ...o])
                        }
                        for (let i = 0; i < e.children.length; i++) {
                            const o = e.children[i];
                            t.length && o.classList.remove(...t), s.length && o.classList.add(...s)
                        }
                    }
                    if (t.onComplete) try {
                        t.onComplete(e, s)
                    } catch (t) {
                        console.log(t)
                    }
                })(o, n)
            };
        return {
            showRecentlyViewed: function(o) {
                const n = o || {};
                Object.assign(t, n), e = r.read(), s = document.querySelector(`#${t.wrapperId}`), i = t.howManyToShow, t.howManyToShow = Math.min(e.length, t.howManyToShow), t.howManyToShow && s && a(0, e, s, t.section)
            },
            getConfig: function() {
                return t
            },
            clearList: function() {
                r.destroy()
            },
            recordRecentlyViewed: function(e) {
                const s = e || {};
                Object.assign(t, s);
                let i = r.read();
                if (-1 !== window.location.pathname.indexOf("/products/")) {
                    let e = decodeURIComponent(window.location.pathname).match(/\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/)[0].split("/products/")[1];
                    t.handle && (e = t.handle);
                    const s = i.indexOf(e); - 1 === s ? (i.unshift(e), i = i.splice(0, t.howManyToStoreInMemory)) : (i.splice(s, 1), i.unshift(e)), r.write(i)
                }
            },
            hasProducts: r.read().length > 0
        }
    }();
    const Ie = (t, e = [], s = !1) => {
        const i = Object.keys(t).map((i => {
            let o = t[i];
            if ("[object Object]" === Object.prototype.toString.call(o) || Array.isArray(o)) return Array.isArray(t) ? e.push("") : e.push(i), Ie(o, e, Array.isArray(o)); {
                let t = i;
                if (e.length > 0) {
                    t = (s ? e : [...e, i]).reduce(((t, e) => "" === t ? e : `${t}[${e}]`), "")
                }
                return s ? `${t}[]=${o}` : `${t}=${o}`
            }
        })).join("&");
        return e.pop(), i
    };

    function He(t) {
        this.status = t.status || null, this.headers = t.headers || null, this.json = t.json || null, this.body = t.body || null
    }
    He.prototype = Error.prototype;
    const Oe = "is-focused",
        Be = "[data-skip-content]",
        De = 'a[href="#"]';
    window.accessibility = new class {
        init() {
            this.a11y = z, this.html = document.documentElement, this.body = document.body, this.inPageLink = document.querySelector(Be), this.linkesWithOnlyHash = document.querySelectorAll(De), this.a11y.focusHash(), this.a11y.bindInPageLinks(), this.clickEvents(), this.focusEvents()
        }
        clickEvents() {
            this.inPageLink && this.inPageLink.addEventListener("click", (t => {
                t.preventDefault()
            })), this.linkesWithOnlyHash && this.linkesWithOnlyHash.forEach((t => {
                t.addEventListener("click", (t => {
                    t.preventDefault()
                }))
            }))
        }
        focusEvents() {
            document.addEventListener("mousedown", (() => {
                this.body.classList.remove(Oe)
            })), document.addEventListener("keyup", (t => {
                "Tab" === t.code && this.body.classList.add(Oe)
            }))
        }
        constructor() {
            this.init()
        }
    };
    const Fe = (t, e) => {
            let s, i;
            return function o(...n) {
                const r = Date.now();
                i = clearTimeout(i), !s || r - s >= e ? (t.apply(null, n), s = r) : i = setTimeout(o.bind(null, ...n), e - (r - s))
            }
        },
        $e = "is-animated",
        _e = "is-added",
        Ne = "is-disabled",
        Re = "is-empty",
        ze = "is-hidden",
        We = "is-hiding",
        Ue = "is-loading",
        Ve = "is-open",
        je = "is-removed",
        Xe = "is-success",
        Je = "is-visible",
        Ye = "is-expanded",
        Qe = "is-updated",
        Ge = "variant--soldout",
        Ke = "variant--unavailable",
        Ze = "[data-api-content]",
        ts = "[data-api-line-items]",
        es = "[data-api-upsell-items]",
        ss = "[data-api-cart-price]",
        is = "[data-animation]",
        os = "[data-skip-upsell-product]",
        ns = "[data-add-to-cart-bar]",
        rs = "[data-cart-error-close]",
        as = "cart-drawer",
        ls = "[data-cart-drawer-close]",
        cs = "[data-cart-empty]",
        hs = "[data-cart-errors]",
        ds = "[data-item-remove]",
        us = "[data-cart-page]",
        ps = "[data-cart-form]",
        ms = "[data-cart-acceptance-checkbox]",
        vs = "[data-cart-checkout-buttons]",
        gs = "[data-cart-checkout-button]",
        fs = "[data-cart-total]",
        ys = "[data-checkout-buttons]",
        bs = "[data-error-message]",
        ws = "[data-close-error]",
        Es = "[data-cart-errors-container]",
        Ss = "[data-form-wrapper]",
        Ls = "[data-free-shipping]",
        ks = "[data-progress-graph]",
        As = "[data-progress-bar]",
        Cs = "[data-header-wrapper]",
        Ts = "[data-item]",
        qs = "[data-items-holder]",
        xs = "[data-left-to-spend]",
        Ms = "[data-drawer]",
        Ps = "[data-section-id]",
        Is = "[data-cart-price-holder]",
        Hs = "[data-quick-add-holder]",
        Os = "[data-quick-add-modal]",
        Bs = 'input[name="updates[]"]',
        Ds = "[data-upsell-products]",
        Fs = "[data-upsell-widget]",
        $s = "[data-terms-error-message]",
        _s = "[data-collapsible-body]",
        Ns = "data-cart-total",
        Rs = "disabled",
        zs = "data-free-shipping",
        Ws = "data-free-shipping-limit",
        Us = "data-item",
        Vs = "data-item-index",
        js = "data-item-title",
        Xs = "open",
        Js = "data-quick-add-holder",
        Ys = "data-scroll-locked",
        Qs = "data-upsell-auto-open";
    let Gs = class extends HTMLElement {
        connectedCallback() {
            this.cartPage = document.querySelector(us), this.cartForm = document.querySelector(ps), this.cartDrawer = document.querySelector(as), this.cartEmpty = document.querySelector(cs), this.cartTermsCheckbox = document.querySelector(ms), this.cartCheckoutButtonWrapper = document.querySelector(vs), this.cartCheckoutButton = document.querySelector(gs), this.checkoutButotns = document.querySelector(ys), this.itemsHolder = document.querySelector(qs), this.priceHolder = document.querySelector(Is), this.items = document.querySelectorAll(Ts), this.cartTotal = document.querySelector(fs), this.freeShipping = document.querySelectorAll(Ls), this.cartErrorHolder = document.querySelector(hs), this.cartCloseErrorMessage = document.querySelector(rs), this.headerWrapper = document.querySelector(Cs), this.navDrawer = document.querySelector(Ms), this.upsellProductsHolder = document.querySelector(Ds), this.subtotal = window.theme.subtotal, this.cart = this.cartDrawer || this.cartPage, this.animateItems = this.animateItems.bind(this), this.addToCart = this.addToCart.bind(this), this.cartAddEvent = this.cartAddEvent.bind(this), this.updateProgress = this.updateProgress.bind(this), this.onCartDrawerClose = this.onCartDrawerClose.bind(this), document.addEventListener("theme:cart:add", this.cartAddEvent), document.addEventListener("theme:cart-drawer:open", this.animateItems), document.addEventListener("theme:cart-drawer:close", this.onCartDrawerClose), document.addEventListener("theme:announcement:init", this.updateProgress), this.skipUpsellProductsArray = [], this.skipUpsellProductEvent(), this.checkSkippedUpsellProductsFromStorage(), this.toggleCartUpsellWidgetVisibility(), this.circumference = 28 * Math.PI, this.freeShippingLimit = this.freeShipping.length ? 100 * Number(this.freeShipping[0].getAttribute(Ws)) * window.Shopify.currency.rate : 0, this.freeShippingMessageHandle(this.subtotal), this.updateProgress(), this.cart && (this.build = this.build.bind(this), this.updateCart = this.updateCart.bind(this), this.productAddCallback = this.productAddCallback.bind(this), this.formSubmitHandler = Fe(this.formSubmitHandler.bind(this), 50), this.cartPage && this.animateItems(), this.hasItemsInCart = this.hasItemsInCart.bind(this), this.cartCount = this.getCartItemCount(), this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this), this.totalItems = this.items.length, this.cartUpdateFailed = !1, this.cartEvents(), this.cartRemoveEvents(), this.cartUpdateEvents(), document.addEventListener("theme:product:add", this.productAddCallback), document.addEventListener("theme:product:add-error", this.productAddCallback), document.dispatchEvent(new CustomEvent("theme:cart:load", {
                bubbles: !0
            })))
        }
        disconnectedCallback() {
            document.removeEventListener("theme:cart:add", this.cartAddEvent), document.removeEventListener("theme:announcement:init", this.updateProgress), document.removeEventListener("theme:product:add", this.productAddCallback), document.removeEventListener("theme:product:add-error", this.productAddCallback), document.dispatchEvent(new CustomEvent("theme:cart:unload", {
                bubbles: !0
            })), document.documentElement.hasAttribute(Ys) && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            }))
        }
        onCartDrawerClose() {
            var t;
            this.resetAnimatedItems(), (null === (t = this.cartDrawer) || void 0 === t ? void 0 : t.classList.contains(Ve)) && this.cart.classList.remove(Qe), this.cartEmpty.classList.remove(Qe), this.cartErrorHolder.classList.remove(Ye), this.cart.querySelectorAll(is).forEach((t => {
                const e = () => {
                    t.classList.remove(We), t.removeEventListener("animationend", e)
                };
                t.classList.add(We), t.addEventListener("animationend", e)
            }))
        }
        cartUpdateEvents() {
            this.items = document.querySelectorAll(Ts), this.items.forEach((t => {
                t.addEventListener("theme:cart:update", (e => {
                    this.updateCart({
                        id: e.detail.id,
                        quantity: e.detail.quantity
                    }, t)
                }))
            }))
        }
        cartRemoveEvents() {
            document.querySelectorAll(ds).forEach((t => {
                const e = t.closest(Ts);
                t.addEventListener("click", (s => {
                    s.preventDefault(), t.classList.contains(Ne) || this.updateCart({
                        id: t.dataset.id,
                        quantity: 0
                    }, e)
                }))
            })), this.cartCloseErrorMessage && this.cartCloseErrorMessage.addEventListener("click", (t => {
                t.preventDefault(), this.cartErrorHolder.classList.remove(Ye)
            }))
        }
        cartAddEvent(t) {
            let e = "",
                s = t.detail.button;
            if (s.hasAttribute("disabled")) return;
            const i = s.closest("form");
            i.checkValidity() ? (e = new FormData(i), null !== i && i.querySelector('[type="file"]') || (t.preventDefault(), this.addToCart(e, s))) : i.reportValidity()
        }
        cartEvents() {
            this.cartTermsCheckbox && (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler), this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler), this.cartForm.removeEventListener("submit", this.formSubmitHandler), this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler), this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler), this.cartForm.addEventListener("submit", this.formSubmitHandler))
        }
        formSubmitHandler() {
            const t = document.querySelector(ms).checked,
                e = document.querySelector($s);
            if (t) e.classList.remove(Ye), this.cartCheckoutButton.removeAttribute(Rs);
            else {
                if (document.querySelector($s).length > 0) return;
                e.innerText = theme.strings.cartAcceptanceError, this.cartCheckoutButton.setAttribute(Rs, !0), e.classList.add(Ye)
            }
        }
        formErrorsEvents(t) {
            const e = t.querySelector(ws);
            null == e || e.addEventListener("click", (e => {
                e.preventDefault(), t && t.classList.remove(Je)
            }))
        }
        getCart() {
            fetch(theme.routes.cart_url + "?section_id=api-cart-items").then(this.cartErrorsHandler).then((t => t.text())).then((t => {
                const e = document.createElement("div");
                e.innerHTML = t;
                const s = e.querySelector(Ze);
                this.build(s)
            })).catch((t => console.log(t)))
        }
        addToCart(t, e) {
            this.cart && this.cart.classList.add(Ue);
            const s = null == e ? void 0 : e.closest(Hs);
            e && (e.classList.add(Ue), e.disabled = !0), s && s.classList.add(Je), fetch(theme.routes.cart_add_url, {
                method: "POST",
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    Accept: "application/javascript"
                },
                body: t
            }).then((t => t.json())).then((t => {
                if (t.status) return this.addToCartError(t, e), void(e && (e.classList.remove(Ue), e.disabled = !1));
                this.cart ? (e && (e.classList.remove(Ue), e.classList.add(_e), e.dispatchEvent(new CustomEvent("theme:product:add", {
                    detail: {
                        response: t,
                        button: e
                    },
                    bubbles: !0
                }))), this.getCart()) : window.location = theme.routes.cart_url
            })).catch((t => {
                this.addToCartError(t, e), this.enableCartButtons()
            }))
        }
        updateCart(t = {}, e = null) {
            this.cart.classList.add(Ue);
            let s = t.quantity;
            null !== e && (s ? e.classList.add(Ue) : e.classList.add(je)), this.disableCartButtons();
            const i = this.cart.querySelector(`[${Us}="${t.id}"]`) || e,
                o = (null == i ? void 0 : i.hasAttribute(Vs)) ? parseInt(i.getAttribute(Vs)) : 0,
                n = (null == i ? void 0 : i.hasAttribute(js)) ? i.getAttribute(js) : null;
            if (0 === o) return;
            const r = {
                line: o,
                quantity: s
            };
            fetch(theme.routes.cart_change_url, {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify(r)
            }).then((t => t.text())).then((t => {
                if (JSON.parse(t).errors) return this.cartUpdateFailed = !0, this.updateErrorText(n), this.toggleErrorMessage(), this.resetLineItem(e), void this.enableCartButtons();
                this.getCart()
            })).catch((t => {
                console.log(t), this.enableCartButtons()
            }))
        }
        resetLineItem(t) {
            const e = t.querySelector(Bs),
                s = e.getAttribute("value");
            e.value = s, t.classList.remove(Ue)
        }
        disableCartButtons() {
            const t = this.cart.querySelectorAll("input"),
                e = this.cart.querySelectorAll(`button, ${ds}`);
            t.length && t.forEach((t => {
                t.classList.add(Ne), t.blur(), t.disabled = !0
            })), e.length && e.forEach((t => {
                t.setAttribute(Rs, !0)
            }))
        }
        enableCartButtons() {
            const t = this.cart.querySelectorAll("input"),
                e = this.cart.querySelectorAll(`button, ${ds}`);
            t.length && t.forEach((t => {
                t.classList.remove(Ne), t.disabled = !1
            })), e.length && e.forEach((t => {
                t.removeAttribute(Rs)
            })), this.cart.classList.remove(Ue)
        }
        updateErrorText(t) {
            this.cartErrorHolder.querySelector(bs).innerText = t
        }
        toggleErrorMessage() {
            this.cartErrorHolder && (this.cartErrorHolder.classList.toggle(Ye, this.cartUpdateFailed), this.cartUpdateFailed = !1)
        }
        cartErrorsHandler(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new He({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        addToCartError(t, e) {
            var s;
            if (this.cartDrawer && this.closeCartDrawer(), null !== e) {
                const s = e.closest(Ps) || e.closest(Hs) || e.closest(Os);
                let i = null == s ? void 0 : s.querySelector(Es);
                const o = e.closest(Hs);
                o && o.querySelector(Es) && (i = o.querySelector(Es)), i && (i.innerHTML = `<div class="errors">${t.message}: ${t.description}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`, i.classList.add(Je), this.formErrorsEvents(i)), e.dispatchEvent(new CustomEvent("theme:product:add-error", {
                    detail: {
                        response: t,
                        button: e
                    },
                    bubbles: !0
                }))
            }
            const i = null == e ? void 0 : e.closest(Hs);
            i && i.dispatchEvent(new CustomEvent("theme:cart:error", {
                bubbles: !0,
                detail: {
                    message: t.message,
                    description: t.description,
                    holder: i
                }
            })), null === (s = this.cart) || void 0 === s || s.classList.remove(Ue)
        }
        productAddCallback(t) {
            let e = [],
                s = null;
            const i = "theme:product:add-error" == t.type,
                o = t.detail.button,
                n = document.querySelector(ns);
            e.push(o), s = o.closest(Hs), n && e.push(n), e.forEach((t => {
                t.classList.remove(Ue), i || t.classList.add(_e)
            })), setTimeout((() => {
                e.forEach((t => {
                    var e, s;
                    t.classList.remove(_e);
                    (null === (e = t.closest(Ss)) || void 0 === e ? void 0 : e.classList.contains(Ge)) || (null === (s = t.closest(Ss)) || void 0 === s ? void 0 : s.classList.contains(Ke)) || (t.disabled = !1)
                })), null == s || s.classList.remove(Je)
            }), 1e3)
        }
        toggleClassesOnContainers() {
            const t = this.hasItemsInCart();
            this.cart.classList.toggle(Re, !t), t || setTimeout((() => {
                _(this.cartDrawer, {
                    elementToFocus: this.cartDrawer.querySelector(ls)
                })
            }), 100)
        }
        build(t) {
            var e;
            const i = t.querySelector(ts),
                o = t.querySelector(es),
                n = Boolean(null === i && null === o),
                r = t.querySelector(ss),
                a = t.querySelector(fs);
            this.priceHolder && r && (this.priceHolder.innerHTML = r.innerHTML), n ? (this.itemsHolder.innerHTML = t.innerHTML, this.upsellProductsHolder && (this.upsellProductsHolder.innerHTML = "")) : (this.itemsHolder.innerHTML = i.innerHTML, this.upsellProductsHolder && (this.upsellProductsHolder.innerHTML = o.innerHTML), this.skipUpsellProductEvent(), this.checkSkippedUpsellProductsFromStorage(), this.toggleCartUpsellWidgetVisibility()), this.newTotalItems = i && i.querySelectorAll(Ts).length ? i.querySelectorAll(Ts).length : 0, this.subtotal = a && a.hasAttribute(Ns) ? parseInt(a.getAttribute(Ns)) : 0, this.cartCount = this.getCartItemCount(), document.dispatchEvent(new CustomEvent("theme:cart:change", {
                bubbles: !0,
                detail: {
                    cartCount: this.cartCount
                }
            })), this.cartTotal.innerHTML = 0 === this.subtotal ? window.theme.strings.free : s.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat), this.cart.classList.remove(Ue), this.totalItems !== this.newTotalItems && (this.totalItems = this.newTotalItems, this.toggleClassesOnContainers()), (null === (e = this.cartDrawer) || void 0 === e ? void 0 : e.classList.contains(Ve)) && this.cart.classList.add(Qe), this.hasItemsInCart() || this.cartEmpty.querySelectorAll(is).forEach((t => {
                t.classList.remove($e)
            })), this.freeShippingMessageHandle(this.subtotal), this.cartRemoveEvents(), this.cartUpdateEvents(), this.toggleErrorMessage(), this.enableCartButtons(), this.updateProgress(), this.animateItems(), document.dispatchEvent(new CustomEvent("theme:product:added", {
                bubbles: !0
            }))
        }
        getCartItemCount() {
            return Array.from(this.cart.querySelectorAll(Bs)).reduce(((t, e) => t + parseInt(e.value)), 0)
        }
        hasItemsInCart() {
            return this.totalItems > 0
        }
        freeShippingMessageHandle(t) {
            this.freeShipping.length && this.freeShipping.forEach((e => {
                const s = e.hasAttribute(zs) && "true" === e.getAttribute(zs) && t >= 0;
                e.classList.toggle(Xe, s && t >= this.freeShippingLimit)
            }))
        }
        updateProgress() {
            if (this.freeShipping = document.querySelectorAll(Ls), !this.freeShipping.length) return;
            const t = isNaN(this.subtotal / this.freeShippingLimit) ? 100 : this.subtotal / this.freeShippingLimit,
                e = Math.min(100 * t, 100),
                i = this.circumference - e / 100 * this.circumference / 2,
                o = s.formatMoney(this.freeShippingLimit - this.subtotal, theme.moneyFormat);
            this.freeShipping.forEach((t => {
                const s = t.querySelector(As),
                    n = t.querySelector(ks),
                    r = t.querySelector(xs);
                r && (r.innerHTML = o.replace(".00", "")), s && (s.value = e), n && n.style.setProperty("--stroke-dashoffset", `${i}`)
            }))
        }
        skipUpsellProductEvent() {
            if (null === this.upsellProductsHolder) return;
            const t = this.upsellProductsHolder.querySelectorAll(os);
            t.length && t.forEach((t => {
                t.addEventListener("click", (e => {
                    e.preventDefault();
                    const s = t.closest(Hs).getAttribute(Js);
                    this.skipUpsellProductsArray.includes(s) || this.skipUpsellProductsArray.push(s), window.sessionStorage.setItem("skip_upsell_products", this.skipUpsellProductsArray), this.removeUpsellProduct(s), this.toggleCartUpsellWidgetVisibility()
                }))
            }))
        }
        checkSkippedUpsellProductsFromStorage() {
            const t = window.sessionStorage.getItem("skip_upsell_products");
            if (!t) return;
            t.split(",").forEach((t => {
                this.skipUpsellProductsArray.includes(t) || this.skipUpsellProductsArray.push(t), this.removeUpsellProduct(t)
            }))
        }
        removeUpsellProduct(t) {
            if (!this.upsellProductsHolder) return;
            const e = this.upsellProductsHolder.querySelector(`[${Js}="${t}"]`);
            e && e.parentNode.remove()
        }
        toggleCartUpsellWidgetVisibility() {
            if (!this.upsellProductsHolder) return;
            const t = this.upsellProductsHolder.querySelectorAll(Hs),
                e = this.upsellProductsHolder.closest(Fs);
            if (e && (e.classList.toggle(ze, !t.length), t.length && !e.hasAttribute(Xs) && e.hasAttribute(Qs))) {
                e.setAttribute(Xs, !0);
                const t = e.querySelector(_s);
                t && (t.style.height = "auto")
            }
        }
        resetAnimatedItems() {
            this.cart.querySelectorAll(is).forEach((t => {
                t.classList.remove($e), t.classList.remove(We)
            }))
        }
        animateItems() {
            requestAnimationFrame((() => {
                var t;
                null === (t = this.cart) || void 0 === t || t.querySelectorAll(is).forEach((t => {
                    t.classList.add($e)
                }))
            }))
        }
        constructor() {
            super()
        }
    };
    customElements.get("cart-items") || customElements.define("cart-items", Gs);
    const Ks = "data-cart-count",
        Zs = "data-limit";
    let ti = class extends HTMLElement {
        connectedCallback() {
            document.addEventListener("theme:cart:change", this.onCartChangeCallback)
        }
        disconnectedCallback() {
            document.addEventListener("theme:cart:change", this.onCartChangeCallback)
        }
        onCartChange(t) {
            this.cartCount = t.detail.cartCount, this.update()
        }
        update() {
            if (null !== this.cartCount) {
                this.setAttribute(Ks, this.cartCount);
                let t = this.cartCount;
                this.limit && this.cartCount >= this.limit && (t = "9+"), this.innerText = t
            }
        }
        constructor() {
            super(), this.cartCount = null, this.limit = this.getAttribute(Zs), this.onCartChangeCallback = this.onCartChange.bind(this)
        }
    };

    function ei(t) {
        return new Promise((e => {
            null == t || t.addEventListener("animationend", (function s(i) {
                i.target == t && (t.removeEventListener("animationend", s), e())
            }))
        }))
    }
    customElements.get("cart-count") || customElements.define("cart-count", ti);
    const si = "is-open",
        ii = "is-closing",
        oi = {
            cartDrawerClose: "[data-cart-drawer-close]",
            cartDrawerSection: '[data-section-type="cart-drawer"]',
            cartDrawerInner: "[data-cart-drawer-inner]"
        },
        ni = "data-drawer-underlay";
    let ri = class extends HTMLElement {
        connectedCallback() {
            this.addEventListener("theme:cart-drawer:show", this.openCartDrawer), document.addEventListener("theme:cart:toggle", this.toggleCartDrawer), document.addEventListener("theme:quick-add:open", this.closeCartDrawer), document.addEventListener("theme:product:added", this.openCartDrawerOnProductAdded), document.addEventListener("shopify:block:select", this.openCartDrawerOnSelect), document.addEventListener("shopify:section:select", this.openCartDrawerOnSelect), document.addEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:product:added", this.openCartDrawerOnProductAdded), document.removeEventListener("theme:cart:toggle", this.toggleCartDrawer), document.removeEventListener("theme:quick-add:open", this.closeCartDrawer), document.removeEventListener("shopify:block:select", this.openCartDrawerOnSelect), document.removeEventListener("shopify:section:select", this.openCartDrawerOnSelect), document.removeEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect)
        }
        openCartDrawerOnProductAdded() {
            this.cartDrawerIsOpen || this.openCartDrawer()
        }
        openCartDrawerOnSelect(t) {
            (t.target.querySelector(oi.cartDrawerSection) || t.target.closest(oi.cartDrawerSection)) && this.openCartDrawer()
        }
        closeCartDrawerOnDeselect() {
            this.cartDrawerIsOpen && this.closeCartDrawer()
        }
        openCartDrawer() {
            this.cartDrawerIsOpen = !0, this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this), document.body.addEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:cart-drawer:open", {
                bubbles: !0
            })), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), this.classList.add(si), this.observeAdditionalCheckoutButtons(), ei(this.cartDrawerInner).then((() => {
                _(this, {
                    elementToFocus: this.querySelector(oi.cartDrawerClose)
                })
            }))
        }
        closeCartDrawer() {
            this.classList.contains(si) && (this.classList.add(ii), this.classList.remove(si), this.cartDrawerIsOpen = !1, document.dispatchEvent(new CustomEvent("theme:cart-drawer:close", {
                bubbles: !0
            })), N(), R(), document.body.removeEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            })), ei(this.cartDrawerInner).then((() => {
                this.classList.remove(ii)
            })))
        }
        toggleCartDrawer() {
            this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer()
        }
        closeCartEvents() {
            this.cartDrawerClose.addEventListener("click", (t => {
                t.preventDefault(), this.closeCartDrawer()
            })), this.addEventListener("keyup", (t => {
                "Escape" === t.code && this.closeCartDrawer()
            }))
        }
        onBodyClick(t) {
            t.target.hasAttribute(ni) && this.closeCartDrawer()
        }
        observeAdditionalCheckoutButtons() {
            const t = this.querySelector(oi.additionalCheckoutButtons);
            if (t) {
                const e = new MutationObserver((() => {
                    _(this, {
                        elementToFocus: this.querySelector(oi.cartDrawerClose)
                    }), e.disconnect()
                }));
                e.observe(t, {
                    subtree: !0,
                    childList: !0
                })
            }
        }
        constructor() {
            super(), this.cartDrawerIsOpen = !1, this.cartDrawerClose = this.querySelector(oi.cartDrawerClose), this.cartDrawerInner = this.querySelector(oi.cartDrawerInner), this.openCartDrawer = this.openCartDrawer.bind(this), this.closeCartDrawer = this.closeCartDrawer.bind(this), this.toggleCartDrawer = this.toggleCartDrawer.bind(this), this.openCartDrawerOnProductAdded = this.openCartDrawerOnProductAdded.bind(this), this.openCartDrawerOnSelect = this.openCartDrawerOnSelect.bind(this), this.closeCartDrawerOnDeselect = this.closeCartDrawerOnDeselect.bind(this), this.closeCartEvents()
        }
    };
    customElements.get("cart-drawer") || customElements.define("cart-drawer", ri);
    const ai = "[data-collapsible]",
        li = "[data-collapsible-trigger]",
        ci = "[data-collapsible-body]",
        hi = "[data-collapsible-content]",
        di = "open",
        ui = "single";
    let pi = class extends HTMLElement {
        connectedCallback() {
            this.collapsibles.forEach((t => {
                const e = t.querySelector(li),
                    s = t.querySelector(ci);
                e.addEventListener("click", (t => this.onCollapsibleClick(t))), s.addEventListener("transitionend", (e => {
                    e.target === s && ("true" == t.getAttribute(di) && this.setBodyHeight(s, "auto"), "false" == t.getAttribute(di) && (t.removeAttribute(di), this.setBodyHeight(s, "")))
                }))
            }))
        }
        open(t) {
            if ("true" == t.getAttribute("open")) return;
            const e = t.querySelector(ci),
                s = t.querySelector(hi);
            t.setAttribute("open", !0), this.setBodyHeight(e, s.offsetHeight)
        }
        close(t) {
            if (!t.hasAttribute("open")) return;
            const e = t.querySelector(ci),
                s = t.querySelector(hi);
            this.setBodyHeight(e, s.offsetHeight), t.setAttribute("open", !1), requestAnimationFrame((() => {
                requestAnimationFrame((() => {
                    this.setBodyHeight(e, 0)
                }))
            }))
        }
        setBodyHeight(t, e) {
            t.style.height = "auto" !== e && "" !== e ? `${e}px` : e
        }
        onCollapsibleClick(t) {
            t.preventDefault();
            const e = (t.target.matches(li) ? t.target : t.target.closest(li)).closest(ai);
            this.single && this.collapsibles.forEach((t => {
                t.hasAttribute(di) && t != e && requestAnimationFrame((() => {
                    this.close(t)
                }))
            })), e.hasAttribute(di) ? this.close(e) : this.open(e), e.dispatchEvent(new CustomEvent("theme:form:sticky", {
                bubbles: !0,
                detail: {
                    element: "accordion"
                }
            }))
        }
        constructor() {
            super(), this.collapsibles = this.querySelectorAll(ai), this.single = this.hasAttribute(ui)
        }
    };
    customElements.get("collapsible-elements") || customElements.define("collapsible-elements", pi);
    const mi = "details",
        vi = "[data-popdown]",
        gi = "[data-popdown-close]",
        fi = 'input:not([type="hidden"])',
        yi = "data-popdown-underlay",
        bi = "is-open";
    let wi = class extends HTMLElement {
        connectedCallback() {
            this.popdown.addEventListener("transitionend", this.popdownTransitionCallback), this.popdownContainer.addEventListener("keyup", (t => "ESCAPE" === t.code.toUpperCase() && this.close())), this.popdownContainer.addEventListener("toggle", this.detailsToggleCallback), this.popdownClose.addEventListener("click", this.close.bind(this))
        }
        detailsToggleCallback(t) {
            t.target.hasAttribute("open") && this.open()
        }
        popdownTransitionCallback(t) {
            t.target === this.popdown && (this.classList.contains(bi) ? "transform" === t.propertyName && this.a11y.trapFocus(this.popdown, {
                elementToFocus: this.popdown.querySelector(fi)
            }) : (this.popdownContainer.removeAttribute("open"), this.a11y.removeTrapFocus()))
        }
        onBodyClick(t) {
            this.contains(t.target) && !t.target.hasAttribute(yi) || this.close()
        }
        open() {
            this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this), document.body.addEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), requestAnimationFrame((() => {
                this.classList.add(bi)
            }))
        }
        close() {
            this.classList.remove(bi), document.body.removeEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            }))
        }
        constructor() {
            super(), this.popdown = this.querySelector(vi), this.popdownContainer = this.querySelector(mi), this.popdownClose = this.querySelector(gi), this.popdownTransitionCallback = this.popdownTransitionCallback.bind(this), this.detailsToggleCallback = this.detailsToggleCallback.bind(this), this.a11y = z
        }
    };
    customElements.define("header-search-popdown", wi);
    const Ei = 'input[type="search"]';
    customElements.define("main-search", class extends X {
        setupEventListeners() {
            let t = [];
            this.allSearchInputs.forEach((e => t.push(e.form))), this.input.addEventListener("focus", this.onInputFocus.bind(this)), t.length < 2 || (t.forEach((t => t.addEventListener("reset", this.onFormReset.bind(this)))), this.allSearchInputs.forEach((t => t.addEventListener("input", this.onInput.bind(this)))))
        }
        onFormReset(t) {
            super.onFormReset(t), super.shouldResetForm() && this.keepInSync("", this.input)
        }
        onInput(t) {
            const e = t.target;
            this.keepInSync(e.value, e)
        }
        onInputFocus() {
            y() || this.scrollIntoView({
                behavior: "smooth"
            })
        }
        keepInSync(t, e) {
            this.allSearchInputs.forEach((s => {
                s !== e && (s.value = t)
            }))
        }
        constructor() {
            super(), this.allSearchInputs = document.querySelectorAll(Ei), this.setupEventListeners()
        }
    });
    const Si = "[data-template-no-shipping]",
        Li = ".get-rates",
        ki = "#address_container",
        Ai = "#address_country",
        Ci = "#address_province",
        Ti = "#address_zip",
        qi = "#wrapper-response",
        xi = "#shipping-calculator-response-template",
        Mi = "data-template-no-shipping",
        Pi = "data-default",
        Ii = "is-hidden",
        Hi = "error",
        Oi = "center",
        Bi = "success",
        Di = "disabled",
        Fi = "get-rates--trigger",
        $i = "Error : country is not supported.",
        _i = "We do not ship to this destination.",
        Ni = "Error : ";
    let Ri = class extends HTMLElement {
        connectedCallback() {
            const t = document.querySelector("html");
            let s = "en";
            if (t.hasAttribute("lang") && "" !== t.getAttribute("lang") && (s = t.getAttribute("lang")), this.fieldsContainer && e.AddressForm(this.fieldsContainer, s, {
                    shippingCountriesOnly: !0
                }), this.selectCountry && this.selectCountry.hasAttribute(Pi) && this.selectProvince && this.selectProvince.hasAttribute(Pi) && this.selectCountry.addEventListener("change", this.onCountryChangeEvent), this.getRatesButton && (this.getRatesButton.addEventListener("click", this.onButtonClickEvent), theme.settings.customerLoggedIn && this.getRatesButton.classList.contains(Fi))) {
                const t = document.querySelector(Ti);
                t && t.value && this.getRatesButton.dispatchEvent(new Event("click"))
            }
        }
        disconnectedCallback() {
            this.selectCountry && this.selectCountry.hasAttribute(Pi) && this.selectProvince && this.selectProvince.hasAttribute(Pi) && this.selectCountry.removeEventListener("change", this.onCountryChangeEvent), this.getRatesButton && this.getRatesButton.removeEventListener("click", this.onButtonClickEvent)
        }
        onCountryChange() {
            this.selectCountry.removeAttribute(Pi), this.selectProvince.removeAttribute(Pi)
        }
        onButtonClick() {
            for (this.disableButtons(); this.wrapper.firstChild;) this.wrapper.removeChild(this.wrapper.firstChild);
            this.wrapper.classList.add(Ii);
            const t = {};
            let e = this.selectCountry.value,
                s = this.selectProvince.value;
            const i = this.selectCountry.getAttribute(Pi);
            "" === e && i && "" !== i && (e = i);
            const o = this.selectProvince.getAttribute(Pi);
            "" === s && o && "" !== o && (s = o), t.zip = document.querySelector(Ti).value || "", t.country = e || "", t.province = s || "", this.getCartShippingRatesForDestination(t)
        }
        formatRate(t) {
            return "0.00" === t ? window.theme.strings.free : s.formatMoney(t, theme.moneyFormat)
        }
        render(t) {
            if (this.template && this.wrapper) {
                this.wrapper.innerHTML = "";
                let e = "",
                    s = "",
                    i = `${Hi} ${Oi}`,
                    o = this.template.innerHTML;
                const n = /[^[\]]+(?=])/g;
                if (t.rates && t.rates.length) {
                    let s = n.exec(o)[0];
                    t.rates.forEach((t => {
                        let i = s;
                        i = i.replace(/\|\|rateName\|\|/, t.name), i = i.replace(/\|\|ratePrice\|\|/, this.formatRate(t.price)), e += i
                    }))
                }
                if (t.success) {
                    i = `${Bi} ${Oi}`;
                    const e = document.createElement("div");
                    e.innerHTML = this.template.innerHTML;
                    const o = e.querySelector(Si);
                    t.rates.length < 1 && o && (s = o.getAttribute(Mi))
                } else s = t.errorFeedback;
                o = o.replace(n, "").replace("[]", ""), o = o.replace(/\|\|ratesList\|\|/g, e), o = o.replace(/\|\|successClass\|\|/g, i), o = o.replace(/\|\|ratesText\|\|/g, s), this.wrapper.innerHTML += o, this.wrapper.classList.remove(Ii)
            }
        }
        enableButtons() {
            this.getRatesButton.removeAttribute("disabled"), this.getRatesButton.classList.remove(Di), this.getRatesButton.textContent = theme.strings.shippingCalcSubmitButton
        }
        disableButtons() {
            this.getRatesButton.setAttribute("disabled", "disabled"), this.getRatesButton.classList.add(Di), this.getRatesButton.textContent = theme.strings.shippingCalcSubmitButtonDisabled
        }
        getCartShippingRatesForDestination(t) {
            const e = encodeURI(Ie({
                    shipping_address: t
                })),
                s = `${theme.routes.cart_url}/shipping_rates.json?${e}`;
            fetch(s).then(this.handleErrors).then((t => t.text())).then((e => {
                const s = JSON.parse(e).shipping_rates;
                this.onCartShippingRatesUpdate(s, t)
            })).catch((t => {
                this.onError(t.json)
            }))
        }
        fullMessagesFromErrors(t) {
            const e = [];
            for (const s in t)
                for (const i of t[s]) e.push(i);
            return e
        }
        handleErrors(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new He({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        onError(t) {
            this.enableButtons();
            let e = "";
            e = t.message ? t.message + "(" + t.status + "): " + t.description : Ni + this.fullMessagesFromErrors(t).join("; "), e === $i && (e = _i), this.render({
                rates: [],
                errorFeedback: e,
                success: !1
            })
        }
        onCartShippingRatesUpdate(t, e) {
            this.enableButtons();
            let s = "";
            e.zip && (s += e.zip + ", "), e.province && (s += e.province + ", "), s += e.country, this.render({
                rates: t,
                address: s,
                success: !0
            })
        }
        constructor() {
            super(), this.getRatesButton = this.querySelector(Li), this.fieldsContainer = this.querySelector(ki), this.selectCountry = this.querySelector(Ai), this.selectProvince = this.querySelector(Ci), this.template = this.querySelector(xi), this.wrapper = this.querySelector(qi), this.onCountryChangeEvent = () => this.onCountryChange(), this.onButtonClickEvent = () => this.onButtonClick()
        }
    };
    customElements.get("shipping-calculator") || customElements.define("shipping-calculator", Ri);
    const zi = "[data-actions]",
        Wi = "[data-content]",
        Ui = "[data-button]",
        Vi = "data-height",
        ji = "is-open",
        Xi = "is-enabled";
    let Ji = class extends HTMLElement {
        connectedCallback() {
            this.setHeight(this.initialHeight), this.trigger.addEventListener("click", (() => {
                this.setHeight(this.content.offsetHeight), this.classList.add(ji)
            })), this.setHeight(this.initialHeight), this.toggleActions(), document.addEventListener("theme:resize", this.toggleActions)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize", this.toggleActions)
        }
        setHeight(t) {
            this.style.setProperty("--height", `${t}px`)
        }
        toggleActions() {
            this.classList.toggle(Xi, this.content.offsetHeight + this.actions.offsetHeight > this.initialHeight)
        }
        constructor() {
            super(), this.initialHeight = this.getAttribute(Vi), this.content = this.querySelector(Wi), this.trigger = this.querySelector(Ui), this.actions = this.querySelector(zi), this.toggleActions = this.toggleActions.bind(this)
        }
    };
    customElements.get("toggle-ellipsis") || customElements.define("toggle-ellipsis", Ji);
    const Yi = ".template-addresses",
        Qi = "#AddressNewForm",
        Gi = ".address-new-toggle",
        Ki = ".address-edit-toggle",
        Zi = ".address-delete",
        to = "data-form-id",
        eo = "data-confirm-message",
        so = "#EditAddress",
        io = "AddressCountryNew",
        oo = "AddressProvinceNew",
        no = "AddressProvinceContainerNew",
        ro = ".address-country-option",
        ao = "AddressCountry",
        lo = "AddressProvince",
        co = "AddressProvinceContainer",
        ho = "hidden";
    const uo = document.querySelector(Yi);
    uo && new class {
        init() {
            if (this.addressNewForm) {
                const t = this.section,
                    e = this.addressNewForm;
                this.customerAddresses();
                const s = t.querySelectorAll(Gi);
                s.length && s.forEach((t => {
                    t.addEventListener("click", (function() {
                        e.classList.toggle(ho)
                    }))
                }));
                const i = t.querySelectorAll(Ki);
                i.length && i.forEach((e => {
                    e.addEventListener("click", (function() {
                        const e = this.getAttribute(to);
                        t.querySelector(`${so}_${e}`).classList.toggle(ho)
                    }))
                }));
                const o = t.querySelectorAll(Zi);
                o.length && o.forEach((t => {
                    t.addEventListener("click", (function() {
                        const t = this.getAttribute(to),
                            e = this.getAttribute(eo);
                        confirm(e) && Shopify.postLink(window.theme.routes.addresses_url + "/" + t, {
                            parameters: {
                                _method: "delete"
                            }
                        })
                    }))
                }))
            }
        }
        customerAddresses() {
            Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(io, oo, {
                hideElement: no
            }), this.section.querySelectorAll(ro).forEach((t => {
                const e = t.getAttribute(to),
                    s = `${ao}_${e}`,
                    i = `${lo}_${e}`,
                    o = `${co}_${e}`;
                new Shopify.CountryProvinceSelector(s, i, {
                    hideElement: o
                })
            }))
        }
        constructor(t) {
            this.section = t, this.addressNewForm = this.section.querySelector(Qi), this.init()
        }
    }(uo);
    const po = ".customer-logged-in",
        mo = ".account",
        vo = ".account-sidebar--mobile";
    const go = document.querySelector(po);
    go && new class {
        init() {
            this.section.querySelector(mo) && this.accountMobileSidebar()
        }
        accountMobileSidebar() {
            this.section.querySelector(vo) && this.section.querySelector(vo).addEventListener("click", (function() {
                const t = this.nextElementSibling;
                t && "UL" === t.tagName && t.classList.toggle("visible")
            }))
        }
        constructor(t) {
            this.section = t, this.init()
        }
    }(go);
    const fo = "[data-account-form]",
        yo = "[data-show-reset]",
        bo = "[data-hide-reset]",
        wo = "[data-recover-password]",
        Eo = "[data-recover-success]",
        So = "[data-login-form]",
        Lo = "#recover",
        ko = "is-hidden";
    const Ao = document.querySelector(fo);
    Ao && new class {
        init() {
            window.location.hash == Lo || this.recoverSuccess ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm(), this.showButton.addEventListener("click", function(t) {
                t.preventDefault(), this.showRecoverPasswordForm()
            }.bind(this), !1), this.hideButton.addEventListener("click", function(t) {
                t.preventDefault(), this.hideRecoverPasswordForm()
            }.bind(this), !1)
        }
        showRecoverPasswordForm() {
            return this.login.classList.add(ko), this.recover.classList.remove(ko), window.location.hash = Lo, !1
        }
        hideRecoverPasswordForm() {
            return this.recover.classList.add(ko), this.login.classList.remove(ko), window.location.hash = "", !1
        }
        constructor(t) {
            this.form = t, this.showButton = t.querySelector(yo), this.hideButton = t.querySelector(bo), this.recover = t.querySelector(wo), this.recoverSuccess = t.querySelector(Eo), this.login = t.querySelector(So), this.init()
        }
    }(Ao), window.Shopify = window.Shopify || {}, window.Shopify.theme = window.Shopify.theme || {}, window.Shopify.theme.sections = window.Shopify.theme.sections || {}, window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}, window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
    const Co = window.Shopify.theme.sections.registered,
        To = window.Shopify.theme.sections.instances,
        qo = "data-section-id",
        xo = "data-section-type";
    let Mo = class {
        callFunctions(t, e = null) {
            this.callStack[t].forEach((t => {
                const s = {
                    id: this.id,
                    type: this.type,
                    container: this.container
                };
                e ? t.call(s, e) : t.call(s)
            }))
        }
        onLoad() {
            this.callFunctions("onLoad")
        }
        onUnload() {
            this.callFunctions("onUnload")
        }
        onSelect(t) {
            this.callFunctions("onSelect", t)
        }
        onDeselect(t) {
            this.callFunctions("onDeselect", t)
        }
        onBlockSelect(t) {
            this.callFunctions("onBlockSelect", t)
        }
        onBlockDeselect(t) {
            this.callFunctions("onBlockDeselect", t)
        }
        onReorder(t) {
            this.callFunctions("onReorder", t)
        }
        constructor(t, e) {
            this.container = function(t) {
                if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                if (null === t.getAttribute(qo)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + qo + " attribute.");
                return t
            }(t), this.id = t.getAttribute(qo), this.type = e.type, this.callStack = e.getStack();
            try {
                this.onLoad()
            } catch (t) {
                console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t)
            }
        }
    };

    function Po(t, e) {
        if ("string" != typeof t) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== Co[t]) throw new Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        const s = new class {
            getStack() {
                return this.callStack
            }
            constructor(t = null, e = []) {
                this.type = t, this.components = function(t) {
                    if (void 0 !== t && "object" != typeof t || null === t) throw new TypeError("Theme Sections: The components object provided is not a valid");
                    return t
                }(e), this.callStack = {
                    onLoad: [],
                    onUnload: [],
                    onSelect: [],
                    onDeselect: [],
                    onBlockSelect: [],
                    onBlockDeselect: [],
                    onReorder: []
                }, e.forEach((t => {
                    for (const [e, s] of Object.entries(t)) {
                        const t = this.callStack[e];
                        Array.isArray(t) && "function" == typeof s ? t.push(s) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(s))
                    }
                }))
            }
        }(t, e);
        return Co[t] = s, Co
    }

    function Io(t, e) {
        t = Bo(t), void 0 === e && (e = document.querySelectorAll("[" + xo + "]")), e = Do(e), t.forEach((function(t) {
            const s = Co[t];
            void 0 !== s && (e = e.filter((function(e) {
                return !(Ho(e).length > 0) && (null !== e.getAttribute(xo) && (e.getAttribute(xo) !== t || (To.push(new Mo(e, s)), !1)))
            })))
        }))
    }

    function Ho(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var s = t[0];
        if (t instanceof Element || s instanceof Element) Do(t).forEach((function(t) {
            e = e.concat(To.filter((function(e) {
                return e.container === t
            })))
        }));
        else if ("string" == typeof t || "string" == typeof s) {
            Bo(t).forEach((function(t) {
                e = e.concat(To.filter((function(e) {
                    return e.type === t
                })))
            }))
        }
        return e
    }

    function Oo(t) {
        for (var e, s = 0; s < To.length; s++)
            if (To[s].id === t) {
                e = To[s];
                break
            }
        return e
    }

    function Bo(t) {
        return "*" === t ? t = Object.keys(Co) : "string" == typeof t ? t = [t] : t.constructor === Mo ? t = [t.prototype.type] : Array.isArray(t) && t[0].constructor === Mo && (t = t.map((function(t) {
            return t.type
        }))), t = t.map((function(t) {
            return t.toLowerCase()
        }))
    }

    function Do(t) {
        return NodeList.prototype.isPrototypeOf(t) && t.length > 0 ? t = Array.prototype.slice.call(t) : NodeList.prototype.isPrototypeOf(t) && 0 === t.length || null === t ? t = [] : !Array.isArray(t) && t instanceof Element && (t = [t]), t
    }
    window.Shopify.designMode && (document.addEventListener("shopify:section:load", (function(t) {
        var e = t.detail.sectionId,
            s = t.target.querySelector("[" + qo + '="' + e + '"]');
        null !== s && Io(s.getAttribute(xo), s)
    })), document.addEventListener("shopify:section:reorder", (function(t) {
        var e = t.detail.sectionId,
            s = t.target.querySelector("[" + qo + '="' + e + '"]');
        "object" == typeof Ho(s)[0] && Ho(s).forEach((function(t) {
            t.onReorder()
        }))
    })), document.addEventListener("shopify:section:unload", (function(t) {
        var e = t.detail.sectionId,
            s = t.target.querySelector("[" + qo + '="' + e + '"]');
        "object" == typeof Ho(s)[0] && Ho(s).forEach((function(t) {
            var e = To.map((function(t) {
                return t.id
            })).indexOf(t.id);
            To.splice(e, 1), t.onUnload()
        }))
    })), document.addEventListener("shopify:section:select", (function(t) {
        var e = Oo(t.detail.sectionId);
        "object" == typeof e && e.onSelect(t)
    })), document.addEventListener("shopify:section:deselect", (function(t) {
        var e = Oo(t.detail.sectionId);
        "object" == typeof e && e.onDeselect(t)
    })), document.addEventListener("shopify:block:select", (function(t) {
        var e = Oo(t.detail.sectionId);
        "object" == typeof e && e.onBlockSelect(t)
    })), document.addEventListener("shopify:block:deselect", (function(t) {
        var e = Oo(t.detail.sectionId);
        "object" == typeof e && e.onBlockDeselect(t)
    })));
    const Fo = "data-tooltip",
        $o = "data-tooltip-stop-mouseenter",
        _o = "tooltip-default",
        No = "is-visible",
        Ro = "is-hiding";
    let zo = {},
        Wo = class {
            init() {
                if (!document.querySelector(`.${this.class}`)) {
                    const t = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
                        e = document.createElement("div");
                    e.className = this.class, e.innerHTML = t, document.body.appendChild(e)
                }
                this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent), this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent), this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent), document.addEventListener("theme:tooltip:close", this.removePinEvent)
            }
            addPin(t = !1) {
                const e = document.querySelector(`.${this.class}`);
                if (this.label && e && (t && !this.tooltip.hasAttribute($o) || !t)) {
                    const t = e.querySelector(`.${this.class}__arrow`),
                        s = e.querySelector(`.${this.class}__inner`);
                    e.querySelector(`.${this.class}__text`).textContent = this.label;
                    const i = s.offsetWidth,
                        o = this.tooltip.getBoundingClientRect(),
                        n = o.top,
                        r = o.width,
                        a = n + o.height + window.scrollY;
                    let l = o.left - i / 2 + r / 2;
                    const c = l + i - g();
                    c > 0 && (l -= c), l < 0 && (l = 0), t.style.left = `${o.left+r/2}px`, e.style.setProperty("--tooltip-top", `${a}px`), s.style.transform = `translateX(${l}px)`, e.classList.remove(Ro), e.classList.add(No), document.addEventListener("theme:scroll", this.removePinEvent)
                }
            }
            removePin(t, e = !1, s = !1) {
                const i = document.querySelector(`.${this.class}`),
                    o = i.classList.contains(No);
                i && (e && !this.tooltip.hasAttribute($o) || !e) && (o && (s || t.detail.hideTransition) && (i.classList.add(Ro), this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout), this.hideTransitionTimeout = setTimeout((() => {
                    i.classList.remove(Ro)
                }), this.transitionSpeed)), i.classList.remove(No), document.removeEventListener("theme:scroll", this.removePinEvent))
            }
            unload() {
                this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent), this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent), this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent), document.removeEventListener("theme:tooltip:close", this.removePinEvent), document.removeEventListener("theme:scroll", this.removePinEvent)
            }
            constructor(t, e = {}) {
                this.tooltip = t, this.tooltip.hasAttribute(Fo) && (this.label = this.tooltip.getAttribute(Fo), this.class = e.class || _o, this.transitionSpeed = e.transitionSpeed || 200, this.hideTransitionTimeout = 0, this.addPinEvent = () => this.addPin(), this.addPinMouseEvent = () => this.addPin(!0), this.removePinEvent = t => Fe(this.removePin(t), 50), this.removePinMouseEvent = t => this.removePin(t, !0, !0), this.init())
            }
        };
    const Uo = {
        onLoad() {
            zo[this.id] = [];
            this.container.querySelectorAll(`[${Fo}]`).forEach((t => {
                zo[this.id].push(new Wo(t))
            }))
        },
        onUnload: function() {
            zo[this.id].forEach((t => {
                "function" == typeof t.unload && t.unload()
            }))
        }
    };
    var Vo = {};
    const jo = {
        onLoad() {
            Vo[this.id] = [];
            this.container.querySelectorAll("[data-parallax-wrapper]").forEach((t => {
                const e = t.querySelector("[data-parallax-img]");
                Vo[this.id].push(new i(e, {
                    center: !0,
                    round: !0,
                    frame: t
                }))
            })), window.addEventListener("load", (() => {
                Vo[this.id].forEach((t => {
                    "function" == typeof t.refresh && t.refresh()
                }))
            }))
        },
        onUnload: function() {
            Vo[this.id].forEach((t => {
                "function" == typeof t.destroy && t.destroy()
            }))
        }
    };
    Po("article", [Uo, jo]);
    const Xo = "[data-aos]",
        Jo = ".collection-item__image",
        Yo = "[data-column-image]",
        Qo = ".flickity-button.next",
        Go = ".flickity-button.previous",
        Ko = "a:not(.btn)",
        Zo = ".product-item__image",
        tn = "[data-slide]",
        en = "data-slide",
        sn = "[data-slider]",
        on = "[data-slider-thumb]",
        nn = {
            arrowPositionMiddle: "data-arrow-position-middle",
            slideIndex: "data-slide-index",
            sliderOptions: "data-options",
            slideTextColor: "data-slide-text-color"
        },
        rn = "aos-animate",
        an = "desktop",
        ln = "is-focused",
        cn = "flickity-enabled",
        hn = "is-initialized",
        dn = "is-loading",
        un = "is-selected",
        pn = "mobile",
        mn = "single-slide",
        vn = "js-slider--initialized",
        gn = {};
    let fn = class {
        init() {
            this.slideshow.classList.add(dn);
            let t = tn;
            const e = y(),
                s = `${tn}:not(.${pn})`,
                i = `${tn}:not(.${an})`;
            (this.slideshow.querySelectorAll(i).length || this.slideshow.querySelectorAll(s).length) && (t = e ? s : i), this.slideshow.querySelectorAll(t).length <= 1 && (this.slideshow.classList.add(mn), this.slideshow.classList.remove(dn)), this.sliderOptions = {
                cellSelector: t,
                contain: !0,
                wrapAround: !0,
                adaptiveHeight: !0,
                ...this.customOptions,
                on: {
                    ready: () => {
                        requestAnimationFrame((() => {
                            this.slideshow.classList.add(hn), this.slideshow.classList.remove(dn), this.slideshow.parentNode.dispatchEvent(new CustomEvent("theme:slider:loaded", {
                                bubbles: !0,
                                detail: {
                                    slider: this
                                }
                            }))
                        })), this.slideActions(), this.sliderOptions.prevNextButtons && this.positionArrows()
                    },
                    change: t => {
                        const e = this.slideshowSlides[t];
                        if (!e || this.sliderOptions.groupCells) return;
                        const s = e.querySelectorAll(Xo);
                        s.length && s.forEach((t => {
                            t.classList.remove(rn), requestAnimationFrame((() => {
                                setTimeout((() => {
                                    t.classList.add(rn)
                                }), 0)
                            }))
                        }))
                    },
                    resize: () => {
                        this.sliderOptions.prevNextButtons && this.positionArrows()
                    }
                }
            }, this.sliderOptions.fade && (this.flkty = new n(this.slideshow, this.sliderOptions)), this.sliderOptions.fade || (this.flkty = new o(this.slideshow, this.sliderOptions)), this.flkty.on("change", (() => this.slideActions(!0))), this.sliderThumbs.length && this.sliderThumbs.forEach((t => {
                t.addEventListener("click", (e => {
                    e.preventDefault();
                    const s = [...t.parentElement.children].indexOf(t);
                    this.flkty.select(s)
                }))
            })), this.flkty && this.flkty.isActive || this.slideshow.classList.remove(dn)
        }
        slideActions(t = !1) {
            const e = this.slideshow.querySelector(`.${un}`),
                s = e.getAttribute(nn.slideTextColor),
                i = e.querySelector(Ko),
                o = this.slideshow.querySelectorAll(`${tn} a, ${tn} button`);
            if (document.body.classList.contains(ln) && i && this.sliderOptions.groupCells && t && i.focus(), o.length && o.forEach((t => {
                    const e = t.closest(tn);
                    if (e) {
                        const s = e.classList.contains(un) ? 0 : -1;
                        t.setAttribute("tabindex", s)
                    }
                })), "rgba(0,0,0,0)" !== s && "" !== s && this.slideshow.style.setProperty("--text", s), this.sliderThumbs.length && this.sliderThumbs.length === this.slideshowSlides.length && e.hasAttribute(nn.slideIndex)) {
                const t = parseInt(e.getAttribute(nn.slideIndex)),
                    s = this.container.querySelector(`${on}.${un}`);
                s && s.classList.remove(un), this.sliderThumbs[t].classList.add(un)
            }
        }
        positionArrows() {
            if (this.slideshow.hasAttribute(nn.arrowPositionMiddle) && this.sliderOptions.prevNextButtons) {
                const t = this.slideshow.querySelector(Jo) || this.slideshow.querySelector(Zo) || this.slideshow.querySelector(Yo);
                if (!t) return;
                this.slideshow.querySelector(Go).style.top = t.clientHeight / 2 + "px", this.slideshow.querySelector(Qo).style.top = t.clientHeight / 2 + "px"
            }
        }
        onUnload() {
            this.slideshow && this.flkty && (this.flkty.options.watchCSS = !1, this.flkty.destroy())
        }
        onBlockSelect(t) {
            if (!this.slideshow) return;
            const e = this.slideshow.querySelector(`[${en}="${t.detail.blockId}"]`);
            if (!e) return;
            let s = parseInt(e.getAttribute(nn.slideIndex));
            this.multipleSlides && !this.slideshow.classList.contains(vn) && (s = 0), this.slideshow.classList.add(un), this.flkty && this.slideshow.classList.contains(cn) && (this.flkty.selectCell(s), this.flkty.stopPlayer())
        }
        onBlockDeselect() {
            this.slideshow && (this.slideshow.classList.remove(un), this.flkty && this.sliderOptions.hasOwnProperty("autoPlay") && this.sliderOptions.autoPlay && this.flkty.playPlayer())
        }
        constructor(t, e = null) {
            this.container = t, this.slideshow = e || this.container.querySelector(sn), this.slideshow && (this.slideshowSlides = this.slideshow.querySelectorAll(tn), this.slideshowSlides.length <= 1 || (this.sliderThumbs = this.container.querySelectorAll(on), this.multipleSlides = this.slideshow.hasAttribute(nn.slidesLargeDesktop), this.slideshow.hasAttribute(nn.sliderOptions) && (this.customOptions = JSON.parse(decodeURIComponent(this.slideshow.getAttribute(nn.sliderOptions)))), this.flkty = null, this.init()))
        }
    };
    const yn = {
        onLoad() {
            gn[this.id] = [];
            this.container.querySelectorAll(sn).forEach((t => {
                gn[this.id].push(new fn(this.container, t))
            }))
        },
        onUnload() {
            gn[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        },
        onBlockSelect(t) {
            gn[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        },
        onBlockDeselect(t) {
            gn[this.id].forEach((e => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
            }))
        }
    };
    Po("blog-section", [yn]), Po("hero", jo), Po("double", yn);
    const bn = t => {
        let {
            stickyHeaderHeight: e
        } = c();
        window.scrollTo({
            top: t + window.scrollY - e,
            left: 0,
            behavior: "smooth"
        })
    };
    let wn = class {
        write() {
            (-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((t => t.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) && (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`)
        }
        read() {
            if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t => t.startsWith(this.name)))) {
                return document.cookie.split("; ").find((t => t.startsWith(this.name))).split("=")[1]
            }
            return !1
        }
        destroy() {
            document.cookie.split("; ").find((t => t.startsWith(this.name))) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`)
        }
        constructor(t, e, s = 7) {
            const i = new Date,
                o = new Date;
            o.setTime(i.getTime() + 864e5 * s), this.configuration = {
                expires: o.toGMTString(),
                path: "/",
                domain: window.location.hostname,
                sameSite: "none",
                secure: !0
            }, this.name = t, this.value = e
        }
    };
    const En = "[data-newsletter-form]",
        Sn = "[data-newsletter-heading]",
        Ln = "[data-newsletter]",
        kn = "has-success",
        An = "has-error",
        Cn = "hidden",
        Tn = "data-cookie-name",
        qn = {};
    const xn = {
        onLoad() {
            qn[this.id] = [];
            this.container.querySelectorAll(En).forEach((t => {
                qn[this.id].push(new class {
                    init() {
                        this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage()
                    }
                    newsletterSubmitEvent(t) {
                        this.stopSubmit && (t.preventDefault(), t.stopImmediatePropagation(), this.removeStorage(), this.writeStorage(), this.stopSubmit = !1, this.newsletter.submit())
                    }
                    checkForChallengePage() {
                        this.isChallengePage = "/challenge" === window.location.pathname
                    }
                    writeStorage() {
                        void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id)
                    }
                    readStorage() {
                        this.formID = this.sessionStorage.getItem("newsletter_form_id")
                    }
                    removeStorage() {
                        this.sessionStorage.removeItem("newsletter_form_id")
                    }
                    showMessage() {
                        if (this.readStorage(), this.newsletter.id === this.formID) {
                            const t = document.getElementById(this.formID),
                                e = t.parentElement.querySelector(Sn),
                                s = -1 !== window.location.search.indexOf("?customer_posted=true"),
                                i = -1 !== window.location.search.indexOf("accepts_marketing");
                            s ? (t.classList.remove(An), t.classList.add(kn), e && (e.classList.add(Cn), t.classList.remove(Cn)), this.popup && this.cookie.write()) : i && (t.classList.remove(kn), t.classList.add(An), e && (e.classList.add(Cn), t.classList.remove(Cn))), (s || i) && window.addEventListener("load", (() => {
                                this.scrollToForm(t)
                            }))
                        }
                    }
                    scrollToForm(t) {
                        const e = t.getBoundingClientRect();
                        e.top >= 0 && e.left >= 0 && e.bottom <= f() && e.right <= g() || setTimeout((() => {
                            bn(t.getBoundingClientRect().top)
                        }), 500)
                    }
                    unload() {
                        this.newsletter.removeEventListener("submit", this.newsletterSubmit)
                    }
                    constructor(t) {
                        this.sessionStorage = window.sessionStorage, this.newsletter = t, this.popup = this.newsletter.closest(Ln), this.popup && (this.cookie = new wn(this.popup.getAttribute(Tn), "user_has_closed", null)), this.stopSubmit = !0, this.isChallengePage = !1, this.formID = null, this.checkForChallengePage(), this.newsletterSubmit = t => this.newsletterSubmitEvent(t), this.isChallengePage || this.init()
                    }
                }(t))
            }))
        },
        onUnload() {
            qn[this.id].forEach((t => {
                "function" == typeof t.unload && t.unload()
            }))
        }
    };
    Po("footer", [jo, xn]);
    const Mn = "[data-section-type]",
        Pn = "[data-collection-sidebar]",
        In = "[data-collection-sidebar-slide-out]",
        Hn = "[data-collection-sidebar-close]",
        On = "[data-collection-filters-form]",
        Bn = "input",
        Dn = "select",
        Fn = "label",
        $n = "textarea",
        _n = "[data-field-price-min]",
        Nn = "[data-field-price-max]",
        Rn = "data-field-price-min",
        zn = "data-field-price-max",
        Wn = "[data-se-min-value]",
        Un = "[data-se-max-value]",
        Vn = "data-se-min-value",
        jn = "data-se-max-value",
        Xn = "data-se-min",
        Jn = "data-se-max",
        Yn = "[data-show-more]",
        Qn = "[data-link-hidden]",
        Gn = "[data-collection-nav]",
        Kn = "[data-products-grid]",
        Zn = "[data-active-filters]",
        tr = "data-active-filters-count",
        er = "[data-filter-update-url]",
        sr = "[data-sort-enabled]",
        ir = "[data-sort-link]",
        or = "data-value",
        nr = "[data-popout-toggle]",
        rr = "[data-sort-button-text]",
        ar = "[data-results-count]",
        lr = "hidden",
        cr = "is-focused",
        hr = "is-loading",
        dr = "is-active";
    let ur = class extends HTMLElement {
        connectedCallback() {
            this.sort && this.sortLinks.length && this.sortLinks.forEach((t => {
                t.addEventListener("click", this.onSortButtonClickEvent)
            })), this.collectionSidebar && this.form && (this.collectionSidebar.addEventListener("input", this.updatePriceEvent), this.collectionSidebar.addEventListener("theme:range:update", this.updateRangeEvent)), this.showMoreOptions.length && this.showMoreOptions.forEach((t => {
                t.addEventListener("click", this.showMoreEvent)
            })), (this.collectionSidebar || this.sort) && window.addEventListener("popstate", this.submitFormEvent), this.filterUrlButtons.length && this.filterUrlButtons.forEach((t => {
                t.addEventListener("click", this.filterUpdateFromUrlEvent)
            })), this.collectionSidebarCloseButtons.length && this.collectionSidebarCloseButtons.forEach((t => {
                t.addEventListener("click", this.collectionSidebarCloseEvent)
            }))
        }
        collectionSidebarClose(t) {
            t.preventDefault(), this.container.dispatchEvent(new CustomEvent("theme:filter:close", {
                bubbles: !1
            }))
        }
        onSortButtonClick(t) {
            t.preventDefault(), this.sortButton && this.sortButton.dispatchEvent(new Event("click")), this.sortActions(t, t.currentTarget)
        }
        sortActions(t, e, s = !0) {
            const i = this.sort.querySelector(rr),
                o = this.sort.querySelector(`.${dr}`);
            if (i) {
                const t = e ? e.textContent.trim() : "";
                i.textContent = t
            }
            o && o.classList.remove(dr), this.sort.classList.toggle(dr, e), e && (e.parentElement.classList.add(dr), s && this.submitForm(t))
        }
        onSortCheck(t) {
            let e = null;
            if (window.location.search.includes("sort_by")) {
                const t = new window.URL(window.location.href).searchParams;
                for (const [s, i] of t.entries()) {
                    const t = this.sort.querySelector(`[${or}="${i}"]`);
                    if (s.includes("sort_by") && t) {
                        e = t;
                        break
                    }
                }
            }
            this.sortActions(t, e, !1)
        }
        showMore(t) {
            t.preventDefault();
            const e = t.target.matches(Yn) ? t.target : t.target.closest(Yn);
            e.parentElement.classList.add(lr), e.parentElement.previousElementSibling.querySelectorAll(Qn).forEach(((t, e) => {
                t.classList.remove(lr);
                const s = t.querySelector(Bn);
                0 === e && document.body.classList.contains(cr) && s && (this.collectionSidebarSlideOut || b() ? (this.a11y.removeTrapFocus(), this.a11y.trapFocus(this.collectionSidebar, {
                    elementToFocus: s
                })) : s.focus())
            }))
        }
        updatePrice(t) {
            const e = t.type,
                s = t.target;
            if ((e === Bn || e === Dn || e === Fn || e === $n) && this.form && "function" == typeof this.form.submit) {
                const e = this.form.querySelector(_n),
                    i = this.form.querySelector(Nn);
                e && i && (s.hasAttribute(Rn) && !i.value ? i.value = i.placeholder : s.hasAttribute(zn) && !e.value && (e.value = e.placeholder)), this.submitForm(t)
            }
        }
        updateRange(t) {
            if (this.form && "function" == typeof this.form.submit) {
                const e = this.form.querySelector(Wn),
                    s = this.form.querySelector(Un),
                    i = this.form.querySelector(_n),
                    o = this.form.querySelector(Nn);
                if (e && s && i && o && e.hasAttribute(Vn) && s.hasAttribute(jn)) {
                    const n = parseInt(i.placeholder),
                        r = parseInt(o.placeholder),
                        a = parseInt(e.getAttribute(Vn)),
                        l = parseInt(s.getAttribute(jn));
                    n === a && r === l || (i.value = a, o.value = l, this.submitForm(t))
                }
            }
        }
        filterUpdateFromUrl(t) {
            t.preventDefault(), this.submitForm(t, t.currentTarget.getAttribute("href"))
        }
        submitForm(t, e = "") {
            if (!t || t && "popstate" !== t.type)
                if ("" === e) {
                    let t = new window.URL(window.location.href).searchParams;
                    const e = t,
                        s = Object.fromEntries(e),
                        i = t.toString();
                    if (i.includes("filter.") || i.includes("page=") || i.includes("sort_by="))
                        for (const e in s)(e.includes("filter.") || "page" === e || "sort_by" === e) && t.delete(e);
                    if (this.form) {
                        const e = new FormData(this.form),
                            s = new URLSearchParams(e),
                            i = this.form.querySelector(Wn),
                            o = this.form.querySelector(Un),
                            n = i && i.hasAttribute(Xn) ? i.getAttribute(Xn) : "",
                            r = o && o.hasAttribute(Jn) ? o.getAttribute(Jn) : "";
                        let a = 0;
                        for (let [e, i] of s.entries())(e.includes("filter.") && i || e.includes("sort_by") && i) && (t.append(e, i), (i === n && "filter.v.price.gte" === e || i === r && "filter.v.price.lte" === e) && (a += 1));
                        2 === a && (t.delete("filter.v.price.gte"), t.delete("filter.v.price.lte"))
                    }
                    const o = t.toString(),
                        n = o ? `?${o}` : location.pathname;
                    window.history.pushState(null, "", n)
                } else window.history.pushState(null, "", e);
            else this.sort && this.onSortCheck(t);
            this.productsContainer && (this.productsContainer.classList.add(hr), fetch(`${window.location.pathname}${window.location.search}`).then((t => t.text())).then((t => {
                const e = (new DOMParser).parseFromString(t, "text/html"),
                    s = this.container.querySelector(ar);
                if (s) {
                    const t = e.querySelector(ar);
                    s.innerHTML = t.innerHTML
                }
                if (this.productsContainer.innerHTML = e.querySelector(Kn).innerHTML, this.collectionSidebar) {
                    this.collectionSidebar.innerHTML = e.querySelector(Pn).innerHTML;
                    const t = this.collectionSidebar.querySelector(`[${tr}]`),
                        s = this.container.querySelectorAll(Zn);
                    if (t && s.length) {
                        const e = parseInt(t.getAttribute(tr));
                        s.forEach((t => {
                            t.textContent = e, t.classList.toggle(lr, e < 1)
                        }))
                    }
                }
                this.collectionNav && bn(this.productsContainer.getBoundingClientRect().top - this.collectionNav.offsetHeight), setTimeout((() => {
                    this.productsContainer.classList.remove(hr)
                }), 500)
            })).catch((t => {
                console.log(t)
            })))
        }
        disconnectedCallback() {
            this.collectionSidebar && this.form && (this.collectionSidebar.removeEventListener("input", this.updatePriceEvent), this.collectionSidebar.removeEventListener("theme:range:update", this.updateRangeEvent)), this.showMoreOptions.length && this.showMoreOptions.forEach((t => {
                t.removeEventListener("click", this.showMoreEvent)
            })), this.sort && this.sortLinks.length && this.sortLinks.forEach((t => {
                t.removeEventListener("click", this.onSortButtonClickEvent)
            })), (this.collectionSidebar || this.sort) && window.removeEventListener("popstate", this.submitFormEvent), this.filterUrlButtons.length && this.filterUrlButtons.forEach((t => {
                t.removeEventListener("click", this.filterUpdateFromUrlEvent)
            })), this.collectionSidebarCloseButtons.length && this.collectionSidebarCloseButtons.forEach((t => {
                t.removeEventListener("click", this.collectionSidebarCloseEvent)
            }))
        }
        constructor() {
            super(), this.container = this.closest(Mn), this.collectionSidebar = this.container.querySelector(Pn), this.collectionSidebarSlideOut = this.container.querySelector(In), this.form = this.querySelector(On), this.productsContainer = this.container.querySelector(Kn), this.collectionNav = this.container.querySelector(Gn), this.sort = this.container.querySelector(sr), this.sortButton = this.container.querySelector(nr), this.sortLinks = this.container.querySelectorAll(ir), this.filterUrlButtons = this.container.querySelectorAll(er), this.collectionSidebarCloseButtons = this.container.querySelectorAll(Hn), this.showMoreOptions = this.querySelectorAll(Yn), this.a11y = z, this.updatePriceEvent = v((t => this.updatePrice(t)), 500), this.updateRangeEvent = t => this.updateRange(t), this.showMoreEvent = t => this.showMore(t), this.onSortButtonClickEvent = t => this.onSortButtonClick(t), this.submitFormEvent = t => this.submitForm(t), this.collectionSidebarCloseEvent = t => this.collectionSidebarClose(t), this.filterUpdateFromUrlEvent = t => this.filterUpdateFromUrl(t)
        }
    };
    const pr = "[data-collection-sidebar]",
        mr = "[data-range-left]",
        vr = "[data-range-right]",
        gr = "[data-range-line]",
        fr = "[data-range-holder]",
        yr = "data-se-min",
        br = "data-se-max",
        wr = "data-se-min-value",
        Er = "data-se-max-value",
        Sr = "data-se-step",
        Lr = "data-range-filter-update",
        kr = "[data-field-price-min]",
        Ar = "[data-field-price-max]",
        Cr = "is-initialized";
    let Tr = class extends HTMLElement {
        connectedCallback() {
            let t = this.min;
            this.hasAttribute(wr) && (t = parseFloat(this.getAttribute(wr)));
            let e = this.max;
            this.hasAttribute(Er) && (e = parseFloat(this.getAttribute(Er))), t < this.min && (t = this.min), e > this.max && (e = this.max), t > e && (t = e), this.getAttribute(Sr) && (this.step = Math.abs(parseFloat(this.getAttribute(Sr)))), this.reset(), this.maxX = this.offsetWidth - this.touchRight.offsetWidth, this.selectedTouch = null, this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact, this.setMinValue(t), this.setMaxValue(e), this.touchLeft.addEventListener("mousedown", this.onStartEvent), this.touchRight.addEventListener("mousedown", this.onStartEvent), this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
                passive: !0
            }), this.touchRight.addEventListener("touchstart", this.onStartEvent, {
                passive: !0
            }), this.classList.add(Cr)
        }
        reset() {
            this.touchLeft.style.left = "0px", this.touchRight.style.left = this.offsetWidth - this.touchLeft.offsetWidth + "px", this.lineSpan.style.marginLeft = "0px", this.lineSpan.style.width = this.offsetWidth - this.touchLeft.offsetWidth + "px", this.startX = 0, this.x = 0
        }
        setMinValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            this.touchLeft.style.left = Math.ceil(e * (this.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.setAttribute(wr, t)
        }
        setMaxValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            this.touchRight.style.left = Math.ceil(e * (this.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.setAttribute(Er, t)
        }
        onStart(t) {
            let e = t;
            t.touches && (e = t.touches[0]), t.currentTarget === this.touchLeft ? this.x = this.touchLeft.offsetLeft : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft), this.startX = e.pageX - this.x, this.selectedTouch = t.currentTarget, document.addEventListener("mousemove", this.onMoveEvent), document.addEventListener("mouseup", this.onStopEvent), document.addEventListener("touchmove", this.onMoveEvent, {
                passive: !0
            }), document.addEventListener("touchend", this.onStopEvent, {
                passive: !0
            })
        }
        onMove(t) {
            let e = t;
            if (t.touches && (e = t.touches[0]), this.x = e.pageX - this.startX, this.selectedTouch === this.touchLeft ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 : this.x < 0 && (this.x = 0), this.selectedTouch.style.left = this.x + "px") : this.selectedTouch === this.touchRight && (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 : this.x > this.maxX && (this.x = this.maxX), this.selectedTouch.style.left = this.x + "px"), this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.calculateValue(), this.getAttribute("on-change")) {
                new Function("min, max", this.getAttribute("on-change"))(this.getAttribute(wr), this.getAttribute(Er))
            }
            this.onChange(this.getAttribute(wr), this.getAttribute(Er))
        }
        onStop() {
            document.removeEventListener("mousemove", this.onMoveEvent), document.removeEventListener("mouseup", this.onStopEvent), document.removeEventListener("touchmove", this.onMoveEvent), document.removeEventListener("touchend", this.onStopEvent), this.selectedTouch = null, this.calculateValue(), this.onChanged(this.getAttribute(wr), this.getAttribute(Er))
        }
        onChange(t, e) {
            const s = this.closest(fr);
            if (s) {
                const i = s.querySelector(kr),
                    o = s.querySelector(Ar);
                i && o && (i.value = t, o.value = e)
            }
        }
        onChanged(t, e) {
            this.hasAttribute(Lr) && this.dispatchEvent(new CustomEvent("theme:range:update", {
                bubbles: !0
            }))
        }
        calculateValue() {
            const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
            let e = this.lineSpan.offsetLeft / this.initialValue,
                s = e + t;
            if (e = e * (this.max - this.min) + this.min, s = s * (this.max - this.min) + this.min, 0 !== this.step) {
                let t = Math.floor(e / this.step);
                e = this.step * t, t = Math.floor(s / this.step), s = this.step * t
            }
            this.selectedTouch === this.touchLeft && this.setAttribute(wr, e), this.selectedTouch === this.touchRight && this.setAttribute(Er, s)
        }
        onSidebarTransitionEnd(t) {
            t.target == this.sidebar && "min-width" == t.propertyName && (this.sidebar.removeEventListener("transitionend", this.sidebarTransitionEvent), this.connectedCallback())
        }
        disconnectedCallback() {
            this.sidebar.removeEventListener("transitionend", this.sidebarTransitionEvent), this.resizeEvent && document.removeEventListener("theme:resize:width", this.resizeEvent)
        }
        constructor() {
            super(), this.sidebar = this.closest(pr), this.sidebarTransitionEvent = t => this.onSidebarTransitionEnd(t), this.resizeEvent = () => {
                this.connectedCallback(), this.sidebar.addEventListener("transitionend", this.sidebarTransitionEvent)
            }, this.onMoveEvent = t => this.onMove(t), this.onStopEvent = t => this.onStop(t), this.onStartEvent = t => this.onStart(t), this.startX = 0, this.x = 0, this.touchLeft = this.querySelector(mr), this.touchRight = this.querySelector(vr), this.lineSpan = this.querySelector(gr), this.min = parseFloat(this.getAttribute(yr)), this.max = parseFloat(this.getAttribute(br)), this.step = 0, this.normalizeFact = 26, document.addEventListener("theme:resize:width", this.resizeEvent)
        }
    };
    const qr = "[data-collection-sidebar]",
        xr = "[data-collection-sidebar-slide-out]",
        Mr = "[data-collection-sidebar-close]",
        Pr = "[data-aria-toggle]",
        Ir = "drawer--animated",
        Hr = "expanded",
        Or = "no-mobile-animation",
        Br = "is-focused";
    let Dr = {};
    Po("collection", [yn, jo, {
        onLoad() {
            Dr[this.id] = new class {
                init() {
                    null !== this.groupTagsButton && (document.addEventListener("theme:resize:width", this.sidebarResizeEvent), this.groupTagsButton.addEventListener("click", this.groupTagsButtonClickEvent), this.collectionSidebar && setTimeout((() => {
                        this.collectionSidebar.classList.remove(Or)
                    }), 1e3), new MutationObserver((t => {
                        for (const e of t) "attributes" === e.type && "true" == e.target.getAttribute("aria-expanded") && this.showSidebarCallback()
                    })).observe(this.groupTagsButton, {
                        attributes: !0,
                        childList: !1,
                        subtree: !1
                    })), this.container.addEventListener("keyup", function(t) {
                        "Escape" === t.code && this.hideSidebar()
                    }.bind(this)), this.collectionSidebar && (this.collectionSidebar.addEventListener("transitionend", (() => {
                        this.collectionSidebar.classList.contains(Hr) || this.collectionSidebar.classList.remove(Ir)
                    })), this.toggleSidebarSlider(), this.container.addEventListener("theme:filter:close", this.collectionSidebarCloseEvent))
                }
                showSidebarCallback() {
                    const t = this.container.querySelector(xr),
                        e = document.documentElement.hasAttribute("data-scroll-locked"),
                        s = b();
                    this.collectionSidebar.classList.add(Ir), null === t && !s && e && (this.a11y.removeTrapFocus(), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    }))), (s || null !== t) && (t && this.a11y.trapFocus(this.collectionSidebar, {
                        elementToFocus: this.collectionSidebar.querySelector(Mr)
                    }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                        bubbles: !0
                    })))
                }
                hideSidebar() {
                    const t = this.container.querySelector(xr),
                        e = document.documentElement.hasAttribute("data-scroll-locked");
                    this.groupTagsButton.setAttribute("aria-expanded", "false"), this.collectionSidebar.classList.remove(Hr), t && this.a11y.removeTrapFocus(), e && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    }))
                }
                toggleSidebarSlider() {
                    b() ? this.hideSidebar() : this.collectionSidebar.classList.contains(Hr) && this.showSidebarCallback()
                }
                collectionSidebarClose(t) {
                    t.preventDefault(), this.hideSidebar(), document.body.classList.contains(Br) && this.groupTagsButton && this.groupTagsButton.focus()
                }
                groupTagsButtonClick() {
                    document.documentElement.hasAttribute("data-scroll-locked") && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    }))
                }
                onUnload() {
                    null !== this.groupTagsButton && (document.removeEventListener("theme:resize:width", this.sidebarResizeEvent), this.groupTagsButton.removeEventListener("click", this.groupTagsButtonClickEvent)), this.collectionSidebar && this.container.removeEventListener("theme:filter:close", this.collectionSidebarCloseEvent)
                }
                constructor(t) {
                    this.container = t.container, this.collectionSidebar = this.container.querySelector(qr), this.groupTagsButton = this.container.querySelector(Pr), this.a11y = z, this.groupTagsButtonClickEvent = t => this.groupTagsButtonClick(t), this.sidebarResizeEvent = () => this.toggleSidebarSlider(), this.collectionSidebarCloseEvent = t => this.collectionSidebarClose(t), this.init()
                }
            }(this)
        },
        onUnload() {
            Dr[this.id].onUnload()
        }
    }, Uo]), customElements.get("collection-filters-form") || customElements.define("collection-filters-form", ur), customElements.get("range-slider") || customElements.define("range-slider", Tr);
    const Fr = "[data-ticker-scale]",
        $r = "[data-ticker-text]",
        _r = "data-clone",
        Nr = "autoplay",
        Rr = "speed",
        zr = "ticker--animated",
        Wr = "ticker--unloaded",
        Ur = "ticker__comparitor",
        Vr = 1.63,
        jr = 100;
    let Xr = class extends HTMLElement {
        connectedCallback() {
            this.checkWidth(), this.addEventListener("theme:ticker:refresh", this.checkWidthEvent), screen.orientation.addEventListener("change", this.checkWidthEvent), document.addEventListener("theme:resize:width", this.checkWidthEvent)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.checkWidthEvent)
        }
        checkWidth() {
            const t = 2 * window.getComputedStyle(this).paddingLeft.replace("px", ""),
                e = this.clientWidth - t < this.comparitor.clientWidth;
            if (e || this.autoplay) {
                var s;
                this.text.classList.remove(zr);
                const i = this.scale.querySelectorAll(`[${_r}]`),
                    o = this.autoplay ? parseInt((window.innerWidth - t) / this.text.clientWidth) : 2;
                if (null == i || i.forEach((t => {
                        t.remove()
                    })), this.autoplay || e)
                    for (let t = 0; t <= o; t++) {
                        const t = this.text.cloneNode(!0);
                        t.setAttribute(_r, ""), this.scale.appendChild(t)
                    }
                const n = (this.text.clientWidth / jr * Number(this.speed)).toFixed(2);
                this.scale.style.setProperty("--animation-time", `${n}s`), null === (s = this.scale.querySelectorAll($r)) || void 0 === s || s.forEach((t => {
                    t.classList.add(zr)
                }))
            } else {
                this.text.classList.add(zr);
                let t = this.scale.querySelector(`[${_r}]`);
                t && this.scale.removeChild(t), this.text.classList.remove(zr)
            }
        }
        constructor() {
            super(), this.autoplay = this.hasAttribute(Nr), this.scale = this.querySelector(Fr), this.text = this.querySelector($r), this.speed = this.hasAttribute(Rr) ? this.getAttribute(Rr) : Vr, this.comparitor = this.text.cloneNode(!0), this.comparitor.classList.add(Ur), this.appendChild(this.comparitor), this.scale.classList.remove(Wr), this.checkWidthEvent = this.checkWidth.bind(this)
        }
    };
    const Jr = {
            slide: "[data-slide]",
            slider: "[data-slider]"
        },
        Yr = "data-target-referrer";
    let Qr = class extends HTMLElement {
        connectedCallback() {
            this.removeAnnouncement(), this.slider && this.initSliders(), this.addEventListener("theme:block:select", (t => {
                this.onBlockSelect(t)
            })), this.addEventListener("theme:block:deselect", (t => {
                this.onBlockDeselect(t)
            })), document.dispatchEvent(new CustomEvent("theme:announcement:init", {
                bubbles: !0
            }))
        }
        removeAnnouncement() {
            for (let t = 0; t < this.slides.length; t++) {
                const e = this.slides[t];
                e.hasAttribute(Yr) && (-1 !== this.locationPath.indexOf(e.getAttribute(Yr)) || window.Shopify.designMode || e.parentNode.removeChild(e))
            }
        }
        initSliders() {
            this.initSlider(), document.addEventListener("theme:resize:width", this.initSliderEvent), this.addEventListener("theme:slider:loaded", (() => {
                var t;
                null === (t = this.querySelectorAll(Jr.tickerBar)) || void 0 === t || t.forEach((t => {
                    t.dispatchEvent(new CustomEvent("theme:ticker:refresh"))
                }))
            }))
        }
        initSlider() {
            const t = y(),
                e = !t;
            var s, i;
            (t && this.enableSlider || e && !this.enableSlider) && (null === (s = this.slider.flkty) || void 0 === s || s.destroy(), t && this.enableSlider ? this.enableSlider = !1 : e && !this.enableSlider && (this.enableSlider = !0), this.slider = new fn(this, this.querySelector(Jr.slider)), null === (i = this.slider.flkty) || void 0 === i || i.reposition())
        }
        onBlockSelect(t) {
            this.slider && this.slider.onBlockSelect(t)
        }
        onBlockDeselect(t) {
            this.slider && this.slider.onBlockDeselect(t)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.initSliderEvent), document.removeEventListener("theme:resize:width", this.tickerResizeEvent), this.removeEventListener("theme:block:select", (t => {
                this.onBlockSelect(t)
            })), this.removeEventListener("theme:block:deselect", (t => {
                this.onBlockDeselect(t)
            }))
        }
        constructor() {
            super(), this.locationPath = location.href, this.slides = this.querySelectorAll(Jr.slide), this.slider = this.querySelector(Jr.slider), this.enableSlider = y(), this.initSliderEvent = t => this.initSlider(t)
        }
    };
    customElements.get("announcement-bar") || customElements.define("announcement-bar", Qr), customElements.get("ticker-bar") || customElements.define("ticker-bar", Xr);
    const Gr = "body",
        Kr = "[data-drawer]",
        Zr = "[data-drawer-inner]",
        ta = "[data-drawer-underlay]",
        ea = "[data-stagger-animation]",
        sa = "[data-header-wrapper]",
        ia = "data-drawer-toggle",
        oa = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        na = "drawer--animated",
        ra = "is-open",
        aa = "is-closing",
        la = "is-focused";
    let ca = {};
    const ha = {
            onLoad() {
                ca[this.id] = [];
                this.container.querySelectorAll(Kr).forEach((t => {
                    ca[this.id].push(new class {
                        connectToggle() {
                            this.buttons.forEach((t => {
                                t.addEventListener("click", (() => {
                                    this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", {
                                        bubbles: !1
                                    }))
                                }))
                            }))
                        }
                        connectDrawer() {
                            this.drawer.addEventListener("theme:drawer:toggle", (() => {
                                this.drawer.classList.contains(ra) ? this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", {
                                    bubbles: !0
                                })) : this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", {
                                    bubbles: !0
                                }))
                            })), document.addEventListener("theme:cart-drawer:open", this.hideDrawer), document.addEventListener("theme:drawer:close", this.hideDrawer), document.addEventListener("theme:drawer:open", this.showDrawer)
                        }
                        closers() {
                            this.wrapper.addEventListener("keyup", (t => {
                                "Escape" === t.code && this.hideDrawer()
                            })), this.underlay.addEventListener("click", (() => {
                                this.hideDrawer()
                            }))
                        }
                        showDrawer() {
                            this.isAnimating || (this.isAnimating = !0, this.buttons.forEach((t => {
                                t.setAttribute("aria-expanded", !0)
                            })), this.drawer.classList.add(ra, na), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                                bubbles: !0
                            })), this.drawerInner && this.drawerInner.querySelector(this.btnSelector) && (N(), ei(this.drawerInner).then((() => {
                                this.drawer.querySelector(oa).focus(), this.isAnimating = !1, _(this.drawerInner, {
                                    elementToFocus: this.drawerInner.querySelector(this.btnSelector)
                                })
                            }))))
                        }
                        hideDrawer() {
                            this.drawer.classList.contains(ra) && !this.isAnimating && (this.isAnimating = !0, this.drawer.classList.add(aa), this.drawer.classList.remove(ra), N(), this.body.classList.contains(la) && this.buttons.length && this.buttons[0].focus(), this.buttons.forEach((t => {
                                t.setAttribute("aria-expanded", !1)
                            })), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                                bubbles: !0
                            })), ei(this.drawerInner).then((() => {
                                this.drawer.classList.remove(aa, na), this.isAnimating = !1, document.dispatchEvent(new CustomEvent("theme:sliderule:close", {
                                    bubbles: !1
                                }))
                            })))
                        }
                        onUnload() {
                            document.removeEventListener("theme:cart-drawer:open", this.hideDrawer), document.removeEventListener("theme:drawer:close", this.hideDrawer), document.removeEventListener("theme:drawer:open", this.showDrawer)
                        }
                        constructor(t) {
                            this.isAnimating = !1, this.drawer = t, this.drawerWrapper = this.drawer.closest(Kr), this.drawerInner = this.drawer.querySelector(Zr), this.underlay = this.drawer.querySelector(ta), this.wrapper = this.drawer.closest(sa), this.key = this.drawer.dataset.drawer, this.btnSelector = `[${ia}='${this.key}']`, this.buttons = document.querySelectorAll(this.btnSelector), this.staggers = this.drawer.querySelectorAll(ea), this.body = document.querySelector(Gr), this.showDrawer = this.showDrawer.bind(this), this.hideDrawer = this.hideDrawer.bind(this), this.connectToggle(), this.connectDrawer(), this.closers()
                        }
                    }(t))
                }))
            },
            onUnload() {
                ca[this.id].forEach((t => {
                    "function" == typeof t.onUnload && t.onUnload()
                }))
            }
        },
        da = ".page-header",
        ua = "js__header__stuck",
        pa = "has-header-sticky",
        ma = "shopify-section-group-header-group",
        va = "data-header-sticky",
        ga = "data-scroll-locked";
    let fa = {};
    const ya = {
            onLoad() {
                fa = new class {
                    listen() {
                        document.addEventListener("theme:scroll", this.scrollEvent), document.addEventListener("shopify:section:load", this.updateHeaderOffset), document.addEventListener("shopify:section:unload", this.updateHeaderOffset)
                    }
                    onScroll(t) {
                        t.detail.down ? !this.isStuck && t.detail.position > this.headerOffset && this.stickSimple() : t.detail.position <= this.headerOffset && this.unstickSimple()
                    }
                    updateHeaderOffset(t) {
                        t.target.classList.contains(ma) && setTimeout((() => {
                            var t;
                            this.headerOffset = null === (t = document.querySelector(da)) || void 0 === t ? void 0 : t.offsetTop
                        }))
                    }
                    stickOnLoad() {
                        window.scrollY > this.headerOffset && this.stickSimple()
                    }
                    stickSimple() {
                        this.cls.add(ua), this.isStuck = !0
                    }
                    unstickSimple() {
                        document.documentElement.hasAttribute(ga) || (this.cls.remove(ua), this.isStuck = !1)
                    }
                    unload() {
                        document.removeEventListener("theme:scroll", this.scrollEvent), document.removeEventListener("shopify:section:load", this.updateHeaderOffset), document.removeEventListener("shopify:section:unload", this.updateHeaderOffset)
                    }
                    constructor(t) {
                        var e;
                        this.wrapper = t, this.sticks = this.wrapper.hasAttribute(va), document.body.classList.toggle(pa, this.sticks), this.sticks && (this.isStuck = !1, this.cls = this.wrapper.classList, this.headerOffset = null === (e = document.querySelector(da)) || void 0 === e ? void 0 : e.offsetTop, this.updateHeaderOffset = this.updateHeaderOffset.bind(this), this.scrollEvent = t => this.onScroll(t), this.listen(), this.stickOnLoad())
                    }
                }(this.container)
            },
            onUnload: function() {
                "function" == typeof fa.unload && fa.unload()
            }
        },
        ba = "data-hover-disclosure-toggle",
        wa = "[data-hover-disclosure]",
        Ea = "[data-top-link]",
        Sa = "[data-header-wrapper]",
        La = "[data-stagger]",
        ka = "[data-stagger-first]",
        Aa = "[data-stagger-second]",
        Ca = "is-visible",
        Ta = "meganav--visible",
        qa = "meganav--is-transitioning";
    let xa = {},
        Ma = {};
    const Pa = {
            onLoad() {
                xa[this.id] = [], Ma = this.container.querySelectorAll(wa), Ma.forEach((t => {
                    xa[this.id].push(new class {
                        onBlockSelect(t) {
                            this.disclosure.contains(t.target) && this.showDisclosure(t)
                        }
                        onBlockDeselect(t) {
                            this.disclosure.contains(t.target) && this.hideDisclosure()
                        }
                        showDisclosure(t) {
                            t && t.type && "mouseenter" === t.type && this.wrapper.classList.add(qa), this.grandparent ? this.wrapper.classList.add(Ta) : this.wrapper.classList.remove(Ta), this.trigger.setAttribute("aria-expanded", !0), this.trigger.classList.add(Ca), this.disclosure.classList.add(Ca), this.transitionTimeout && clearTimeout(this.transitionTimeout), this.transitionTimeout = setTimeout((() => {
                                this.wrapper.classList.remove(qa)
                            }), 200)
                        }
                        hideDisclosure() {
                            this.disclosure.classList.remove(Ca), this.trigger.classList.remove(Ca), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(Ta, qa)
                        }
                        staggerChildAnimations() {
                            this.disclosure.querySelectorAll(La).forEach(((t, e) => {
                                t.style.transitionDelay = 50 * e + 10 + "ms"
                            })), this.disclosure.querySelectorAll(ka).forEach(((t, e) => {
                                const s = 100 * e;
                                t.style.transitionDelay = `${s}ms`, t.parentElement.querySelectorAll(Aa).forEach(((t, e) => {
                                    const i = 20 * (e + 1);
                                    t.style.transitionDelay = `${s+i}ms`
                                }))
                            }))
                        }
                        handleTablets() {
                            this.trigger.addEventListener("touchstart", function(t) {
                                this.disclosure.classList.contains(Ca) || (t.preventDefault(), this.showDisclosure(t))
                            }.bind(this), {
                                passive: !0
                            })
                        }
                        connectHoverToggle() {
                            this.trigger.addEventListener("mouseenter", (t => this.showDisclosure(t))), this.link.addEventListener("focus", (t => this.showDisclosure(t))), this.trigger.addEventListener("mouseleave", (() => this.hideDisclosure())), this.trigger.addEventListener("focusout", (t => {
                                this.trigger.contains(t.relatedTarget) || this.hideDisclosure()
                            })), this.disclosure.addEventListener("keyup", (t => {
                                "Escape" === t.code && this.hideDisclosure()
                            }))
                        }
                        constructor(t) {
                            this.disclosure = t, this.wrapper = t.closest(Sa), this.key = this.disclosure.id, this.trigger = document.querySelector(`[${ba}='${this.key}']`), this.link = this.trigger.querySelector(Ea), this.grandparent = this.trigger.classList.contains("grandparent"), this.transitionTimeout = 0, this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.connectHoverToggle(), this.handleTablets(), this.staggerChildAnimations()
                        }
                    }(t))
                }))
            },
            onBlockSelect(t) {
                xa[this.id].forEach((e => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
                }))
            },
            onBlockDeselect(t) {
                xa[this.id].forEach((e => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
                }))
            }
        },
        Ia = {
            slideruleOpen: "data-sliderule-open",
            slideruleClose: "data-sliderule-close",
            sliderulePane: "data-sliderule-pane",
            slideruleWrappper: "[data-sliderule]",
            drawerContent: "[data-drawer-content]",
            focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
            dataAnimates: "data-animates",
            children: ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *"
        },
        Ha = "is-visible",
        Oa = "is-hiding",
        Ba = "is-hidden",
        Da = "is-focused",
        Fa = "is-scrolling";
    let $a = {};
    const _a = {
            onLoad() {
                $a[this.id] = [];
                this.container.querySelectorAll(Ia.slideruleWrappper).forEach((t => {
                    $a[this.id].push(new class {
                        clickEvents() {
                            this.trigger.addEventListener("click", (() => {
                                this.cachedButton = this.trigger, this.showSliderule()
                            })), this.exit.forEach((t => {
                                t.addEventListener("click", (() => {
                                    this.hideSliderule()
                                }))
                            }))
                        }
                        keyboardEvents() {
                            this.sliderule.addEventListener("keyup", (t => {
                                t.stopPropagation(), "Escape" === t.code && this.hideSliderule()
                            }))
                        }
                        trapFocusSliderule(t = !0) {
                            const e = t ? this.sliderule.querySelector(this.exitSelector) : this.cachedButton;
                            this.accessibility.removeTrapFocus(), e && this.drawerContent && this.accessibility.trapFocus(this.drawerContent, {
                                elementToFocus: document.body.classList.contains(Da) ? e : null
                            })
                        }
                        hideSliderule(t = !1) {
                            const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                            this.pane.setAttribute(Ia.sliderulePane, e), this.pane.classList.add(Oa), this.sliderule.classList.add(Oa);
                            const s = t ? `[${Ia.dataAnimates}].${Ba}` : `[${Ia.dataAnimates}="${e}"]`,
                                i = this.pane.querySelectorAll(s);
                            i.length && i.forEach((t => {
                                t.classList.remove(Ba)
                            }));
                            const o = t ? this.pane.querySelectorAll(`.${Ha}, .${Oa}`) : this.children;
                            o.forEach(((s, i) => {
                                const n = o.length - 1 == i;
                                s.classList.remove(Ha), t && (s.classList.remove(Oa), this.pane.classList.remove(Oa));
                                const r = () => {
                                    parseInt(this.pane.getAttribute(Ia.sliderulePane)) === e && this.sliderule.classList.remove(Ha), this.sliderule.classList.remove(Oa), this.pane.classList.remove(Oa), n && (this.accessibility.removeTrapFocus(), t || this.trapFocusSliderule(!1)), s.removeEventListener("animationend", r)
                                };
                                window.theme.settings.enableAnimations ? s.addEventListener("animationend", r) : r()
                            }))
                        }
                        showSliderule() {
                            let t = null;
                            const e = this.sliderule.closest(`.${Ha}`);
                            let s = this.pane;
                            e && (s = e), s.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "smooth"
                            }), s.classList.add(Fa);
                            const i = () => {
                                s.scrollTop <= 0 ? (s.classList.remove(Fa), t && cancelAnimationFrame(t)) : t = requestAnimationFrame(i)
                            };
                            t = requestAnimationFrame(i), this.sliderule.classList.add(Ha);
                            const o = parseInt(this.pane.dataset.sliderulePane, 10),
                                n = o + 1;
                            this.pane.setAttribute(Ia.sliderulePane, n);
                            const r = this.pane.querySelectorAll(`[${Ia.dataAnimates}="${o}"]`);
                            r.length && r.forEach(((t, e) => {
                                const s = r.length - 1 == e;
                                t.classList.add(Oa);
                                const i = () => {
                                    t.classList.remove(Oa), parseInt(this.pane.getAttribute(Ia.sliderulePane)) !== o && t.classList.add(Ba), s && this.trapFocusSliderule(), t.removeEventListener("animationend", i)
                                };
                                window.theme.settings.enableAnimations ? t.addEventListener("animationend", i) : i()
                            }))
                        }
                        closeSliderule() {
                            this.pane && this.pane.hasAttribute(Ia.sliderulePane) && parseInt(this.pane.getAttribute(Ia.sliderulePane)) > 0 && (this.hideSliderule(!0), parseInt(this.pane.getAttribute(Ia.sliderulePane)) > 0 && this.pane.setAttribute(Ia.sliderulePane, 0))
                        }
                        onUnload() {
                            document.removeEventListener("theme:sliderule:close", this.closeSliderule)
                        }
                        constructor(t) {
                            this.sliderule = t, this.key = this.sliderule.id;
                            const e = `[${Ia.slideruleOpen}='${this.key}']`;
                            this.exitSelector = `[${Ia.slideruleClose}='${this.key}']`, this.trigger = document.querySelector(e), this.exit = document.querySelectorAll(this.exitSelector), this.pane = document.querySelector(`[${Ia.sliderulePane}]`), this.children = this.sliderule.querySelectorAll(Ia.children), this.drawerContent = document.querySelector(Ia.drawerContent), this.cachedButton = null, this.accessibility = z, this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.closeSliderule = this.closeSliderule.bind(this), this.clickEvents(), this.keyboardEvents(), document.addEventListener("theme:sliderule:close", this.closeSliderule)
                        }
                    }(t))
                }))
            },
            onUnload() {
                $a[this.id].forEach((t => {
                    "function" == typeof t.onUnload && t.onUnload()
                }))
            }
        },
        Na = "[data-takes-space-wrapper]",
        Ra = "[data-child-takes-space]",
        za = "[data-header-desktop]",
        Wa = '.navlink[href="#"]',
        Ua = "cart-drawer",
        Va = "[data-cart-toggle]",
        ja = ".main-content > .shopify-section.section-overlay-header:first-of-type",
        Xa = "js__header__clone",
        Ja = "has-first-section-overlay-header",
        Ya = "js__show__mobile",
        Qa = "has-header-transparent",
        Ga = "data-header-transparent";
    let Ka = {};
    Po("header", [{
        onLoad() {
            Ka = new class {
                initTicker(t = !1) {
                    this.tickerFrames.forEach((e => {
                        new Xr(e, t)
                    })), this.tickerResizeEvent = t => this.onTickerResize(t), document.addEventListener("theme:resize:width", this.tickerResizeEvent)
                }
                listenWidth() {
                    "ResizeObserver" in window ? (this.resizeObserver = new ResizeObserver(this.checkWidth), this.resizeObserver.observe(this.wrapper)) : document.addEventListener("theme:resize", this.checkWidth)
                }
                killDeadLinks() {
                    this.deadLinks.forEach((t => {
                        t.onclick = t => {
                            t.preventDefault()
                        }
                    }))
                }
                checkWidth() {
                    if (document.body.clientWidth < this.minWidth) {
                        this.wrapper.classList.add(Ya);
                        const {
                            headerHeight: t
                        } = c();
                        document.documentElement.style.setProperty("--header-height", `${t}px`)
                    } else this.wrapper.classList.remove(Ya)
                }
                getMinWidth() {
                    const t = this.wrapper.cloneNode(!0);
                    t.classList.add(Xa), document.body.appendChild(t);
                    const e = t.querySelectorAll(Na);
                    let s = 0,
                        i = 0;
                    return e.forEach((t => {
                        const e = t.querySelectorAll(Ra);
                        let o = 0;
                        o = 3 === e.length ? function(t) {
                            let e = [];
                            return t.forEach((t => {
                                t.firstElementChild && e.push(t.firstElementChild.clientWidth)
                            })), e[0] > e[2] ? e[2] = e[0] : e[0] = e[2], e.reduce(((t, e) => t + e))
                        }(e) : function(t) {
                            let e = 0;
                            return t.forEach((t => {
                                e += t.clientWidth
                            })), e
                        }(e), o > s && (s = o, i = 20 * e.length)
                    })), document.body.removeChild(t), s + i
                }
                cartToggleEvent() {
                    var t;
                    "drawer" === theme.settings.cartType && (null === (t = this.wrapper.querySelectorAll(Va)) || void 0 === t || t.forEach((t => {
                        t.addEventListener("click", (e => {
                            const s = document.querySelector(Ua);
                            s && (e.preventDefault(), s.dispatchEvent(new CustomEvent("theme:cart-drawer:show")), window.accessibility.lastElement = t)
                        }))
                    })))
                }
                toggleButtonClick(t) {
                    t.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:toggle", {
                        bubbles: !0
                    }))
                }
                unload() {
                    var t;
                    "ResizeObserver" in window ? null === (t = this.resizeObserver) || void 0 === t || t.unobserve(this.wrapper) : document.removeEventListener("theme:resize", this.checkWidth)
                }
                constructor(t) {
                    this.wrapper = t, this.style = this.wrapper.dataset.style, this.desktop = this.wrapper.querySelector(za), this.deadLinks = document.querySelectorAll(Wa), this.resizeObserver = null, this.checkWidth = this.checkWidth.bind(this), this.killDeadLinks(), "drawer" !== this.style && this.desktop && (this.minWidth = this.getMinWidth(), this.listenWidth()), this.cartToggleEvent();
                    const e = document.querySelector(ja);
                    document.body.classList.toggle(Qa, this.wrapper.hasAttribute(Ga)), document.body.classList.toggle(Ja, e)
                }
            }(this.container)
        },
        onUnload() {
            "function" == typeof Ka.unload && Ka.unload()
        }
    }, ha, _a, ya, Pa]), customElements.get("ticker-bar") || customElements.define("ticker-bar", Xr);
    const Za = "[data-block-scroll]",
        tl = "flickity-enabled",
        el = {};
    const sl = {
            onLoad() {
                el[this.id] = new class {
                    onBlockSelect(t) {
                        const e = this.container.querySelector(Za);
                        if (e && !e.classList.contains(tl)) {
                            const s = t.srcElement;
                            s && e.scrollTo({
                                top: 0,
                                left: s.offsetLeft,
                                behavior: "smooth"
                            })
                        }
                    }
                    constructor(t) {
                        this.container = t.container
                    }
                }(this)
            },
            onBlockSelect(t) {
                el[this.id].onBlockSelect(t)
            }
        },
        il = "[data-slider-mobile]",
        ol = "[data-slide]",
        nl = "[data-slider-thumb]",
        rl = "[data-slider-container]",
        al = "[data-popup-container]",
        ll = "[data-popup-close]",
        cl = "is-animating",
        hl = "is-open",
        dl = "data-slider-thumb",
        ul = {};

    function pl() {
        this.entries = []
    }

    function ml(t, e) {
        vl(t);
        var s = function(t, e) {
            vl(t),
                function(t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.")
                }(e);
            var s = [];
            return e.forEach((function(e) {
                for (var i = 0; i < t.options.length; i++) {
                    if ((t.options[i].name || t.options[i]).toLowerCase() === e.name.toLowerCase()) {
                        s[i] = e.value;
                        break
                    }
                }
            })), s
        }(t, e);
        return function(t, e) {
            return vl(t),
                function(t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.")
                }(e), t.variants.filter((function(t) {
                    return e.every((function(e, s) {
                        return t.options[s] === e
                    }))
                }))[0] || null
        }(t, s)
    }

    function vl(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.")
    }
    Po("look", [{
        onLoad() {
            ul[this.id] = new class {
                init() {
                    this.slider && this.slides.length && this.thumbs.length && (this.popupContainer.addEventListener("transitionend", (t => {
                        t.target == this.popupContainer && (this.popupContainer.classList.remove(cl), t.target.classList.contains(hl) ? this.popupOpenCallback() : this.popupCloseCallback())
                    })), this.popupContainer.addEventListener("transitionstart", (t => {
                        t.target == this.popupContainer && this.popupContainer.classList.add(cl)
                    })), this.popupClose.forEach((t => {
                        t.addEventListener("click", (() => {
                            this.popupContainer.classList.remove(hl), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                                bubbles: !0
                            }))
                        }))
                    })), this.thumbs.forEach(((t, e) => {
                        t.addEventListener("click", (s => {
                            s.preventDefault();
                            const i = t.hasAttribute(dl) && "" !== t.getAttribute(dl) ? parseInt(t.getAttribute(dl)) : e,
                                o = this.slides[i];
                            if (b()) {
                                const t = parseInt(window.getComputedStyle(this.slider).paddingLeft);
                                this.slider.scrollTo({
                                    top: 0,
                                    left: o.offsetLeft - t,
                                    behavior: "auto"
                                }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                                    bubbles: !0
                                })), this.popupContainer.classList.add(cl, hl)
                            } else {
                                let {
                                    stickyHeaderHeight: t
                                } = c();
                                const e = o.getBoundingClientRect().top,
                                    s = o.offsetHeight / 2,
                                    i = window.innerHeight,
                                    n = i / 2,
                                    r = this.container.querySelector(rl);
                                let a = e + s - n + window.scrollY;
                                if (r) {
                                    const e = r.getBoundingClientRect().top + window.scrollY,
                                        s = e + r.offsetHeight;
                                    a < e ? a = e - t : a + i > s && (a = s - i)
                                }
                                window.scrollTo({
                                    top: a,
                                    left: 0,
                                    behavior: "smooth"
                                })
                            }
                        }))
                    })))
                }
                popupCloseByEvent() {
                    this.popupContainer.classList.remove(hl)
                }
                popupOpenCallback() {
                    document.addEventListener("theme:quick-add:open", this.popupCloseByEvent, {
                        once: !0
                    }), document.addEventListener("theme:product:added", this.popupCloseByEvent, {
                        once: !0
                    })
                }
                popupCloseCallback() {
                    document.removeEventListener("theme:quick-add:open", this.popupCloseByEvent, {
                        once: !0
                    }), document.removeEventListener("theme:product:added", this.popupCloseByEvent, {
                        once: !0
                    })
                }
                constructor(t) {
                    this.container = t.container, this.slider = this.container.querySelector(il), this.slides = this.container.querySelectorAll(ol), this.thumbs = this.container.querySelectorAll(nl), this.popupContainer = this.container.querySelector(al), this.popupClose = this.container.querySelectorAll(ll), this.popupCloseByEvent = this.popupCloseByEvent.bind(this), this.init()
                }
            }(this)
        }
    }, sl]), pl.prototype.add = function(t, e, s) {
        this.entries.push({
            element: t,
            event: e,
            fn: s
        }), t.addEventListener(e, s)
    }, pl.prototype.removeAll = function() {
        this.entries = this.entries.filter((function(t) {
            return t.element.removeEventListener(t.event, t.fn), !1
        }))
    };
    var gl = '[name="id"]',
        fl = '[name="selling_plan"]',
        yl = '[name^="options"]',
        bl = '[name="quantity"]',
        wl = '[name^="properties"]';
    const El = "data-scrollbar",
        Sl = "data-scrollbar-slider",
        Ll = "data-scrollbar-slide-fullwidth",
        kl = "[data-scrollbar-arrow-prev]",
        Al = "[data-scrollbar-arrow-next]",
        Cl = "is-hidden",
        Tl = 200;
    let ql = class {
        init() {
            this.arrowNext && this.arrowPrev && (this.toggleNextArrow(), this.events())
        }
        listen() {
            document.addEventListener("theme:modal:open", (() => {
                this.toggleNextArrow()
            })), document.addEventListener("theme:resize", (() => {
                this.toggleNextArrow()
            }))
        }
        events() {
            this.arrowNext.addEventListener("click", (t => {
                t.preventDefault(), this.goToNext()
            })), this.arrowPrev.addEventListener("click", (t => {
                t.preventDefault(), this.goToPrev()
            })), this.scrollbar.addEventListener("scroll", (() => {
                this.togglePrevArrow(), this.toggleNextArrow()
            }))
        }
        goToNext() {
            const t = (this.scrollbar.hasAttribute(Ll) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2) + this.scrollbar.scrollLeft;
            this.move(t), this.arrowPrev.classList.remove(Cl), this.toggleNextArrow()
        }
        goToPrev() {
            const t = this.scrollbar.hasAttribute(Ll) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2,
                e = this.scrollbar.scrollLeft - t;
            this.move(e), this.arrowNext.classList.remove(Cl), this.togglePrevArrow()
        }
        toggleNextArrow() {
            setTimeout((() => {
                this.arrowNext.classList.toggle(Cl, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth)
            }), Tl)
        }
        togglePrevArrow() {
            setTimeout((() => {
                this.arrowPrev.classList.toggle(Cl, this.scrollbar.scrollLeft <= 0)
            }), Tl)
        }
        scrollToVisibleElement() {
            [].forEach.call(this.scrollbar.children, (t => {
                t.addEventListener("click", (e => {
                    e.preventDefault(), this.move(t.offsetLeft - t.clientWidth)
                }))
            }))
        }
        move(t) {
            this.scrollbar.scrollTo({
                top: 0,
                left: t,
                behavior: "smooth"
            })
        }
        constructor(t) {
            this.scrollbar = t, this.arrowNext = this.scrollbar.parentNode.querySelector(Al), this.arrowPrev = this.scrollbar.parentNode.querySelector(kl), this.scrollbar.hasAttribute(El) && (this.init(), this.listen()), this.scrollbar.hasAttribute(Sl) && this.scrollToVisibleElement()
        }
    };
    const xl = "[data-grid-swatch-form]",
        Ml = "[data-grid-item]",
        Pl = "[data-product-information]",
        Il = "[data-product-image]",
        Hl = "[data-swatch-button]",
        Ol = "[data-swatch-link]",
        Bl = "[data-swatch-text]",
        Dl = "[data-swatch-template]",
        Fl = "is-visible",
        $l = "hidden",
        _l = "no-events",
        Nl = "swatch",
        Rl = "data-swatch-handle",
        zl = "data-swatch-label",
        Wl = "data-scrollbar",
        Ul = "data-swatch-count",
        Vl = "data-tooltip",
        jl = "data-swatch-variant-name",
        Xl = "data-variant-title",
        Jl = "data-swatch-values";
    let Yl = class extends HTMLElement {
            connectedCallback() {
                this.hasAttribute(Vl) && new Wo(this)
            }
            constructor() {
                super()
            }
        },
        Ql = class extends HTMLElement {
            connectedCallback() {
                this.handle = this.getAttribute(Rl), this.productItem = this.closest(Ml), this.productInfo = this.closest(Pl), this.productImage = this.productItem.querySelector(Il), this.template = document.querySelector(Dl).innerHTML, this.swatchesJSON = this.getSwatchesJSON();
                const t = this.getAttribute(zl).trim().toLowerCase();
                (function(t) {
                    const e = `${window.theme.routes.root}products/${t}.js`;
                    return window.fetch(e).then((t => t.json())).catch((t => {
                        console.error(t)
                    }))
                })(this.handle).then((e => {
                    this.product = e, this.colorOption = e.options.find((function(e) {
                        return e.name.toLowerCase() === t || null
                    })), this.colorOption && (this.swatches = this.colorOption.values, this.init())
                }))
            }
            init() {
                this.innerHTML = "", this.count = 0, this.swatches.forEach((t => {
                    let e = null,
                        s = !1,
                        i = "";
                    for (const s of this.product.variants) {
                        const o = s.options.includes(t);
                        if (!e && o && (e = s), o && s.featured_media) {
                            i = s.featured_media.preview_image.src, e = s;
                            break
                        }
                    }
                    for (const e of this.product.variants) {
                        if (e.options.includes(t) && e.available) {
                            s = !0;
                            break
                        }
                    }
                    if (e) {
                        const r = document.createElement("div");
                        r.innerHTML = this.template;
                        const a = r.querySelector(Hl),
                            l = r.querySelector(Ol),
                            c = r.querySelector(Bl),
                            h = this.swatchesJSON[t],
                            d = e.title.replaceAll('"', "'");
                        a.style = `--animation-delay: ${100*this.count/1e3}s`, a.classList.add(`${Nl}-${h}`), a.dataset.tooltip = t, a.dataset.swatchVariant = e.id, a.dataset.swatchVariantName = d, a.dataset.swatchImage = i, a.dataset.variant = e.id, a.style.setProperty("--swatch", `var(--${h})`), l.href = (o = this.product.url, n = e.id, /variant=/.test(o) ? o.replace(/(variant=)[^&]+/, "$1" + n) : /\?/.test(o) ? o.concat("&variant=").concat(n) : o.concat("?variant=").concat(n)), l.dataset.swatch = t, l.disabled = !s, c.innerText = t, this.innerHTML += r.innerHTML, this.count++
                    }
                    var o, n
                })), this.swatchCount = this.productInfo.querySelector(`[${Ul}]`), this.swatchElements = this.querySelectorAll(Ol), this.swatchForm = this.productInfo.querySelector(xl), this.hideSwatchesTimer = 0, this.swatchCount.hasAttribute(Ul) && (this.swatchCount.innerText = `${this.count} ${this.count>1?theme.strings.otherColor:theme.strings.oneColor}`, this.swatchCount.addEventListener("mouseenter", (() => {
                    this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productInfo.classList.add(_l), this.swatchForm.classList.add(Fl)
                })), this.productInfo.addEventListener("mouseleave", (() => {
                    this.hideSwatchesTimer = setTimeout((() => {
                        this.productInfo.classList.remove(_l), this.swatchForm.classList.remove(Fl)
                    }), 100)
                }))), this.hasAttribute(Wl) && new ql(this), this.showDeferredImage(), this.bindSwatchButtonEvents()
            }
            showDeferredImage() {
                const t = this.productItem.querySelectorAll(`[${Xl}]`);
                t.length && this.productItem.addEventListener("mouseenter", (() => {
                    t.forEach((t => {
                        t.classList.remove($l)
                    }))
                }), {
                    once: !0
                })
            }
            bindSwatchButtonEvents() {
                var t;
                null === (t = this.querySelectorAll(Hl)) || void 0 === t || t.forEach((t => {
                    t.addEventListener("mouseenter", this.showVariantImageEvent), t.hasAttribute(Vl) && new Wo(t)
                })), this.productItem.addEventListener("mouseleave", this.productItemMouseLeaveEvent)
            }
            showVariantImage(t) {
                var e;
                const s = null === (e = t.target.getAttribute(jl)) || void 0 === e ? void 0 : e.replaceAll('"', "'"),
                    i = this.productImage.querySelectorAll(`[${Xl}]`),
                    o = this.productImage.querySelector(`[${Xl}="${s}"]`);
                null == i || i.forEach((t => {
                    t.classList.remove(Fl)
                })), null == o || o.classList.add(Fl)
            }
            hideVariantImages() {
                var t;
                null === (t = this.productImage.querySelectorAll(`[${Xl}].${Fl}`)) || void 0 === t || t.forEach((t => {
                    t.classList.remove(Fl)
                }))
            }
            getSwatchesJSON() {
                if (!this.hasAttribute(Jl)) return {};
                const t = this.getAttribute(Jl).split(","),
                    e = {};
                return null == t || t.forEach((t => {
                    const [s, i] = t.split(":");
                    e[s.trim()] = i.trim()
                })), e
            }
            constructor() {
                super(), this.productItemMouseLeaveEvent = () => this.hideVariantImages(), this.showVariantImageEvent = t => this.showVariantImage(t)
            }
        };
    const Gl = {
            productCutline: "[data-product-cutline]",
            productLink: "[data-product-link]",
            productGridItem: "[data-grid-item]",
            productInfo: "[data-product-information]",
            productImage: "[data-product-image-default]",
            productImageSibling: "[data-product-image-sibling]",
            productPrice: "[data-product-price]",
            siblingsInnerHolder: "[data-sibling-inner]",
            siblingCount: "[data-sibling-count]",
            siblingFieldset: "[data-sibling-fieldset]",
            siblingLink: "[data-sibling-link]",
            tooltip: "[data-tooltip]"
        },
        Kl = "is-visible",
        Zl = "is-fade",
        tc = "no-events",
        ec = "is-active",
        sc = "data-sibling-cutline",
        ic = "data-sibling-image",
        oc = "data-sibling-link",
        nc = "data-sibling-price",
        rc = "data-product-link";
    let ac = class extends HTMLElement {
        connectedCallback() {
            this.product = this.closest(Gl.productGridItem), this.siblingScrollbar = this.querySelector(Gl.siblingsInnerHolder), this.siblingCount = this.querySelector(Gl.siblingCount), this.siblingFieldset = this.querySelector(Gl.siblingFieldset), this.siblingLinks = this.querySelectorAll(Gl.siblingLink), this.productInfo = this.closest(Gl.productInfo), this.productLink = this.closest(Gl.link), this.hideSwatchesTimer = 0, this.initScrollbar(), this.siblingCount && this.siblingFieldset && this.productInfo && (this.siblingCount.addEventListener("mouseenter", (() => this.showSiblings())), this.productInfo.addEventListener("mouseleave", (() => this.hideSiblings()))), this.siblingLinks.length && new class {
                init() {
                    this.cacheDefaultValues(), this.product.addEventListener("mouseleave", (() => this.resetProductValues())), this.swatches.forEach((t => {
                        t.addEventListener("mouseenter", (t => this.showSibling(t)))
                    })), this.productLinks.length && this.swatches.forEach((t => {
                        t.addEventListener("click", (() => {
                            this.productLinks[0].click()
                        }))
                    }))
                }
                cacheDefaultValues() {
                    this.productLinkValue = this.productLinks[0].hasAttribute(rc) ? this.productLinks[0].getAttribute(rc) : "", this.productPriceValue = this.productPrice.innerHTML, this.productCutline && (this.productCutlineValue = this.productCutline.innerHTML)
                }
                resetProductValues() {
                    this.product.classList.remove(ec), this.productLinkValue && this.productLinks.forEach((t => {
                        t.href = this.productLinkValue
                    })), this.productPrice && (this.productPrice.innerHTML = this.productPriceValue), this.productCutline && this.productCutline && (this.productCutline.innerHTML = this.productCutlineValue, this.productCutline.title = this.productCutlineValue), this.hideSiblingImage()
                }
                showSibling(t) {
                    const e = t.target,
                        s = e.hasAttribute(oc) ? e.getAttribute(oc) : "",
                        i = e.hasAttribute(nc) ? e.getAttribute(nc) : "",
                        o = e.hasAttribute(sc) ? e.getAttribute(sc) : "",
                        n = e.hasAttribute(ic) ? e.getAttribute(ic) : "";
                    s && this.productLinks.forEach((t => {
                        t.href = s
                    })), i && (this.productPrice.innerHTML = i), o ? (this.productCutline.innerHTML = o, this.productCutline.title = o) : (this.productCutline.innerHTML = "", this.productCutline.title = ""), n && this.showSiblingImage(n)
                }
                showSiblingImage(t) {
                    if (!this.productImageSibling) return;
                    const e = window.devicePixelRatio || 1,
                        s = this.productImage.offsetWidth * e,
                        i = 180 * Math.ceil(s / 180),
                        o = r.getSizedImageUrl(t, `${i}x`),
                        n = this.productImageSibling.querySelector(`[src="${o}"]`),
                        a = () => {
                            this.productImageSibling.classList.add(Kl), this.productImageSibling.querySelector(`[src="${o}"]`).classList.add(Zl)
                        },
                        l = () => {
                            this.productImageSibling.querySelectorAll("img").forEach((t => {
                                t.classList.remove(Zl)
                            })), requestAnimationFrame(a)
                        };
                    if (n) l();
                    else {
                        const t = document.createElement("img");
                        t.src = o, this.productCutline && (t.alt = this.productCutline.innerText), t.addEventListener("load", (() => {
                            this.productImageSibling.append(t), l()
                        }))
                    }
                }
                hideSiblingImage() {
                    this.productImageSibling && (this.productImageSibling.classList.remove(Kl), this.productImageSibling.querySelectorAll("img").forEach((t => {
                        t.classList.remove(Zl)
                    })))
                }
                constructor(t, e) {
                    this.swatches = t, this.product = e, this.productLinks = this.product.querySelectorAll(Gl.productLink), this.productCutline = this.product.querySelector(Gl.productCutline), this.productPrice = this.product.querySelector(Gl.productPrice), this.productImage = this.product.querySelector(Gl.productImage), this.productImageSibling = this.product.querySelector(Gl.productImageSibling), this.init()
                }
            }(this.siblingLinks, this.product), this.querySelectorAll(Gl.tooltip).forEach((t => {
                new Wo(t)
            }))
        }
        showSiblings() {
            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productLink && this.productLink.classList.add(tc), this.siblingFieldset.classList.add(Kl)
        }
        hideSiblings() {
            this.hideSwatchesTimer = setTimeout((() => {
                this.productLink && this.productLink.classList.remove(tc), this.siblingFieldset.classList.remove(Kl)
            }), 100)
        }
        initScrollbar() {
            this.siblingScrollbar && new ql(this.siblingScrollbar)
        }
        constructor() {
            super()
        }
    };
    const lc = "body",
        cc = "[data-related-section]",
        hc = "[data-tabs-holder]",
        dc = "data-tab",
        uc = "data-tab-index",
        pc = "[data-aos]",
        mc = "data-block-id",
        vc = "[data-tab]",
        gc = ".tab-link",
        fc = ".tab-link__recent",
        yc = ".tab-content",
        bc = "[data-scrollbar]",
        wc = "current",
        Ec = "hidden",
        Sc = "aos-animate",
        Lc = "aos-no-transition",
        kc = "is-focused",
        Ac = {};
    const Cc = {
        onLoad() {
            Ac[this.id] = [];
            this.container.querySelectorAll(hc).forEach((t => {
                Ac[this.id].push(new class {
                    init() {
                        const t = this.container.querySelectorAll(vc);
                        this.container.addEventListener("theme:tab:check", (() => this.checkRecentTab())), this.container.addEventListener("theme:tab:hide", (() => this.hideRelatedTab())), t.length && t.forEach((t => {
                            const e = parseInt(t.getAttribute(dc)),
                                s = this.container.querySelector(`${yc}-${e}`);
                            t.addEventListener("click", (() => {
                                this.tabChange(t, s)
                            })), t.addEventListener("keyup", (e => {
                                "Space" !== e.code && "Enter" !== e.code || !this.body.classList.contains(kc) || this.tabChange(t, s)
                            }))
                        }))
                    }
                    tabChange(t, e) {
                        if (t.classList.contains(wc)) return;
                        const s = this.container.querySelector(`${vc}.${wc}`),
                            i = this.container.querySelector(`${yc}.${wc}`);
                        null == s || s.classList.remove(wc), null == i || i.classList.remove(wc), t.classList.add(wc), e.classList.add(wc), t.classList.contains(Ec) && e.classList.add(Ec), this.accessibility.a11y.removeTrapFocus(), this.container.dispatchEvent(new CustomEvent("theme:tab:change", {
                            bubbles: !0
                        })), t.dispatchEvent(new CustomEvent("theme:form:sticky", {
                            bubbles: !0,
                            detail: {
                                element: "tab"
                            }
                        })), this.animateItems(e)
                    }
                    animateItems(t, e = !0) {
                        const s = t.querySelectorAll(pc);
                        s.length && s.forEach((t => {
                            t.classList.remove(Sc), e && (t.classList.add(Lc), requestAnimationFrame((() => {
                                t.classList.remove(Lc), t.classList.add(Sc)
                            })))
                        }))
                    }
                    initNativeScrollbar() {
                        this.scrollbarHolder.length && this.scrollbarHolder.forEach((t => {
                            new ql(t)
                        }))
                    }
                    checkRecentTab() {
                        const t = this.container.querySelector(fc);
                        if (t) {
                            t.classList.remove(Ec);
                            const e = parseInt(t.getAttribute(dc)),
                                s = this.container.querySelector(`${yc}[${uc}="${e}"]`);
                            s && (s.classList.remove(Ec), this.animateItems(s, !1)), this.initNativeScrollbar()
                        }
                    }
                    hideRelatedTab() {
                        const t = this.container.querySelector(cc);
                        if (!t) return;
                        const e = t.closest(`${yc}.${wc}`);
                        if (!e) return;
                        const s = parseInt(e.getAttribute(uc)),
                            i = this.container.querySelectorAll(vc);
                        if (i.length > s) {
                            const t = i[s].nextSibling;
                            t && (i[s].classList.add(Ec), t.dispatchEvent(new Event("click")), this.initNativeScrollbar())
                        }
                    }
                    onBlockSelect(t) {
                        const e = this.container.querySelector(`${gc}[${mc}="${t.detail.blockId}"]`);
                        e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({
                            top: 0,
                            left: e.offsetLeft - e.clientWidth,
                            behavior: "smooth"
                        }))
                    }
                    constructor(t) {
                        this.container = t, this.body = document.querySelector(lc), this.accessibility = window.accessibility, this.container && (this.scrollbarHolder = this.container.querySelectorAll(bc), this.init(), this.initNativeScrollbar())
                    }
                }(t))
            }))
        },
        onBlockSelect(t) {
            Ac[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        }
    };

    function Tc() {
        const t = Boolean(document.querySelectorAll("dialog[open][data-scroll-lock-required]").length),
            e = Boolean(document.querySelectorAll(".drawer.is-open").length);
        return t || e
    }
    const qc = {
            added: "is-added",
            animated: "is-animated",
            disabled: "is-disabled",
            error: "has-error",
            loading: "is-loading",
            open: "is-open",
            overlayText: "product-item--overlay-text",
            visible: "is-visible",
            siblingLinkCurrent: "sibling__link--current"
        },
        xc = 3e3,
        Mc = "[data-animation]",
        Pc = "[data-api-content]",
        Ic = "[data-quick-add-btn]",
        Hc = "[data-add-to-cart]",
        Oc = "cart-drawer",
        Bc = "[data-cart-page]",
        Dc = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Fc = "[data-message-error]",
        $c = "[data-quick-add-modal-handle]",
        _c = "[data-product-upsell-ajax]",
        Nc = "[data-quick-add-modal-close]",
        Rc = "data-grid-item",
        zc = "[data-product-information]",
        Wc = "[data-quick-add-holder]",
        Uc = "[data-quick-add-modal]",
        Vc = "[data-quick-add-modal-template]",
        jc = "closing",
        Xc = "data-product-id",
        Jc = "data-quick-add-modal-handle",
        Yc = "data-sibling-swapper",
        Qc = "data-quick-add-holder";
    let Gc = class extends HTMLElement {
        connectedCallback() {
            this.modalButton && this.modalButton.addEventListener("click", this.modalButtonClickEvent), this.buttonATC && this.cart && this.buttonATC.addEventListener("click", (t => {
                t.preventDefault(), window.accessibility.lastElement = this.buttonATC, document.dispatchEvent(new CustomEvent("theme:cart:add", {
                    detail: {
                        button: this.buttonATC
                    }
                }))
            })), this.quickAddHolder && (this.quickAddHolder.addEventListener("animationend", this.quickAddLoadingToggle), this.errorHandler())
        }
        modalButtonClickEvent(t) {
            t.preventDefault();
            const e = this.modalButton.hasAttribute(Yc),
                s = this.modalButton.classList.contains(qc.siblingLinkCurrent);
            s || (this.modalButton.classList.add(qc.loading), this.modalButton.disabled = !0, e && !s && (this.currentModal = t.target.closest(Uc), this.currentModal.classList.add(qc.loading)), this.renderModal())
        }
        modalCreate(t) {
            const e = document.querySelector(`${Uc}[${Xc}="${this.productId}"]`);
            if (e) this.modal = e, this.modalOpen();
            else {
                const e = this.quickAddHolder.querySelector(Vc);
                if (!e) return;
                const s = document.createElement("div");
                s.innerHTML = e.innerHTML, document.body.appendChild(s.querySelector(Uc)), e.remove(), this.modal = document.querySelector(`${Uc}[${Xc}="${this.productId}"]`), this.modal.querySelector(_c).innerHTML = (new DOMParser).parseFromString(t, "text/html").querySelector(Pc).innerHTML, this.modalCreatedCallback()
            }
        }
        modalOpen() {
            this.currentModal && this.currentModal.dispatchEvent(new CustomEvent("theme:modal:close", {
                bubbles: !1
            })), "function" == typeof this.modal.show && this.modal.show(), this.modal.setAttribute("open", !0), this.modal.removeAttribute("inert"), this.quickAddHolder.classList.add(qc.disabled), this.modalButton && (this.modalButton.classList.remove(qc.loading), this.modalButton.disabled = !1, window.accessibility.lastElement = this.modalButton), requestAnimationFrame((() => {
                this.modal.querySelectorAll(Mc).forEach((t => {
                    t.classList.add(qc.animated)
                }))
            })), document.dispatchEvent(new CustomEvent("theme:quick-add:open", {
                bubbles: !0
            })), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), document.addEventListener("theme:product:added", this.modalCloseOnProductAdded, {
                once: !0
            })
        }
        modalClose() {
            if (!this.isAnimating) {
                if (!this.modal.hasAttribute(jc)) return this.modal.setAttribute(jc, ""), void(this.isAnimating = !0);
                "function" == typeof this.modal.close ? this.modal.close() : this.modal.removeAttribute("open"), this.modal.removeAttribute(jc), this.modal.setAttribute("inert", ""), this.modal.classList.remove(qc.loading), this.modalButton && (this.modalButton.disabled = !1), this.quickAddHolder && this.quickAddHolder.classList.contains(qc.disabled) && this.quickAddHolder.classList.remove(qc.disabled), this.resetAnimatedItems(), Tc() || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0
                })), document.removeEventListener("theme:product:added", this.modalCloseOnProductAdded), this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()
            }
        }
        modalEvents() {
            var t;
            null === (t = this.modal.querySelector(Nc)) || void 0 === t || t.addEventListener("click", (t => {
                t.preventDefault(), this.modalClose()
            })), this.modal.addEventListener("click", (t => {
                "DIALOG" === t.target.nodeName && "click" === t.type && this.modalClose()
            })), this.modal.addEventListener("keydown", (t => {
                "Escape" == t.code && (t.preventDefault(), this.modalClose())
            })), this.modal.addEventListener("theme:modal:close", (() => {
                this.modalClose()
            })), this.modal.addEventListener("animationend", (t => {
                t.target === this.modal && (this.isAnimating = !1, this.modal.hasAttribute(jc) ? this.modalClose() : setTimeout((() => {
                    this.a11y.trapFocus(this.modal);
                    const t = this.modal.querySelector("[autofocus]") || this.modal.querySelector(Dc);
                    null == t || t.focus()
                }), 50))
            }))
        }
        modalCloseOnProductAdded() {
            this.resetQuickAddButtons(), this.modal && this.modal.hasAttribute("open") && this.modalClose()
        }
        quickAddLoadingToggle(t) {
            t.target == this.quickAddHolder && this.quickAddHolder.classList.remove(qc.disabled)
        }
        errorHandler() {
            this.quickAddHolder.addEventListener("theme:cart:error", (t => {
                const e = t.detail.holder,
                    s = e.closest(`[${Rc}]`);
                if (!s) return;
                const i = e.querySelector(Fc),
                    o = s.classList.contains(qc.overlayText),
                    n = s.querySelector(zc),
                    r = e.querySelector(Hc);
                r && (r.classList.remove(qc.added, qc.loading), e.classList.add(qc.error)), i && (i.innerText = t.detail.description), o && n.classList.add(qc.hidden), setTimeout((() => {
                    this.resetQuickAddButtons(), o && n.classList.remove(qc.hidden)
                }), xc)
            }))
        }
        resetQuickAddButtons() {
            this.quickAddHolder && this.quickAddHolder.classList.remove(qc.visible, qc.error), this.buttonQuickAdd && (this.buttonQuickAdd.classList.remove(qc.added), this.buttonQuickAdd.disabled = !1)
        }
        renderModal() {
            this.modal ? this.modalOpen() : window.fetch(`${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`).then(this.upsellErrorsHandler).then((t => t.text())).then((t => {
                this.modalCreate(t)
            }))
        }
        modalCreatedCallback() {
            this.modalEvents(), this.modalOpen(), I(this.modal)
        }
        upsellErrorsHandler(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new He({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        resetAnimatedItems() {
            var t;
            null === (t = this.modal) || void 0 === t || t.querySelectorAll(Mc).forEach((t => {
                t.classList.remove(qc.animated)
            }))
        }
        constructor() {
            var t;
            (super(), this.container = this, this.cart = document.querySelector(Oc) || document.querySelector(Bc), this.quickAddHolder = this.container.querySelector(Wc), this.quickAddHolder) && (this.modal = null, this.currentModal = null, this.productId = this.quickAddHolder.getAttribute(Qc), this.modalButton = this.quickAddHolder.querySelector($c), this.handle = null === (t = this.modalButton) || void 0 === t ? void 0 : t.getAttribute(Jc), this.cartDrawer = document.querySelector(Oc), this.buttonQuickAdd = this.quickAddHolder.querySelector(Ic), this.buttonATC = this.quickAddHolder.querySelector(Hc), this.button = this.modalButton || this.buttonATC, this.modalClose = this.modalClose.bind(this), this.modalCloseOnProductAdded = this.modalCloseOnProductAdded.bind(this), this.a11y = z, this.isAnimating = !1, this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this), this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this))
        }
    };
    Po("product-grid", [Cc]), customElements.get("quick-add-product") || customElements.define("quick-add-product", Gc), customElements.get("radio-swatch") || customElements.define("radio-swatch", Yl), customElements.get("grid-swatch") || customElements.define("grid-swatch", Ql), customElements.get("product-siblings") || customElements.define("product-siblings", ac);
    const Kc = "complementary-products",
        Zc = "quick-add-product",
        th = "is-loaded",
        eh = "data-url";
    let sh = class extends HTMLElement {
        connectedCallback() {
            new IntersectionObserver(((t, e) => {
                t[0].isIntersecting && (e.unobserve(this), this.hasAttribute(eh) && "" !== this.getAttribute(eh) && fetch(this.getAttribute(eh)).then((t => t.text())).then((t => {
                    const e = document.createElement("div");
                    e.innerHTML = t;
                    const s = e.querySelector(Kc);
                    s && s.innerHTML.trim().length && (this.innerHTML = s.innerHTML), e.querySelector(`${Kc} ${Zc}`) && this.classList.add(th)
                })).catch((t => {
                    console.error(t)
                })))
            }).bind(this), {
                rootMargin: "0px 0px 400px 0px"
            }).observe(this)
        }
        constructor() {
            super()
        }
    };
    const ih = 'input:not([type="checkbox"]):not([type="hidden"]), textarea',
        oh = 'input[type="email"]',
        nh = 'input[type="checkbox"]',
        rh = "[data-form-wrapper]";
    let ah = class extends HTMLElement {
        connectedCallback() {
            this.fieldCheckbox && (this.fieldCheckbox.addEventListener("change", this.onChangeEvent), this.form && this.form.addEventListener("theme:product:add", (() => {
                this.fieldCheckbox.checked = !1, this.fieldCheckbox.dispatchEvent(new Event("change"))
            })))
        }
        clearInputValues() {
            this.fields.length && this.fields.forEach((t => {
                t.value = ""
            }))
        }
        onChange(t) {
            this.fieldEmail.required = Boolean(t.target.checked), t.target.checked || this.clearInputValues()
        }
        disconnectedCallback() {
            this.fieldCheckbox.removeEventListener("change", this.onChangeEvent)
        }
        constructor() {
            super(), this.fieldCheckbox = this.querySelector(nh), this.fieldEmail = this.querySelector(oh), this.fields = this.querySelectorAll(ih), this.form = this.closest(rh), this.onChangeEvent = t => this.onChange(t)
        }
    };
    const lh = ".product__page",
        ch = "[data-form-wrapper]",
        hh = "[data-header-sticky]",
        dh = "[data-product-media-list]",
        uh = "is-sticky",
        ph = "data-sticky-enabled";
    window.theme.variables = {
        productPageSticky: !1
    };
    const mh = {};
    const vh = {
            onLoad() {
                mh[this.id] = new class {
                    init() {
                        this.stickyEnabled && (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)), this.initSticky()
                    }
                    initSticky() {
                        theme.variables.productPageSticky && (this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition())), this.formWrapper.addEventListener("theme:form:sticky", this.stickyFormEvent), document.addEventListener("theme:scroll", this.scrollEvent))
                    }
                    stickyFormEvents(t) {
                        this.removeAnimationFrameSticky(), this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition(t)))
                    }
                    scrollEvents(t) {
                        this.scrollTop = t.detail.position, this.scrollDirectionDown = t.detail.down, this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition())))
                    }
                    resizeEvents(t) {
                        this.stickyScrollCheck(), document.removeEventListener("theme:scroll", this.scrollEvent), this.formWrapper.removeEventListener("theme:form:sticky", this.stickyFormEvent), this.initSticky()
                    }
                    stickyScrollCheck() {
                        const t = this.container.querySelector(`${lh} ${ch}`);
                        if (t)
                            if (y()) {
                                const e = this.container.querySelector(ch),
                                    s = this.container.querySelector(dh);
                                if (!e || !s) return;
                                e.offsetHeight < s.offsetHeight ? (theme.variables.productPageSticky = !0, t.classList.add(uh)) : (theme.variables.productPageSticky = !1, t.classList.remove(uh))
                            } else theme.variables.productPageSticky = !1, t.classList.remove(uh)
                    }
                    calculateStickyPosition(t = null) {
                        if (document.documentElement.hasAttribute("data-scroll-locked")) return void this.removeAnimationFrameSticky();
                        const e = Boolean(t && t.detail),
                            s = Boolean(e && t.detail.element && "accordion" === t.detail.element),
                            i = this.formWrapper.offsetHeight,
                            o = window.innerHeight - i - this.defaultTopBottomSpacings,
                            n = Math.abs(this.scrollTop - this.scrollLastPosition);
                        if (this.scrollDirectionDown ? this.stickyScrollTop -= n : this.stickyScrollTop += n, this.stickyFormLoad) {
                            if (document.querySelector(hh)) {
                                let {
                                    headerHeight: t
                                } = c();
                                this.stickyDefaultTop = t
                            } else this.stickyDefaultTop = this.defaultTopBottomSpacings;
                            this.stickyScrollTop = this.stickyDefaultTop
                        }
                        this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, o), this.stickyDefaultTop);
                        const r = this.stickyScrollTop - this.currentPoint;
                        this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + .5 * r, this.formWrapper.style.setProperty("--sticky-top", `${this.currentPoint}px`), this.scrollLastPosition = this.scrollTop, this.stickyFormLoad = !1, s && this.onChangeCounter <= 10 || s && this.stickyFormLastHeight !== i || this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky ? (s && (this.onChangeCounter += 1), s && this.stickyFormLastHeight !== i && (this.onChangeCounter = 11), this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition(t)))) : this.requestAnimationSticky && this.removeAnimationFrameSticky(), this.stickyFormLastHeight = i
                    }
                    removeAnimationFrameSticky() {
                        this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), this.requestAnimationSticky = null, this.onChangeCounter = 0)
                    }
                    onUnload() {
                        this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent), theme.variables.productPageSticky && document.removeEventListener("theme:scroll", this.scrollEvent)
                    }
                    constructor(t) {
                        this.section = t, this.container = t.container, this.stickyEnabled = "true" === this.container.getAttribute(ph), this.formWrapper = this.container.querySelector(ch), this.stickyScrollTop = 0, this.scrollLastPosition = 0, this.stickyDefaultTop = 0, this.currentPoint = 0, this.defaultTopBottomSpacings = 30, this.scrollTop = window.scrollY, this.scrollDirectionDown = !0, this.requestAnimationSticky = null, this.stickyFormLoad = !0, this.stickyFormLastHeight = null, this.onChangeCounter = 0, this.scrollEvent = t => this.scrollEvents(t), this.resizeEvent = t => this.resizeEvents(t), this.stickyFormEvent = t => this.stickyFormEvents(t), setTimeout((() => {
                            this.init()
                        }), 50)
                    }
                }(this)
            },
            onUnload() {
                mh[this.id].onUnload()
            }
        },
        gh = "data-section-type",
        fh = "[data-share-button]",
        yh = "[data-share-message]",
        bh = "is-visible";
    let wh = class extends HTMLElement {
        init() {
            navigator.share ? this.shareButton.addEventListener("click", (() => {
                navigator.share({
                    url: this.urlToShare,
                    title: document.title
                })
            })) : this.shareButton.addEventListener("click", this.copyToClipboard.bind(this))
        }
        updateShareLink() {
            "product" == this.container.getAttribute(gh) && this.container.addEventListener("theme:variant:change", (t => {
                t.detail.variant && (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${t.detail.variant.id}`)
            }))
        }
        copyToClipboard() {
            navigator.clipboard.writeText(this.urlToShare).then((() => {
                this.shareMessage.classList.add(bh);
                const t = () => {
                    this.shareMessage.classList.remove(bh), this.shareMessage.removeEventListener("animationend", t)
                };
                this.shareMessage.addEventListener("animationend", t)
            }))
        }
        constructor() {
            super(), this.container = this.closest(`[${gh}]`), this.shareButton = this.querySelector(fh), this.shareMessage = this.querySelector(yh), this.urlToShare = this.shareButton.dataset.shareUrl ? this.shareButton.dataset.shareUrl : document.location.href, this.init(), this.updateShareLink()
        }
    };
    const Eh = "[data-button-arrow]",
        Sh = "[data-deferred-media-button]",
        Lh = "model-viewer, video, iframe, button, [href], input, [tabindex]",
        kh = "[data-image-id]",
        Ah = "[data-product-media-list]",
        Ch = "[data-section-type]",
        Th = "slider__arrows",
        qh = "is-dragging",
        xh = "is-focused",
        Mh = "media--active",
        Ph = "media--hidden",
        Ih = "media--hiding",
        Hh = "data-active-media",
        Oh = "data-button-prev",
        Bh = "data-button-next",
        Dh = "data-image-id",
        Fh = "data-media-id",
        $h = "data-fader-desktop",
        _h = "data-fader-mobile";
    let Nh = class extends HTMLElement {
        connectedCallback() {
            this.productMediaObserver(), this.toggleEvents(), this.listen(), this.setHeight()
        }
        disconnectedCallback() {
            this.unlisten()
        }
        listen() {
            document.addEventListener("theme:resize:width", this.toggleEvents), document.addEventListener("theme:resize:width", this.setHeight), this.addEventListener("theme:media:select", this.selectMediaEvent)
        }
        unlisten() {
            document.removeEventListener("theme:resize:width", this.toggleEvents), document.removeEventListener("theme:resize:width", this.setHeight), this.removeEventListener("theme:media:select", this.selectMediaEvent)
        }
        toggleEvents() {
            const t = b();
            t && this.hasAttribute(_h) || !t && this.hasAttribute($h) ? this.bindEventListeners() : this.unbindEventListeners()
        }
        bindEventListeners() {
            this.initialized || (this.productMediaList.addEventListener("mousedown", this.handleMouseDown), this.productMediaList.addEventListener("mouseleave", this.handleMouseLeave), this.productMediaList.addEventListener("mouseup", this.handleMouseUp), this.productMediaList.addEventListener("mousemove", this.handleMouseMove), this.productMediaList.addEventListener("touchstart", this.handleMouseDown, {
                passive: !0
            }), this.productMediaList.addEventListener("touchend", this.handleMouseUp, {
                passive: !0
            }), this.productMediaList.addEventListener("touchmove", this.handleMouseMove, {
                passive: !0
            }), this.productMediaList.addEventListener("keyup", this.handleKeyUp), this.initArrows(), this.resetScrollPosition(), this.initialized = !0)
        }
        unbindEventListeners() {
            this.initialized && (this.productMediaList.removeEventListener("mousedown", this.handleMouseDown), this.productMediaList.removeEventListener("mouseleave", this.handleMouseLeave), this.productMediaList.removeEventListener("mouseup", this.handleMouseUp), this.productMediaList.removeEventListener("mousemove", this.handleMouseMove), this.productMediaList.removeEventListener("touchstart", this.handleMouseDown), this.productMediaList.removeEventListener("touchend", this.handleMouseUp), this.productMediaList.removeEventListener("touchmove", this.handleMouseMove), this.productMediaList.removeEventListener("keyup", this.handleKeyUp), this.removeArrows(), this.initialized = !1)
        }
        handleMouseDown(t) {
            this.isDown = !0, this.startX = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft, this.startY = (t.pageY || t.changedTouches[0].screenY) - this.offsetTop
        }
        handleMouseLeave() {
            this.isDown && (this.isDown = !1)
        }
        handleMouseUp(t) {
            const e = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft,
                s = (t.pageY || t.changedTouches[0].screenY) - this.offsetTop,
                i = e - this.startX,
                o = s - this.startY,
                n = i > 0 ? 1 : -1;
            Math.abs(i) > 10 && Math.abs(i) > Math.abs(o) && (n < 0 ? this.showNextImage() : this.showPreviousImage()), this.isDown = !1, requestAnimationFrame((() => {
                this.classList.remove(qh)
            }))
        }
        handleMouseMove() {
            this.isDown && this.classList.add(qh)
        }
        handleKeyUp(t) {
            "ArrowLeft" === t.code && this.showPreviousImage(), "ArrowRight" === t.code && this.showNextImage()
        }
        handleArrowsClickEvent() {
            var t;
            null === (t = this.querySelectorAll(Eh)) || void 0 === t || t.forEach((t => {
                t.addEventListener("click", (t => {
                    t.preventDefault(), t.target.hasAttribute(Oh) && this.showPreviousImage(), t.target.hasAttribute(Bh) && this.showNextImage()
                }))
            }))
        }
        resetScrollPosition() {
            0 !== this.productMediaList.scrollLeft && (this.productMediaList.scrollLeft = 0)
        }
        initArrows() {
            if (!this.buttons.length) {
                const t = document.createElement("div");
                t.classList.add(Th), t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next, this.productMediaList.append(t), this.buttons = this.querySelectorAll(Eh), this.buttonPrev = this.querySelector(`[${Oh}]`), this.buttonNext = this.querySelector(`[${Bh}]`)
            }
            this.handleArrowsClickEvent(), this.preloadImageOnArrowHover()
        }
        removeArrows() {
            var t;
            null === (t = this.querySelector(`.${Th}`)) || void 0 === t || t.remove()
        }
        preloadImageOnArrowHover() {
            var t, e;
            null === (t = this.buttonPrev) || void 0 === t || t.addEventListener("mouseover", (() => {
                const t = this.getPreviousMediaId();
                this.preloadImage(t)
            })), null === (e = this.buttonNext) || void 0 === e || e.addEventListener("mouseover", (() => {
                const t = this.getNextMediaId();
                this.preloadImage(t)
            }))
        }
        preloadImage(t) {
            var e;
            null === (e = this.querySelector(`[${Fh}="${t}"] img`)) || void 0 === e || e.setAttribute("loading", "eager")
        }
        showMediaOnVariantSelect(t) {
            const e = t.detail.id;
            this.setActiveMedia(e)
        }
        getCurrentMedia() {
            return this.querySelector(`${kh}.${Mh}`)
        }
        getNextMediaId() {
            const t = this.getCurrentMedia(),
                e = (null == t ? void 0 : t.nextElementSibling.hasAttribute(Dh)) ? null == t ? void 0 : t.nextElementSibling : this.querySelector(kh);
            return null == e ? void 0 : e.getAttribute(Fh)
        }
        getPreviousMediaId() {
            const t = this.getCurrentMedia(),
                e = this.productMediaItems.length - 1,
                s = (null == t ? void 0 : t.previousElementSibling) || this.productMediaItems[e];
            return null == s ? void 0 : s.getAttribute(Fh)
        }
        showNextImage() {
            const t = this.getNextMediaId();
            this.selectMedia(t)
        }
        showPreviousImage() {
            const t = this.getPreviousMediaId();
            this.selectMedia(t)
        }
        selectMedia(t) {
            this.dispatchEvent(new CustomEvent("theme:media:select", {
                detail: {
                    id: t
                }
            }))
        }
        setActiveMedia(t) {
            if (!t) return;
            this.setAttribute(Hh, t);
            const e = this.querySelector(`${kh}.${Mh}`),
                s = this.querySelector(`[${Fh}="${t}"]`),
                i = null == s ? void 0 : s.querySelector(Lh),
                o = s.querySelector("deferred-media");
            var n;
            (null == e || e.classList.add(Ih), null == e || e.classList.remove(Mh), null == s || s.classList.remove(Ih, Ph), null == s || s.classList.add(Mh), o && !0 !== o.getAttribute("loaded")) && (null === (n = s.querySelector(Sh)) || void 0 === n || n.dispatchEvent(new Event("click", {
                bubbles: !1
            })));
            requestAnimationFrame((() => {
                this.setHeight(), document.body.classList.contains(xh) && (null == i || i.focus())
            }))
        }
        setHeight() {
            var t, e;
            const s = (null === (t = this.querySelector(`${kh}.${Mh}`)) || void 0 === t ? void 0 : t.offsetHeight) || (null === (e = this.productMediaItems[0]) || void 0 === e ? void 0 : e.offsetHeight);
            this.style.setProperty("--height", `${s}px`)
        }
        productMediaObserver() {
            this.productMediaItems.forEach((t => {
                t.addEventListener("transitionend", (e => {
                    e.target == t && t.classList.contains(Ih) && (t.classList.remove(Ih), t.classList.add(Ph))
                })), t.addEventListener("transitioncancel", (e => {
                    e.target == t && t.classList.contains(Ih) && (t.classList.remove(Ih), t.classList.add(Ph))
                }))
            }))
        }
        constructor() {
            super(), this.initialized = !1, this.buttons = !1, this.isDown = !1, this.startX = 0, this.startY = 0, this.scrollLeft = 0, this.onButtonArrowClick = t => this.buttonArrowClickEvent(t), this.container = this.closest(Ch), this.handleMouseDown = this.handleMouseDown.bind(this), this.handleMouseLeave = this.handleMouseLeave.bind(this), this.handleMouseUp = this.handleMouseUp.bind(this), this.handleMouseMove = this.handleMouseMove.bind(this), this.handleKeyUp = this.handleKeyUp.bind(this), this.productMediaItems = this.querySelectorAll(kh), this.productMediaList = this.querySelector(Ah), this.setHeight = this.setHeight.bind(this), this.toggleEvents = this.toggleEvents.bind(this), this.selectMediaEvent = t => this.showMediaOnVariantSelect(t)
        }
    };
    const Rh = "data-option-position",
        zh = '[name^="options"], [data-popout-option]',
        Wh = '[name^="options"]:checked, [name^="options"][type="hidden"]',
        Uh = "data-value",
        Vh = "[data-popout]",
        jh = "sold-out",
        jhh = "sold-outt",
        Xh = "unavailable",
        Xhh = "unavailablee",
        Jh = "sale";
    const Yh = "[data-product]",
        Qh = "[data-product-form]",
        Gh = "[data-add-to-cart]",
        Kh = "[data-add-to-cart-text]",
        Zh = "cart-drawer",
        td = "[data-cart-page]",
        ed = "[data-compare-price]",
        sd = "[data-compare-text]",
        id = "[data-form-wrapper]",
        od = "[data-product-select]",
        nd = "[data-price-wrapper]",
        rd = "product-images",
        ad = "[data-product-media-list]",
        ld = "[data-product-json]",
        cd = "[data-product-price]",
        hd = "[data-product-unit-price]",
        dd = "[data-product-base]",
        ud = "[data-product-unit]",
        pd = "[data-product-preorder]",
        md = "[data-subscription-watch-price]",
        vd = "[data-subscription-selectors]",
        gd = "[data-toggles-group]",
        fd = "data-group-toggle",
        yd = "[data-plan-description]",
        bd = "[data-section-type]",
        wd = "[data-quick-add-modal]",
        Ed = "[data-price-off]",
        Sd = "[data-price-off-type]",
        Ld = "[data-price-off-amount]",
        kd = "[data-remaining-count]",
        Ad = "[data-remaining-max]",
        Cd = "[data-remaining-wrapper]",
        Td = "[data-product-remaining-json]",
        qd = "[data-option-value]",
        xd = "[data-option-position]",
        Md = "[data-product-form-installment]",
        Pd = 'input[name="id"]',
        Id = "hidden",
        Hd = "variant--soldout",
        Od = "variant--unavailable",
        Bd = "product__price--sale",
        Dd = "count-is-low",
        Fd = "count-is-in",
        $d = "count-is-out",
        _d = "count-is-unavailable",
        Nd = "data-remaining-max",
        Rd = "data-enable-history-state",
        zd = "data-fader-desktop",
        Wd = "data-fader-mobile",
        Ud = "data-option-position",
        Vd = "data-image-id",
        jd = "data-media-id",
        Xd = "data-quick-add-btn";
    let Jd = class extends HTMLElement {
        connectedCallback() {
            if (this.cartAddEvents(), this.container = this.closest(bd) || this.closest(wd), !this.container) return;
            if (this.sectionId = this.container.dataset.sectionId, this.product = this.container.querySelector(Yh), this.productForm = this.container.querySelector(Qh), this.productImages = this.container.querySelector(rd), this.productMediaList = this.container.querySelector(ad), this.installmentForm = this.container.querySelector(Md), this.sellout = null, this.priceOffWrap = this.container.querySelector(Ed), this.priceOffAmount = this.container.querySelector(Ld), this.priceOffType = this.container.querySelector(Sd), this.planDescription = this.container.querySelector(yd), this.remainingWrapper = this.container.querySelector(Cd), this.remainingWrapper) {
                const t = this.container.querySelector(Ad);
                t && (this.remainingMaxInt = parseInt(t.getAttribute(Nd), 10), this.remainingCount = this.container.querySelector(kd), this.remainingJSONWrapper = this.container.querySelector(Td), this.remainingJSON = null, this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML) : console.warn("Missing product quantity JSON"))
            }
            this.enableHistoryState = "true" === this.container.getAttribute(Rd), this.hasUnitPricing = this.container.querySelector(ud), this.subSelectors = this.container.querySelector(vd), this.subPrices = this.container.querySelector(md), this.isPreOrder = this.container.querySelector(pd);
            let t = null;
            const e = this.container.querySelector(ld);
            e && (t = e.innerHTML), t ? (this.productJSON = JSON.parse(t), this.linkForm(), this.sellout = new class {
                init() {
                    this.update()
                }
                update() {
                    window.thiss = this;
                    if(window.thiss.productJSON.options.length < 2){
                       this.getCurrentState(), this.optionElements.forEach((t => {
                            const e = t.closest(`[${Rh}]`);
                            if (!e) return;
                            const s = t.value || t.getAttribute(Uh),
                                i = e.getAttribute(Rh),
                                o = parseInt(i, 10) - 1,
                                n = t.closest(Vh);
                            let r = [...this.selections];
                            r[o] = s;
                            const a = this.productJSON.variants.find((t => {
                                let e = !0;
                                for (let s = 0; s < r.length; s++) t.options[s] !== r[s] && (e = !1);
                                return e
                            }));
                            t.classList.remove(jh, Xh), t.parentNode.classList.remove(Jh), n && n.classList.remove(jh, Xh, Jh), void 0 === a ? (t.classList.add(Xh), n && n.classList.add(Xh)) : a && !1 === a.available && (t.classList.add(jh), n && n.classList.add(jh)), a && a.compare_at_price > a.price && theme.settings.variantOnSale && t.parentNode.classList.add(Jh)
                        })) 
                    }else{
                        console.log('here')
                    }
                    
                }
                getCurrentState() {
                    this.selections = [];
                    const t = this.container.querySelectorAll(Wh);
                    t.length && t.forEach((t => {
                        const e = t.value;
                        e && "" !== e && this.selections.push(e)
                    }))
                }
                constructor(t, e) {
                    this.container = t, this.productJSON = e, this.optionElements = this.container.querySelectorAll(zh), this.productJSON && this.optionElements.length && this.init()
                }
            }(this.container, this.productJSON)) : console.error("Missing product JSON")
        }
        cartAddEvents() {
            this.buttonATC = this.querySelector(Gh);
            const t = document.querySelector(Zh) || document.querySelector(td);
            this.buttonATC && t && this.buttonATC.addEventListener("click", (t => {
                t.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:add", {
                    detail: {
                        button: this.buttonATC
                    },
                    bubbles: !1
                })), this.closest(wd) || (window.accessibility.lastElement = this.buttonATC)
            }))
        }
        destroy() {
            this.productForm.destroy()
        }
        linkForm() {
            this.productForm = new class {
                destroy() {
                    this._listeners.removeAll()
                }
                options() {
                    return this._serializeInputValues(this.optionInputs, (function(t) {
                        return t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2], t
                    }))
                }
                variant() {
                    const t = this.options();
                    return t.length ? ml(this.product, t) : this.product.variants[0]
                }
                plan(t) {
                    let e = {
                        allocation: null,
                        group: null,
                        detail: null
                    };
                    const s = this.element.querySelector(`${fl}:checked`);
                    if (!s) return null;
                    const i = s.value,
                        o = i && "" !== i ? i : null;
                    return o && t && (e.allocation = t.selling_plan_allocations.find((function(t) {
                        return t.selling_plan_id.toString() === o.toString()
                    }))), e.allocation && (e.group = this.product.selling_plan_groups.find((function(t) {
                        return t.id.toString() === e.allocation.selling_plan_group_id.toString()
                    }))), e.group && (e.detail = e.group.selling_plans.find((function(t) {
                        return t.id.toString() === o.toString()
                    }))), e && e.allocation && e.detail && e.allocation ? e : null
                }
                properties() {
                    return this._serializeInputValues(this.propertyInputs, (function(t) {
                        return t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2], t
                    }))
                }
                quantity() {
                    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1
                }
                getFormState() {
                    const t = this.variant();
                    return {
                        options: this.options(),
                        variant: t,
                        properties: this.properties(),
                        quantity: this.quantity(),
                        plan: this.plan(t)
                    }
                }
                _setIdInputValue(t) {
                    t && t.id ? this.variantElement.value = t.id.toString() : this.variantElement.value = "", this.variantElement.dispatchEvent(new Event("change"))
                }
                _onSubmit(t, e) {
                    e.dataset = this.getFormState(), t.onFormSubmit && t.onFormSubmit(e)
                }
                _onOptionChange(t) {
                    this._setIdInputValue(t.dataset.variant)
                }
                _onFormEvent(t) {
                    return void 0 === t ? Function.prototype.bind() : function(e) {
                        e.dataset = this.getFormState(), this._setIdInputValue(e.dataset.variant), t(e)
                    }.bind(this)
                }
                _initInputs(t, e) {
                    return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(function(t) {
                        return this._listeners.add(t, "change", this._onFormEvent(e)), t
                    }.bind(this))
                }
                _serializeInputValues(t, e) {
                    return t.reduce((function(t, s) {
                        return (s.checked || "radio" !== s.type && "checkbox" !== s.type) && t.push(e({
                            name: s.name,
                            value: s.value
                        })), t
                    }), [])
                }
                _validateProductObject(t) {
                    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                    if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                    return t
                }
                constructor(t, e, s) {
                    this.element = t, this.product = this._validateProductObject(e), this.variantElement = this.element.querySelector(gl), s = s || {}, this._listeners = new pl, this._listeners.add(this.element, "submit", this._onSubmit.bind(this, s)), this.optionInputs = this._initInputs(yl, s.onOptionChange), this.planInputs = this._initInputs(fl, s.onPlanChange), this.quantityInputs = this._initInputs(bl, s.onQuantityChange), this.propertyInputs = this._initInputs(wl, s.onPropertyChange)
                }
            }(this.container, this.productJSON, {
                onOptionChange: this.onOptionChange.bind(this),
                onPlanChange: this.onPlanChange.bind(this)
            }), this.pushState(this.productForm.getFormState(), !0), this.subsToggleListeners()
        }
        onOptionChange(t) {
            this.pushState(t.dataset), this.updateProductImage(t)
        }
        onPlanChange(t) {
            this.subPrices && this.pushState(t.dataset)
        }
        pushState(t, e = !1) {
            var s;
            this.productState = this.setProductState(t), this.updateAddToCartState(t), this.updateProductPrices(t), this.updateSaleText(t), this.updateSubscriptionText(t), this.updateRemaining(t), this.updateLegend(t), this.fireHookEvent(t), null === (s = this.sellout) || void 0 === s || s.update(t), this.enableHistoryState && !e && this.updateHistoryState(t)
        }
        updateAddToCartState(t) {
            const e = t.variant;
            let s = theme.strings.addToCart;
            const i = this.container.querySelectorAll(nd),
                o = this.container.querySelectorAll(Gh),
                n = this.container.querySelectorAll(Kh),
                r = this.container.querySelectorAll(id);
            if (this.installmentForm && e) {
                const t = this.installmentForm.querySelector(Pd);
                t.value = e.id, t.dispatchEvent(new Event("change", {
                    bubbles: !0
                }))
            }
            this.isPreOrder && (s = theme.strings.preOrder), i.length && e && i.forEach((t => {
                t.classList.remove(Id)
            })), o.length && o.forEach((t => {
                t.hasAttribute(Xd) || (e && e.available ? t.disabled = !1 : t.disabled = !0)
            })), n.length && n.forEach((t => {
                e ? e.available ? t.innerHTML = s : t.innerHTML = theme.strings.soldOut : t.innerHTML = theme.strings.unavailable
            })), r.length && r.forEach((t => {
                if (e) {
                    e.available ? t.classList.remove(Hd, Od) : (t.classList.add(Hd), t.classList.remove(Od));
                    const s = t.querySelector(od);
                    s && (s.value = e.id);
                    const i = t.querySelector(`${Pd}[form]`);
                    i && (i.value = e.id, i.dispatchEvent(new Event("change")))
                } else t.classList.add(Od), t.classList.remove(Hd)
            }))
        }
        updateHistoryState(t) {
            const e = t.variant,
                s = t.plan,
                i = window.location.href;
            if (e && i.includes("/product")) {
                const t = new window.URL(i),
                    o = t.searchParams;
                o.set("variant", e.id), s && s.detail && s.detail.id && this.productState.hasPlan ? o.set("selling_plan", s.detail.id) : o.delete("selling_plan"), t.search = o.toString();
                const n = t.toString();
                window.history.replaceState({
                    path: n
                }, "", n)

               // add to show hide
            console.log(e.id,'cliekddd')
            let addToCartButton = document.querySelector(".Bydefault_atc");
            let slected_size = document.querySelector('button#select_sizes')
            if(e.id && addToCartButton && slected_size){         
            slected_size.style.display = 'none'
            addToCartButton.style.display = 'block'
            }else if(addToCartButton&& slected_size){
            slected_size.style.display = 'block'
            addToCartButton.style.display = 'none'
            }
            // -----

              
            }
        }
        updateRemaining(t) {
            var e;
            const s = t.variant;
            if (null === (e = this.remainingWrapper) || void 0 === e || e.classList.remove(Fd, $d, _d, Dd), s && this.remainingWrapper && this.remainingJSON) {
                const t = this.remainingJSON[s.id];
                ("out" === t || t < 1) && this.remainingWrapper.classList.add($d), ("in" === t || t >= this.remainingMaxInt) && this.remainingWrapper.classList.add(Fd), ("low" === t || t > 0 && t < this.remainingMaxInt) && (this.remainingWrapper.classList.add(Dd), this.remainingCount && (this.remainingCount.innerHTML = t))
            } else !s && this.remainingWrapper && this.remainingWrapper.classList.add(_d)
        }
        getBaseUnit(t) {
            return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit
        }
        subsToggleListeners() {
            this.container.querySelectorAll(gd).forEach((t => {
                t.addEventListener("change", function(t) {
                    const e = t.target.value.toString(),
                        s = this.container.querySelector(`[${fd}="${e}"]`),
                        i = this.container.querySelectorAll(`[${fd}]`);
                    if (s) {
                        s.classList.remove(Id);
                        const t = s.querySelector('[name="selling_plan"]');
                        t.checked = !0, t.dispatchEvent(new Event("change"))
                    }
                    i.forEach((t => {
                        if (t !== s) {
                            t.classList.add(Id);
                            t.querySelectorAll('[name="selling_plan"]').forEach((t => {
                                t.checked = !1, t.dispatchEvent(new Event("change"))
                            }))
                        }
                    }))
                }.bind(this))
            }))
        }
        updateSaleText(t) {
            this.productState.planSale ? this.updateSaleTextSubscription(t) : this.productState.onSale ? this.updateSaleTextStandard(t) : this.priceOffWrap && this.priceOffWrap.classList.add(Id)
        }
        updateSaleTextStandard(t) {
            if (this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"), this.priceOffAmount && this.priceOffWrap) {
                const e = t.variant,
                    s = (e.compare_at_price - e.price) / e.compare_at_price,
                    i = Math.floor(100 * s);
                this.priceOffAmount.innerHTML = `${i}%`, this.priceOffWrap.classList.remove(Id)
            }
        }
        updateSubscriptionText(t) {
            t.plan && this.planDescription ? (this.planDescription.innerHTML = t.plan.detail.description, this.planDescription.classList.remove(Id)) : this.planDescription && this.planDescription.classList.add(Id)
        }
        updateSaleTextSubscription(t) {
            if (this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton"), this.priceOffAmount && this.priceOffWrap) {
                const e = t.plan.detail.price_adjustments[0],
                    i = e.value;
                e && "percentage" === e.value_type ? this.priceOffAmount.innerHTML = `${i}%` : this.priceOffAmount.innerHTML = s.formatMoney(i, theme.moneyFormat), this.priceOffWrap.classList.remove(Id)
            }
        }
        updateProductPrices(t) {
            const e = t.variant,
                i = t.plan;
            this.container.querySelectorAll(nd).forEach((t => {
                const o = t.querySelector(ed),
                    n = t.querySelector(cd),
                    r = t.querySelector(sd);
                let a = "",
                    l = "";
                this.productState.available && (a = e.compare_at_price, l = e.price), this.productState.hasPlan && (l = i.allocation.price), this.productState.planSale && (a = i.allocation.compare_at_price, l = i.allocation.price), o && (this.productState.onSale || this.productState.planSale ? (o.classList.remove(Id), r.classList.remove(Id), n.classList.add(Bd)) : (o.classList.add(Id), r.classList.add(Id), n.classList.remove(Bd)), o.innerHTML = s.formatMoney(a, theme.moneyFormat)), n.innerHTML = 0 === l ? window.theme.strings.free : s.formatMoney(l, theme.moneyFormat)
            })), this.hasUnitPricing && this.updateProductUnits(t)
        }
        updateProductUnits(t) {
            const e = t.variant,
                i = t.plan;
            let o = null;
            if (e && e.unit_price && (o = e.unit_price), i && i.allocation && i.allocation.unit_price && (o = i.allocation.unit_price), o) {
                const t = this.getBaseUnit(e),
                    i = s.formatMoney(o, theme.moneyFormat);
                this.container.querySelector(hd).innerHTML = i, this.container.querySelector(dd).innerHTML = t, Pe(this.container.querySelector(ud))
            } else(n = this.container.querySelector(ud)) && (n.style.display = "none");
            var n
        }
        fireHookEvent(t) {
            const e = t.variant;
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", {
                detail: {
                    variant: e
                },
                bubbles: !0
            }))
        }
        setProductState(t) {
            const e = t.variant,
                s = t.plan,
                i = {
                    available: !0,
                    soldOut: !1,
                    onSale: !1,
                    showUnitPrice: !1,
                    requiresPlan: !1,
                    hasPlan: !1,
                    planPerDelivery: !1,
                    planSale: !1
                };
            return !e || e.requires_selling_plan && !s ? i.available = !1 : (e.available || (i.soldOut = !0), e.compare_at_price > e.price && (i.onSale = !0), e.unit_price && (i.showUnitPrice = !0), this.product && this.product.requires_selling_plan && (i.requiresPlan = !0), s && this.subPrices && (i.hasPlan = !0, s.allocation.per_delivery_price !== s.allocation.price && (i.planPerDelivery = !0), e.price > s.allocation.price && (i.planSale = !0))), i
        }
        updateProductImage(t) {
            const e = t.dataset.variant;
            if (e && e.featured_media) {
                const t = this.container.querySelector(`[${Vd}="${e.featured_media.id}"]`);
                if (t) {
                    const e = t.getAttribute(jd),
                        s = y();
                    if (t.dispatchEvent(new CustomEvent("theme:media:select", {
                            bubbles: !0,
                            detail: {
                                id: e
                            }
                        })), s && !this.productImages.hasAttribute(zd)) {
                        const e = t.getBoundingClientRect().top;
                        document.dispatchEvent(new CustomEvent("theme:tooltip:close", {
                            bubbles: !1,
                            detail: {
                                hideTransition: !1
                            }
                        })), bn(e)
                    }
                    s || this.productImages.hasAttribute(Wd) || this.productMediaList.scrollTo({
                        left: t.offsetLeft
                    })
                }
            }
        }
        updateLegend(t) {
            const e = t.variant;
            if (e) {
                const t = this.container.querySelectorAll(qd);
                t.length && t.forEach((t => {
                    const s = t.closest(xd);
                    if (s) {
                        const i = s.getAttribute(Ud),
                            o = parseInt(i, 10) - 1,
                            n = e.options[o];
                        t.innerHTML = n
                    }
                }))
            }
        }
        constructor() {
            super()
        }
    };
    const Yd = "[data-image-id]",
        Qd = "product-images",
        Gd = "[data-section-type]",
        Kd = "[data-thumb-item]",
        Zd = "[data-thumb-link]",
        tu = "[data-thumbs-slider]",
        eu = "data-active-media",
        su = "data-media-id",
        iu = "is-active";
    class ou extends HTMLElement {
        connectedCallback() {
            this.handleEvents(), this.preloadImagesOnHover(), this.activeMediaObserver()
        }
        disconnectedCallback() {
            this.observer && this.observer.disconnect()
        }
        activeMediaObserver() {
            this.observer = new MutationObserver((t => {
                for (const e of t) "attributes" === e.type && e.attributeName == eu && this.setActiveThumb()
            })), this.observer.observe(this.productImagesContainer, {
                attributes: !0,
                childList: !1,
                subtree: !1
            })
        }
        handleEvents() {
            this.thumbLinks.forEach((t => {
                t.addEventListener("click", (e => {
                    e.preventDefault();
                    const s = t.closest(Kd),
                        i = t.getAttribute(su);
                    s.classList.contains(iu) || this.dispatchEvent(new CustomEvent("theme:media:select", {
                        bubbles: !0,
                        detail: {
                            id: i
                        }
                    }))
                })), t.addEventListener("keyup", (e => {
                    if ("Enter" === e.code) {
                        var s;
                        const e = t.getAttribute(su),
                            i = null === (s = this.productImagesContainer.querySelector(`[${su}="${e}"]`)) || void 0 === s ? void 0 : s.querySelectorAll('model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])')[0];
                        i && (i.dispatchEvent(new Event("focus")), i.dispatchEvent(new Event("select")))
                    }
                }))
            }))
        }
        preloadImagesOnHover() {
            this.thumbLinks.forEach((t => {
                t.addEventListener("mouseover", (() => {
                    const e = t.getAttribute(su),
                        s = this.productImagesContainer.querySelector(`[${su}="${e}"] img`);
                    null == s || s.setAttribute("loading", "eager")
                }))
            }))
        }
        setActiveThumb() {
            var t;
            const e = this.productImagesContainer.getAttribute(eu),
                s = this.querySelector(`[${su}="${e}"]`);
            null === (t = this.querySelector(`${Kd}.${iu}`)) || void 0 === t || t.classList.remove(iu), null == s || s.parentNode.classList.add(iu), requestAnimationFrame((() => {
                this.scrollToThumb()
            }))
        }
        scrollToThumb() {
            const t = this.thumbSlider;
            if (t) {
                const e = t.querySelector(`.${iu}`);
                if (!e) return;
                const s = t.scrollTop,
                    i = t.scrollLeft,
                    o = t.offsetWidth,
                    n = t.offsetHeight,
                    r = s + n,
                    a = i + o,
                    l = e.offsetTop,
                    c = e.offsetLeft,
                    h = e.offsetWidth,
                    d = e.offsetHeight,
                    u = s > l,
                    p = i > c,
                    m = c + h > a,
                    v = l + d > r || u,
                    g = m || p,
                    f = b();
                if (v || g) {
                    let e = l - n + d,
                        s = c - o + h;
                    u && (e = l), m && f && (s += parseInt(window.getComputedStyle(t).paddingRight)), p && (s = c, f && (s -= parseInt(window.getComputedStyle(t).paddingLeft))), t.scrollTo({
                        top: e,
                        left: s,
                        behavior: "smooth"
                    })
                }
            }
        }
        constructor() {
            super(), this.container = this.closest(Gd), this.productImages = this.container.querySelectorAll(Yd), this.productImagesContainer = this.container.querySelector(Qd), this.productThumbs = this.container.querySelectorAll(Kd), this.thumbSlider = this.querySelector(tu), this.thumbLinks = this.querySelectorAll(Zd)
        }
    }
    const nu = "[data-popup-open]",
        ru = "[data-popup-close]",
        au = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        lu = "closing";
    let cu = class {
        popupOpen() {
            this.popup && (this.showModal && "function" == typeof this.popup.showModal ? this.popup.showModal() : this.showModal || "function" != typeof this.popup.show || this.popup.show(), this.popup.setAttribute("open", !0), this.popup.removeAttribute("inert"), this.popup.dispatchEvent(new CustomEvent("theme:popup:open", {
                bubbles: !1
            })), this.enableScrollLock && document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })))
        }
        popupClose() {
            if (!this.isAnimating && this.popup && !this.popup.hasAttribute("inert")) {
                if (!this.popup.hasAttribute(lu)) return this.popup.setAttribute(lu, ""), void(this.isAnimating = !0);
                "function" == typeof this.popup.close ? this.popup.close() : this.popup.removeAttribute("open"), this.popup.removeAttribute(lu), this.popup.setAttribute("inert", ""), !Tc() && this.enableScrollLock && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0
                })), this.popup.dispatchEvent(new CustomEvent("theme:popup:onclose", {
                    bubbles: !1
                })), this.enableScrollLock && (this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement())
            }
        }
        popupEvents() {
            var t;
            if (!this.popup) return;
            null === (t = this.buttonPopupOpen) || void 0 === t || t.addEventListener("click", (t => {
                t.preventDefault(), this.popupOpen(), window.accessibility.lastElement = this.buttonPopupOpen
            }));
            const e = this.popup.querySelectorAll(ru);
            e.length && e.forEach((t => {
                t.addEventListener("click", (t => {
                    t.preventDefault(), this.popupClose()
                }))
            })), this.showModal && this.popup.addEventListener("click", (t => {
                "DIALOG" === t.target.nodeName && "click" === t.type && this.popupClose()
            })), this.popup.addEventListener("keydown", (t => {
                "Escape" === t.code && (t.preventDefault(), this.popupClose())
            })), this.popup.addEventListener("theme:popup:close", (() => {
                this.popupClose()
            })), this.popup.addEventListener("animationend", (t => {
                if (t.target === this.popup)
                    if (this.isAnimating = !1, this.popup.hasAttribute(lu)) this.popupClose();
                    else {
                        this.enableScrollLock && this.a11y.trapFocus(this.popup);
                        const t = this.popup.querySelector("[autofocus]") || this.popup.querySelector(au);
                        null == t || t.focus()
                    }
            }))
        }
        constructor(t, e, s = !0, i = !0) {
            var o;
            this.popup = t, this.holder = e, this.a11y = z, this.isAnimating = !1, this.showModal = s, this.enableScrollLock = i, this.buttonPopupOpen = null === (o = this.holder) || void 0 === o ? void 0 : o.querySelector(nu), this.popupEvents()
        }
    };
    const hu = "dialog";
    let du = class extends HTMLElement {
            connectedCallback() {
                new cu(this.querySelector(hu), this, !0, !0)
            }
            constructor() {
                super()
            }
        },
        uu = class extends Kt {
            loadContent() {
                super.loadContent(), Shopify.loadFeatures([{
                    name: "model-viewer-ui",
                    version: "1.0",
                    onLoad: this.setupModelViewerUI.bind(this)
                }])
            }
            setupModelViewerUI(t) {
                t || (this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer")))
            }
            constructor() {
                super()
            }
        };
    window.ProductModel = {
        loadShopifyXR() {
            Shopify.loadFeatures([{
                name: "shopify-xr",
                version: "1.0",
                onLoad: this.setupShopifyXR.bind(this)
            }])
        },
        setupShopifyXR(t) {
            t || (window.ShopifyXR ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach((t => {
                window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove()
            })), window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", (() => this.setupShopifyXR())))
        }
    }, window.addEventListener("DOMContentLoaded", (() => {
        window.ProductModel && window.ProductModel.loadShopifyXR()
    }));
    const pu = "data-store-availability-container",
        mu = ".shopify-section",
        vu = "[data-pickup-drawer]",
        gu = "[data-section-type]",
        fu = "hidden";
    let yu = class extends HTMLElement {
        connectedCallback() {
            this.container = this.closest(gu), this.drawer = null, this.container.addEventListener("theme:variant:change", (t => this.fetchPickupAvailability(t))), this.fetchPickupAvailability()
        }
        fetchPickupAvailability(t) {
            if (t && !t.detail.variant || t && t.detail.variant && !t.detail.variant.available) return void this.classList.add(fu);
            const e = t && t.detail.variant ? t.detail.variant.id : this.getAttribute(pu);
            e && (this.popupActions = null, fetch(`${window.theme.routes.root}variants/${e}/?section_id=api-pickup-availability`).then(this.handleErrors).then((t => t.text())).then((t => {
                const e = (new DOMParser).parseFromString(t, "text/html").querySelector(mu).innerHTML;
                this.innerHTML = e, this.drawer = this.querySelector(vu), this.drawer ? (this.classList.remove(fu), this.popupActions = new cu(this.drawer, this, !0, !0)) : this.classList.add(fu)
            })).catch((t => {
                console.error(t)
            })))
        }
        handleErrors(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new He({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        constructor() {
            super()
        }
    };
    const bu = {};

    function wu(t = {}) {
        if (t.type || (t.type = "json"), t.url) return bu[t.url] ? bu[t.url] : function(t, e) {
            const s = new Promise(((s, i) => {
                "text" === e ? fetch(t).then((t => t.text())).then((t => {
                    s(t)
                })).catch((t => {
                    i(t)
                })) : function(t, e, s) {
                    let i = document.getElementsByTagName("head")[0],
                        o = !1,
                        n = document.createElement("script");
                    n.src = t, n.onload = n.onreadystatechange = function() {
                        o || this.readyState && "loaded" != this.readyState && "complete" != this.readyState ? s() : (o = !0, e())
                    }, i.appendChild(n)
                }(t, (function() {
                    s()
                }), (function() {
                    i()
                }))
            }));
            return bu[t] = s, s
        }(t.url, t.type);
        if (t.json) return bu[t.json] ? Promise.resolve(bu[t.json]) : window.fetch(t.json).then((t => t.json())).then((e => (bu[t.json] = e, e)));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return bu[e] ? bu[e] : function(t) {
                const e = "".concat(t.name, t.version),
                    s = new Promise(((e, s) => {
                        try {
                            window.Shopify.loadFeatures([{
                                name: t.name,
                                version: t.version,
                                onLoad: t => {
                                    ! function(t, e, s) {
                                        s ? e(s) : t()
                                    }(e, s, t)
                                }
                            }])
                        } catch (t) {
                            s(t)
                        }
                    }));
                return bu[e] = s, s
            }(t)
        }
        return Promise.reject()
    }
    window.isYoutubeAPILoaded = !1, window.isVimeoAPILoaded = !1;
    const Eu = ".pswp",
        Su = ".pswp__custom-close",
        Lu = "iframe, video",
        ku = ".pswp__thumbs",
        Au = "is-current",
        Cu = "pswp--custom-loader",
        Tu = "pswp--custom-opening",
        qu = "pswp__loader",
        xu = "is-focused",
        Mu = "data-pswp-option-classes",
        Pu = "aria-current",
        Iu = `<div class="${qu}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
    let Hu = class {
        init() {
            this.pswpElement.classList.add(Tu), this.initLoader(), wu({
                url: window.theme.assets.photoswipe
            }).then((() => this.loadPopup())).catch((t => console.error(t)))
        }
        initLoader() {
            if (this.pswpElement.classList.contains(Cu) && "" !== this.options && this.options.mainClass) {
                this.pswpElement.setAttribute(Mu, this.options.mainClass);
                let t = document.createElement("div");
                t.innerHTML = Iu, t = t.firstChild, this.pswpElement.appendChild(t)
            } else this.pswpElement.setAttribute(Mu, "")
        }
        loadPopup() {
            const t = window.themePhotoswipe.PhotoSwipe.default,
                e = window.themePhotoswipe.PhotoSwipeUI.default;
            this.pswpElement.classList.contains(Cu) && this.pswpElement.classList.remove(Cu), this.pswpElement.classList.remove(Tu), this.popup = new t(this.pswpElement, e, this.items, this.options), this.popup.init(), this.thumbsActions(), document.body.classList.contains(xu) && setTimeout((() => {
                this.a11y.trapFocus(this.pswpElement, {
                    elementToFocus: this.closeBtn
                })
            }), 200), this.popup.listen("close", (() => this.onClose())), this.options && this.options.closeElClasses && this.options.closeElClasses.length && this.options.closeElClasses.forEach((t => {
                const e = this.pswpElement.querySelector(`.pswp__${t}`);
                e && e.addEventListener("keyup", this.keyupCloseEvent)
            }))
        }
        thumbsActions() {
            this.popupThumbsContainer && this.popupThumbsContainer.children.length && (this.popupThumbsContainer.addEventListener("wheel", (t => this.stopDisabledScroll(t))), this.popupThumbsContainer.addEventListener("mousewheel", (t => this.stopDisabledScroll(t))), this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t => this.stopDisabledScroll(t))), this.popupThumbs = this.pswpElement.querySelectorAll(`${ku} > *`), this.popupThumbs.forEach(((t, e) => {
                t.addEventListener("click", (s => {
                    s.preventDefault();
                    const i = t.parentElement.querySelector(`.${Au}`);
                    i.classList.remove(Au), i.setAttribute(Pu, !1), t.classList.add(Au), t.setAttribute(Pu, !0), this.popup.goTo(e)
                }))
            })), this.popup.listen("imageLoadComplete", (() => this.setCurrentThumb())), this.popup.listen("beforeChange", (() => this.setCurrentThumb())))
        }
        stopDisabledScroll(t) {
            t.stopPropagation()
        }
        keyupClose(t) {
            "Enter" === t.code && this.popup.close()
        }
        onClose() {
            const t = this.pswpElement.querySelector(Lu);
            if (t && t.parentNode.removeChild(t), this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
                for (; this.popupThumbsContainer.firstChild;) this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
            this.pswpElement.setAttribute(Mu, "");
            const e = this.pswpElement.querySelector(`.${qu}`);
            e && this.pswpElement.removeChild(e), this.options && this.options.closeElClasses && this.options.closeElClasses.length && this.options.closeElClasses.forEach((t => {
                const e = this.pswpElement.querySelector(`.pswp__${t}`);
                e && e.removeEventListener("keyup", this.keyupCloseEvent)
            })), this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()
        }
        setCurrentThumb() {
            const t = this.pswpElement.querySelector(`${ku} > .${Au}`);
            if (t && (t.classList.remove(Au), t.setAttribute(Pu, !1)), !this.popupThumbs) return;
            const e = this.popupThumbs[this.popup.getCurrentIndex()];
            e.classList.add(Au), e.setAttribute(Pu, !0), this.scrollThumbs(e)
        }
        scrollThumbs(t) {
            const e = this.popupThumbsContainer.scrollLeft + this.popupThumbsContainer.offsetWidth,
                s = t.offsetLeft;
            if (e <= s + t.offsetWidth || e > s) {
                const e = parseInt(window.getComputedStyle(t).marginLeft);
                this.popupThumbsContainer.scrollTo({
                    top: 0,
                    left: s - e,
                    behavior: "smooth"
                })
            }
        }
        constructor(t, e = "") {
            this.items = t, this.pswpElement = document.querySelectorAll(Eu)[0], this.popup = null, this.popupThumbs = null, this.popupThumbsContainer = this.pswpElement.querySelector(ku), this.closeBtn = this.pswpElement.querySelector(Su), this.keyupCloseEvent = t => this.keyupClose(t), this.a11y = z;
            this.options = "" !== e ? e : {
                history: !1,
                focus: !1,
                mainClass: ""
            }, this.init()
        }
    };
    const Ou = "[data-zoom-caption]",
        Bu = "[data-zoom-image]",
        Du = "[data-pswp-thumbs-template]",
        Fu = "[data-section-type]",
        $u = ".pswp__thumbs",
        _u = "product-images",
        Nu = "is-dragging",
        Ru = "variant--soldout",
        zu = "variant--unavailable",
        Wu = "pswp-zoom-gallery",
        Uu = "pswp-zoom-gallery--single",
        Vu = "data-image-src",
        ju = "data-image-width",
        Xu = "data-image-height";
    let Ju = class extends HTMLElement {
        connectedCallback() {
            this.images.forEach(((t, e) => {
                t.addEventListener("click", (s => {
                    s.preventDefault(), t.closest(_u).classList.contains(Nu) || (this.createZoom(e), window.accessibility.lastElement = t)
                })), t.addEventListener("keyup", (s => {
                    "Enter" === s.code && (s.preventDefault(), this.createZoom(e), window.accessibility.lastElement = t)
                }))
            }))
        }
        createZoom(t) {
            const e = this.container.querySelector(Du),
                s = null == e ? void 0 : e.innerHTML;
            let i = [],
                o = 0;
            this.images.forEach((e => {
                const n = e.getAttribute(Vu);
                if (o += 1, i.push({
                        src: n,
                        w: parseInt(e.getAttribute(ju)),
                        h: parseInt(e.getAttribute(Xu)),
                        msrc: n
                    }), this.images.length === o) {
                    new Hu(i, {
                        history: !1,
                        focus: !1,
                        index: t,
                        mainClass: 1 === o ? `${Wu} ${Uu}` : `${Wu}`,
                        showHideOpacity: !0,
                        howAnimationDuration: 150,
                        hideAnimationDuration: 250,
                        closeOnScroll: !1,
                        closeOnVerticalDrag: !1,
                        captionEl: !0,
                        closeEl: !0,
                        closeElClasses: ["caption-close", "title"],
                        tapToClose: !1,
                        clickToCloseNonZoomable: !1,
                        maxSpreadZoom: 2,
                        loop: !0,
                        spacing: 0,
                        allowPanToNext: !0,
                        pinchToClose: !1,
                        addCaptionHTMLFn: (t, e, s) => {
                            this.zoomCaption(t, e, s)
                        },
                        getThumbBoundsFn: () => {
                            const e = this.images[t],
                                s = window.scrollY || document.documentElement.scrollTop,
                                i = e.getBoundingClientRect();
                            return {
                                x: i.left,
                                y: i.top + s,
                                w: i.width
                            }
                        }
                    }), this.thumbsContainer && "" !== s && (this.thumbsContainer.innerHTML = s)
                }
            }))
        }
        zoomCaption(t, e) {
            let s = "";
            const i = e.children[0];
            return this.zoomCaptions && (s = this.zoomCaptions.innerHTML, this.zoomCaptions.closest(`.${Ru}`) ? i.classList.add(Ru) : i.classList.remove(Ru), this.zoomCaptions.closest(`.${zu}`) ? i.classList.add(zu) : i.classList.remove(zu)), i.innerHTML = s, !1
        }
        constructor() {
            super(), this.container = this.closest(Fu), this.images = this.querySelectorAll(Bu), this.zoomCaptions = this.container.querySelector(Ou), this.thumbsContainer = document.querySelector($u)
        }
    };
    const Yu = "[data-add-to-cart]",
        Qu = "[data-product-json]",
        Gu = "[data-product-form]",
        Ku = "#cart-bar",
        Zu = ".product__submit__add",
        tp = "[data-form-wrapper]",
        ep = "[data-product-variants]",
        sp = "[data-slider]",
        ip = "is-visible",
        op = "is-loading",
        np = "data-cart-bar-enabled",
        rp = "data-add-to-cart-bar",
        ap = "data-cart-bar-scroll",
        lp = "data-section-id",
        cp = "data-slider-index",
        hp = {};
    const dp = {
        onLoad() {
            hp[this.id] = new class {
                initCartBar() {
                    this.cartBarBtn = this.cartBar.querySelector(Zu), this.cartBarBtn && (this.cartBarBtn.addEventListener("click", (t => {
                        t.preventDefault(), t.currentTarget.hasAttribute(rp) ? (this.cartBarEnabled && (t.currentTarget.classList.add(op), t.currentTarget.setAttribute("disabled", "disabled")), this.form.querySelector(Yu).dispatchEvent(new Event("click", {
                            bubbles: !0
                        }))) : t.currentTarget.hasAttribute(ap) && this.scrollToTop()
                    })), this.cartBarBtn.hasAttribute(rp) && document.addEventListener("theme:product:add-error", this.scrollToTop)), this.setCartBarHeight()
                }
                scrollToTop() {
                    const t = this.container.querySelector(ep),
                        e = (y() ? this.container : t || this.form).getBoundingClientRect().top;
                    bn(y() ? e : e - 10)
                }
                toggleCartBarOnScroll() {
                    const t = window.scrollY,
                        e = theme.variables.productPageSticky && this.formWrapper ? this.formWrapper : this.form;
                    if (e && this.cartBar) {
                        const s = t > e.offsetTop + e.offsetHeight;
                        this.cartBar.classList.toggle(ip, s)
                    }
                }
                setCartBarHeight() {
                    const t = this.cartBar.offsetHeight;
                    document.documentElement.style.setProperty("--cart-bar-height", `${t}px`)
                }
                onUnload() {
                    document.removeEventListener("theme:product:add-error", this.scrollToTop), this.cartBarEnabled && (document.removeEventListener("theme:scroll", this.toggleCartBarOnScroll), document.removeEventListener("theme:resize", this.setCartBarHeight))
                }
                onBlockSelect(t) {
                    const e = t.srcElement.closest(sp);
                    if (e && this.slider.length) {
                        const s = e.hasAttribute(cp) ? e.getAttribute(cp) : 0;
                        if (!this.slider[s]) return;
                        this.slider[s].onBlockSelect(t)
                    }
                }
                onBlockDeselect(t) {
                    const e = t.srcElement.closest(sp);
                    if (e && this.slider.length) {
                        const s = e.hasAttribute(cp) ? e.getAttribute(cp) : 0;
                        if (!this.slider[s]) return;
                        this.slider[s].onBlockDeselect(t)
                    }
                }
                constructor(t) {
                    this.section = t, this.container = t.container, this.id = this.container.getAttribute(lp), this.sliders = this.container.querySelectorAll(sp), this.slider = [], this.formWrapper = this.container.querySelector(tp), this.cartBarEnabled = this.container.hasAttribute(np), this.cartBar = this.container.querySelector(Ku), this.setCartBarHeight = this.setCartBarHeight.bind(this), this.scrollToTop = this.scrollToTop.bind(this), this.toggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this), this.unlockTimer = 0, this.accessibility = z;
                    const e = this.container.querySelector(Qu);
                    if (e && !e.innerHTML || !e) return;
                    const s = JSON.parse(e.innerHTML).handle;
                    let i = {};
                    s && (i = {
                        handle: s
                    }), Shopify.Products.recordRecentlyViewed(i), this.form = this.container.querySelector(Gu), this.sliders.length && this.sliders.forEach(((t, e) => {
                        t.setAttribute(cp, e), this.slider.push(new fn(this.container, t))
                    })), this.cartBarEnabled && (this.initCartBar(), this.setCartBarHeight(), document.addEventListener("theme:scroll", this.toggleCartBarOnScroll), document.addEventListener("theme:resize", this.setCartBarHeight))
                }
            }(this)
        },
        onUnload(t) {
            hp[this.id].onUnload(t)
        },
        onBlockSelect(t) {
            hp[this.id].onBlockSelect(t)
        },
        onBlockDeselect(t) {
            hp[this.id].onBlockDeselect(t)
        }
    };
    Po("product", [dp, Uo, Cc, vh]), customElements.get("complementary-products") || customElements.define("complementary-products", sh), customElements.get("pickup-availability") || customElements.define("pickup-availability", yu), customElements.get("product-form") || customElements.define("product-form", Jd), customElements.get("product-images") || customElements.define("product-images", Nh), customElements.get("product-thumbs") || customElements.define("product-thumbs", ou), customElements.get("product-modal") || customElements.define("product-modal", du), customElements.get("product-model") || customElements.define("product-model", uu), customElements.get("product-siblings") || customElements.define("product-siblings", ac), customElements.get("radio-swatch") || customElements.define("radio-swatch", Yl), customElements.get("recipient-form") || customElements.define("recipient-form", ah), customElements.get("share-button") || customElements.define("share-button", wh), customElements.get("zoom-images") || customElements.define("zoom-images", Ju);
    const up = "[data-api-related-template]",
        pp = "[data-related-section]",
        mp = "[data-grid-item]",
        vp = "[data-recent-wrapper]",
        gp = "[data-recently-viewed-wrapper]",
        fp = ".product-item",
        yp = "grid-slider",
        bp = "data-limit",
        wp = "data-minimum",
        Ep = "data-product-id",
        Sp = "is-hidden",
        Lp = {};
    const kp = {
        onLoad() {
            Lp[this.id] = new class {
                related() {
                    const t = this.container.querySelector(pp);
                    if (!t) return;
                    const e = t.getAttribute(Ep),
                        s = t.getAttribute(bp),
                        i = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${s}&product_id=${e}&intent=related`;
                    fetch(i).then((t => t.text())).then((e => {
                        const s = document.createElement("div");
                        s.innerHTML = (new DOMParser).parseFromString(e, "text/html").querySelector(up).innerHTML, s.querySelector(mp) ? t.innerHTML = s.innerHTML : t.dispatchEvent(new CustomEvent("theme:tab:hide", {
                            bubbles: !0
                        }))
                    })).catch((function() {
                        t.dispatchEvent(new CustomEvent("theme:tab:hide", {
                            bubbles: !0
                        }))
                    }))
                }
                recent() {
                    const t = this.container.querySelector(vp),
                        e = t ? parseInt(t.getAttribute(bp)) : 4;
                    Shopify.Products.showRecentlyViewed({
                        howManyToShow: e,
                        wrapperId: `recently-viewed-products-${this.sectionId}`,
                        section: this.section,
                        onComplete: (t, e) => {
                            const s = e.container,
                                i = s.querySelector(vp),
                                o = s.querySelector(gp),
                                n = t.querySelectorAll(fp),
                                r = i.querySelector(yp),
                                a = i.hasAttribute(wp) ? parseInt(i.getAttribute(wp)) : 4,
                                l = !o && n.length > 0,
                                c = o && n.length >= a;
                            (l || c) && (c && o.classList.remove(Sp), i.classList.remove("is-hidden"), i.dispatchEvent(new CustomEvent("theme:tab:check", {
                                bubbles: !0
                            })), r && r.dispatchEvent(new CustomEvent("theme:grid-slider:init", {
                                bubbles: !0
                            })))
                        }
                    })
                }
                constructor(t) {
                    this.section = t, this.sectionId = t.id, this.container = t.container, this.related(), this.recent()
                }
            }(this)
        }
    };
    Po("related", [kp, Cc]), Po("reviews", [yn, sl]);
    const Ap = {},
        Cp = "[data-slider-logos]",
        Tp = "[data-slider-text]",
        qp = "[data-slide]",
        xp = "is-selected",
        Mp = "is-initialized",
        Pp = "flickity-enabled",
        Ip = "data-slide",
        Hp = "data-slide-index";
    Po("logos", [{
        onLoad() {
            Ap[this.id] = new class {
                getSlidesWidth() {
                    return 200 * this.logoSlides.length
                }
                initSlideshowText() {
                    this.slideshowText && (this.flkty = new n(this.slideshowText, {
                        fade: !0,
                        autoPlay: !1,
                        prevNextButtons: !1,
                        cellAlign: "left",
                        contain: !0,
                        pageDots: !1,
                        wrapAround: !1,
                        selectedAttraction: .2,
                        friction: .6,
                        draggable: !1,
                        accessibility: !1,
                        on: {
                            ready: () => this.sliderAccessibility(),
                            change: () => this.sliderAccessibility()
                        }
                    }))
                }
                sliderAccessibility() {
                    const t = this.slideshowText.querySelectorAll(`${qp} a, ${qp} button`);
                    t.length && t.forEach((t => {
                        const e = t.closest(qp);
                        if (e) {
                            const s = e.classList.contains(xp) ? 0 : -1;
                            t.setAttribute("tabindex", s)
                        }
                    }))
                }
                initSlideshowNav() {
                    this.slideshowNav && (this.logoSlides.length && this.logoSlides.forEach((t => {
                        t.addEventListener("click", (() => {
                            const e = parseInt(t.getAttribute(Hp)),
                                s = this.slideshowNav.classList.contains(Pp);
                            if (this.flkty && this.flkty.select(e), s) this.flktyNav.select(e), this.slideshowNav.classList.contains(xp) || this.flktyNav.playPlayer();
                            else {
                                const e = this.slideshowNav.querySelector(`.${xp}`);
                                e && e.classList.remove(xp), t.classList.add(xp)
                            }
                        }))
                    })), this.setSlideshowNavState(), document.addEventListener("theme:resize", this.setSlideshowNavStateOnResize))
                }
                setSlideshowNavState() {
                    const t = this.slideshowNav.classList.contains(Pp);
                    if (this.logoSlidesWidth > g()) {
                        if (!t) {
                            this.slideshowNav.classList.add(Mp);
                            const t = this.slideshowNav.querySelector(`.${xp}`);
                            t && t.classList.remove(xp), this.logoSlides[0].classList.add(xp), this.flktyNav || (this.flktyNav = new o(this.slideshowNav, {
                                autoPlay: 4e3,
                                prevNextButtons: !1,
                                contain: !1,
                                pageDots: !1,
                                wrapAround: !0,
                                watchCSS: !0,
                                selectedAttraction: .05,
                                friction: .8,
                                initialIndex: 0
                            }), this.flktyNav.on("deactivate", (() => {
                                this.slideshowNav.querySelector(qp).classList.add(xp), this.flkty && this.flkty.select(0)
                            })), this.flkty && (this.flkty.select(0), this.flktyNav.on("change", (t => this.flkty.select(t)))))
                        }
                    } else t && this.slideshowNav.classList.remove(Mp)
                }
                onBlockSelect(t) {
                    if (!this.slideshowNav) return;
                    const e = this.slideshowNav.querySelector(`[${Ip}="${t.detail.blockId}"]`),
                        s = parseInt(e.getAttribute(Hp));
                    this.slideshowNav.classList.contains(Pp) ? (this.flktyNav.select(s), this.flktyNav.stopPlayer(), this.slideshowNav.classList.add(xp)) : e.dispatchEvent(new Event("click"))
                }
                onBlockDeselect() {
                    this.slideshowNav && this.slideshowNav.classList.contains(Pp) && (this.flktyNav.playPlayer(), this.slideshowNav.classList.remove(xp))
                }
                onUnload() {
                    document.removeEventListener("theme:resize", this.setSlideshowNavStateOnResize)
                }
                constructor(t) {
                    this.container = t.container, this.slideshowNav = this.container.querySelector(Cp), this.slideshowText = this.container.querySelector(Tp), this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState(), this.flkty = null, this.flktyNav = null, this.logoSlides = this.slideshowNav.querySelectorAll(qp), this.logoSlidesWidth = this.getSlidesWidth(), this.initSlideshowText(), this.initSlideshowNav()
                }
            }(this)
        },
        onUnload(t) {
            Ap[this.id].onUnload(t)
        },
        onBlockSelect(t) {
            Ap[this.id].onBlockSelect(t)
        },
        onBlockDeselect(t) {
            Ap[this.id].onBlockDeselect(t)
        }
    }, sl]);
    const Op = "data-video-play";
    let Bp = class extends HTMLElement {
        connectedCallback() {
            var t;
            this.videoPlay = this.querySelectorAll(`[${Op}]`), null === (t = this.videoPlay) || void 0 === t || t.forEach((t => {
                t.addEventListener("click", (t => {
                    const e = t.currentTarget;
                    if ("" !== e.getAttribute(Op).trim()) {
                        t.preventDefault();
                        const s = [{
                            html: e.getAttribute(Op)
                        }];
                        new Hu(s), window.accessibility.lastElement = e
                    }
                }))
            }))
        }
        constructor() {
            super()
        }
    };
    const Dp = "[data-video-template]",
        Fp = "is-loading",
        $p = "data-video-id";
    let _p = class extends HTMLElement {
        connectedCallback() {
            this.videoId = this.getAttribute($p), this.videoTemplate = this.querySelector(Dp), this.video = null, this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this), this.videoId && this.renderVideo()
        }
        powerSaverVideoPlay() {
            var t;
            null === (t = this.video) || void 0 === t || t.play()
        }
        renderVideo() {
            this.videoTemplateObserver = new IntersectionObserver(((t, e) => {
                t.forEach((t => {
                    if (t.isIntersecting) {
                        const s = this.videoTemplate.innerHTML;
                        this.innerHTML = s, this.classList.remove(Fp), this.video = this.querySelector("video"), this.observeVideoPlayToggle(), this.video.play().then((() => {})).catch((() => {
                            document.addEventListener("click", this.powerSaverVideoPlay, {
                                passive: !0,
                                bubbles: !0,
                                once: !0
                            }), document.addEventListener("touchstart", this.powerSaverVideoPlay, {
                                passive: !0,
                                bubbles: !0,
                                once: !0
                            })
                        })), e.unobserve(t.target)
                    }
                }))
            }), {
                root: null,
                rootMargin: "300px",
                threshold: [0, .1, .25, .5, .75, 1]
            }), this.videoTemplateObserver.observe(this)
        }
        observeVideoPlayToggle() {
            if (!this.video) return;
            this.videoPlayObserver = new IntersectionObserver((t => {
                t.forEach((t => {
                    const e = t.isIntersecting;
                    e && "function" == typeof this.video.play && this.video.play(), e || "function" != typeof this.video.pause || this.video.pause()
                }))
            }), {
                rootMargin: "0px",
                threshold: [0, 1]
            }), this.videoPlayObserver.observe(this.video)
        }
        disconnectedCallback() {
            this.videoTemplateObserver && this.videoTemplateObserver.disconnect(), this.videoPlayObserver && this.videoPlayObserver.disconnect(), this.videoId && (document.removeEventListener("click", this.powerSaverVideoPlay), document.removeEventListener("touchstart", this.powerSaverVideoPlay))
        }
        constructor() {
            super()
        }
    };
    Po("featured-video", [jo]), customElements.get("video-background") || customElements.define("video-background", _p), customElements.get("video-popup") || customElements.define("video-popup", Bp), Po("slideshow", [yn, jo]);
    const Np = "[data-image-holder]",
        Rp = "[data-image-element]",
        zp = "[data-range-button]",
        Wp = "[data-range-input]";
    let Up = class extends HTMLElement {
        connectedCallback() {
            this.setOverlapImageSize(), this.setImagePosition(), this.rangeInput.addEventListener("input", (() => this.setImagePosition())), document.addEventListener("theme:resize", this.setOverlapImageSize)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize", this.setOverlapImageSize)
        }
        setImagePosition() {
            const t = this.rangeInput.value,
                e = this.imageElement.offsetWidth,
                s = this.rangeButton.offsetWidth;
            this.rangeButton.style.left = `${t}%`, this.imageHolder.style.width = (e - s) * (100 - t) / 100 + s / 2 + "px"
        }
        setOverlapImageSize() {
            const t = this.offsetWidth;
            this.imageElement.style.width = `${t}px`, this.setImagePosition()
        }
        constructor() {
            super(), this.imageHolder = this.querySelector(Np), this.imageElement = this.querySelector(Rp), this.rangeButton = this.querySelector(zp), this.rangeInput = this.querySelector(Wp), this.setOverlapImageSize = this.setOverlapImageSize.bind(this)
        }
    };
    Po("custom-content", [yn, jo, xn]), customElements.get("video-background") || customElements.define("video-background", _p), customElements.get("video-popup") || customElements.define("video-popup", Bp), customElements.get("compare-images") || customElements.define("compare-images", Up);
    var Vp = {};

    function jp(t) {
        return Vp[t]
    }
    Vp.basic = [], Vp.light = [{
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            lightness: "64"
        }, {
            hue: "#ff0000"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#bdbdbd"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f0f0f0"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "labels",
        stylers: [{
            lightness: "100"
        }]
    }, {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{
            visibility: "on"
        }]
    }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
            saturation: "-41"
        }, {
            color: "#e8ede7"
        }]
    }, {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: "-100"
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            lightness: "25"
        }, {
            gamma: "1.06"
        }, {
            saturation: "-100"
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            gamma: "10.00"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            gamma: "10.00"
        }, {
            lightness: "100"
        }, {
            weight: "0.4"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            weight: "0.01"
        }, {
            lightness: "39"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.50"
        }, {
            gamma: "10.00"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#cfe5ee"
        }, {
            visibility: "on"
        }]
    }], Vp.white_label = [{
        featureType: "all",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            gamma: "3.86"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#cccccc"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f2f2f2"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: -100
        }, {
            lightness: 45
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#e4e4e4"
        }, {
            visibility: "on"
        }]
    }], Vp.dark_label = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{
            saturation: 36
        }, {
            color: "#000000"
        }, {
            lightness: 40
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [{
            visibility: "on"
        }, {
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: 1.2
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            lightness: "-82"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{
            invert_lightness: !0
        }, {
            weight: "7.15"
        }]
    }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 21
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 29
        }, {
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 18
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 19
        }]
    }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }]
    }], window.theme.allMaps = window.theme.allMaps || {};
    let Xp = window.theme.allMaps;
    window.theme.mapAPI = window.theme.mapAPI || null;
    Po("map", {
        onLoad() {
            Xp[this.id] = new class {
                initMaps() {
                    (function(t) {
                        if (null === window.theme.mapAPI) {
                            const e = `https://maps.googleapis.com/maps/api/js?key=${t}`;
                            window.theme.mapAPI = wu({
                                url: e
                            })
                        }
                        return window.theme.mapAPI
                    })(this.key).then((() => {
                        return "true" === this.enableCorrection && "" !== this.lat && "" !== this.long ? new google.maps.LatLng(this.lat, this.long) : (t = this.address, new Promise(((e, s) => {
                            (new google.maps.Geocoder).geocode({
                                address: t
                            }, (function(t, i) {
                                if ("OK" == i) {
                                    var o = {
                                        lat: t[0].geometry.location.lat(),
                                        lng: t[0].geometry.location.lng()
                                    };
                                    e(o)
                                } else s(i)
                            }))
                        })));
                        var t
                    })).then((t => {
                        const e = {
                                zoom: parseInt(this.zoomString, 10),
                                styles: jp(this.styleString),
                                center: t,
                                draggable: !0,
                                clickableIcons: !1,
                                scrollwheel: !1,
                                zoomControl: !1,
                                disableDefaultUI: !0
                            },
                            s = function(t, e) {
                                var s = new google.maps.Map(t, e),
                                    i = s.getCenter();
                                return new google.maps.Marker({
                                    map: s,
                                    position: i
                                }), google.maps.event.addDomListener(window, "resize", (function() {
                                    google.maps.event.trigger(s, "resize"), s.setCenter(i)
                                })), s
                            }(this.mapContainer, e);
                        return s
                    })).then((t => {
                        this.map = t, Xp[this.id] = t
                    })).catch((t => {
                        console.log("Failed to load Google Map"), console.log(t)
                    }))
                }
                unload() {
                    void 0 !== window.google && google.maps.event.clearListeners(this.map, "resize")
                }
                constructor(t) {
                    this.container = t.container, this.mapContainer = this.container.querySelector("[data-map-container]"), this.key = this.container.getAttribute("data-api-key"), this.styleString = this.container.getAttribute("data-style") || "", this.zoomString = this.container.getAttribute("data-zoom") || 14, this.address = this.container.getAttribute("data-address"), this.enableCorrection = this.container.getAttribute("data-latlong-correction"), this.lat = this.container.getAttribute("data-lat"), this.long = this.container.getAttribute("data-long"), this.key && this.initMaps()
                }
            }(this)
        },
        onUnload() {
            "function" == typeof Xp[this.id].unload && Xp[this.id].unload()
        }
    });
    const Jp = "[data-large-promo]",
        Yp = "[data-large-promo-inner]",
        Qp = "[data-tracking-consent]",
        Gp = "[data-confirm-cookies]",
        Kp = "cart-bar",
        Zp = "[data-newsletter]",
        tm = "[data-newsletter-holder]",
        em = "[data-newsletter-heading]",
        sm = "[data-newsletter-field]",
        im = "[data-promo-text]",
        om = "[data-newsletter-form]",
        nm = "data-popup-delay",
        rm = "data-cookie-name",
        am = "data-target-referrer",
        lm = "hidden",
        cm = "has-value",
        hm = "cart-bar-visible",
        dm = "is-visible",
        um = "has-success",
        pm = "selected",
        mm = "has-block-selected",
        vm = "mobile",
        gm = "desktop",
        fm = "bottom",
        ym = "data-enable";
    let bm = {},
        wm = class {
            always() {
                this.popupActions.popupOpen()
            }
            delayed(t = 10) {
                setTimeout((() => {
                    this.popupActions.popupOpen()
                }), 1e3 * t)
            }
            idle() {
                let t = 0;
                const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    s = ["load", "resize", "scroll"],
                    i = () => {
                        t = setTimeout((() => {
                            t = 0, this.popupActions.popupOpen()
                        }), 6e4), e.forEach((t => {
                            document.addEventListener(t, o)
                        })), s.forEach((t => {
                            window.addEventListener(t, o)
                        }))
                    },
                    o = () => {
                        t && clearTimeout(t), e.forEach((t => {
                            document.removeEventListener(t, o)
                        })), s.forEach((t => {
                            window.removeEventListener(t, o)
                        })), i()
                    };
                i()
            }
            bottom() {
                document.addEventListener("theme:scroll", this.showPopupOnScrollEvent)
            }
            showPopupOnScroll() {
                window.scrollY + window.innerHeight >= document.body.clientHeight && (this.popupActions.popupOpen(), document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent))
            }
            onUnload() {
                document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent)
            }
            constructor(t, e, s) {
                if (this.element = e, this.delay = t.getAttribute(nm), this.isSubmitted = -1 !== window.location.href.indexOf("accepts_marketing") || -1 !== window.location.href.indexOf("customer_posted=true"), this.popupActions = s, this.showPopupOnScrollEvent = () => this.showPopupOnScroll(), ("always" === this.delay || this.isSubmitted) && this.always(), this.delay && this.delay.includes("delayed") && !this.isSubmitted) {
                    const t = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
                    this.delayed(t)
                }
                "bottom" !== this.delay || this.isSubmitted || this.bottom(), "idle" !== this.delay || this.isSubmitted || this.idle()
            }
        },
        Em = class {
            init() {
                -1 !== this.locationPath.indexOf(this.el.getAttribute(am)) || window.Shopify.designMode || this.el.parentNode.removeChild(this.el)
            }
            constructor(t) {
                if (this.el = t, this.locationPath = location.href, !this.el.hasAttribute(am)) return !1;
                this.init()
            }
        };
    const Sm = {
        onLoad() {
            bm[this.id] = [];
            this.container.querySelectorAll(Jp).forEach((t => {
                bm[this.id].push(new class {
                    init() {
                        const t = !1 !== this.cookie.read(),
                            e = this.popup.classList.contains(vm),
                            s = this.popup.classList.contains(gm),
                            i = !y();
                        let o = !0;
                        if ((e && !i || s && i) && (o = !1), !o) return this.a11y.removeTrapFocus(), void document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0
                        }));
                        t && !window.Shopify.designMode || (window.Shopify.designMode || window.location.pathname.endsWith("/challenge") || new wm(this.popup, this.modal, this.popupActions), this.form && this.form.classList.contains(um) && this.checkForSuccess(), this.modal.addEventListener("theme:popup:onclose", (() => this.cookie.write())))
                    }
                    checkForSuccess() {
                        this.popupActions.popupOpen(), this.cookie.write()
                    }
                    onBlockSelect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupOpen(), this.popup.classList.add(pm), this.popup.parentNode.classList.add(mm))
                    }
                    onBlockDeselect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupClose(), this.popup.classList.remove(pm), this.popup.parentNode.classList.remove(mm))
                    }
                    constructor(t) {
                        this.popup = t, this.modal = this.popup.querySelector(Yp), this.form = this.popup.querySelector(om), this.cookie = new wn(this.popup.getAttribute(rm), "user_has_closed"), this.isTargeted = new Em(this.popup), this.popupActions = new cu(this.modal, this.modal, !0, !0), this.a11y = z, this.init()
                    }
                }(t))
            }));
            this.container.querySelectorAll(Qp).forEach((t => {
                bm[this.id].push(new class {
                    init() {
                        this.showPopup && this.popupActions.popupOpen(), this.clickEvents()
                    }
                    clickEvents() {
                        this.acceptButton.addEventListener("click", (t => {
                            t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, (() => this.popupActions.popupClose())), document.documentElement.style.setProperty("--cookie-bar-height", "0px")
                        })), document.addEventListener("trackingConsentAccepted", (() => {}))
                    }
                    onSelect() {
                        this.showPopup && (this.popupActions.popupOpen(), this.popup.classList.add(pm), this.popup.parentNode.classList.add(mm))
                    }
                    onDeselect() {
                        this.showPopup && (this.popupActions.popupClose(), this.popup.classList.remove(pm), this.popup.parentNode.classList.remove(mm))
                    }
                    constructor(t) {
                        this.popup = t, this.modal = document.querySelector(Qp), this.acceptButton = this.modal.querySelector(Gp), this.enable = "true" === this.modal.getAttribute(ym), this.showPopup = !1, this.popupActions = new cu(this.popup, this.popup, !1, !1), window.Shopify.loadFeatures([{
                            name: "consent-tracking-api",
                            version: "0.1"
                        }], (t => {
                            if (t) throw t;
                            const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                                s = window.Shopify.customerPrivacy.getTrackingConsent();
                            this.showPopup = !e && "no_interaction" === s && this.enable, window.Shopify.designMode && (this.showPopup = !0), this.init()
                        }))
                    }
                }(t))
            }));
            this.container.querySelectorAll(Zp).forEach((t => {
                bm[this.id].push(new class {
                    init() {
                        const t = !1 !== this.cookie.read(),
                            e = -1 !== window.location.search.indexOf("?customer_posted=true"),
                            s = [...this.holder.classList].toString().includes(fm);
                        e && (this.delay = 0), t && !window.Shopify.designMode || (this.show(), this.form.classList.contains(um) && this.checkForSuccess()), s && this.observeCartBar()
                    }
                    show() {
                        window.location.pathname.endsWith("/challenge") || (window.Shopify.designMode ? this.popupActions.popupOpen() : new wm(this.popup, this.holder, this.popupActions)), this.showForm(), this.inputField(), this.holder.addEventListener("theme:popup:onclose", (() => this.cookie.write()))
                    }
                    checkForSuccess() {
                        this.popupActions.popupOpen(), this.cookie.write()
                    }
                    observeCartBar() {
                        if (this.cartBar = document.getElementById(Kp), !this.cartBar) return;
                        let t = this.cartBar.classList.contains(dm);
                        document.body.classList.toggle(hm, t), this.observer = new MutationObserver((e => {
                            for (const s of e) "attributes" === s.type && (t = s.target.classList.contains(dm), document.body.classList.toggle(hm, t))
                        })), this.observer.observe(this.cartBar, {
                            attributes: !0,
                            childList: !1,
                            subtree: !1
                        })
                    }
                    showForm() {
                        this.heading.addEventListener("click", (t => {
                            t.preventDefault(), this.heading.classList.add(lm), this.form.classList.remove(lm), this.newsletterField.focus()
                        })), this.heading.addEventListener("keyup", (t => {
                            "Enter" === t.code && this.heading.dispatchEvent(new Event("click"))
                        }))
                    }
                    inputField() {
                        const t = () => {
                            this.resetClassTimer && clearTimeout(this.resetClassTimer), "" !== this.newsletterField.value && this.holder.classList.add(cm)
                        };
                        this.newsletterField.addEventListener("input", t), this.newsletterField.addEventListener("focus", t), this.newsletterField.addEventListener("focusout", (() => {
                            this.resetClassTimer && clearTimeout(this.resetClassTimer), this.resetClassTimer = setTimeout((() => {
                                this.holder.classList.remove(cm)
                            }), 2e3)
                        }))
                    }
                    onBlockSelect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupOpen(), this.popup.classList.add(pm), this.popup.parentNode.classList.add(mm))
                    }
                    onBlockDeselect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupClose(), this.popup.classList.remove(pm), this.popup.parentNode.classList.remove(mm))
                    }
                    onUnload() {
                        this.observer && this.observer.disconnect()
                    }
                    constructor(t) {
                        this.popup = t, this.holder = this.popup.querySelector(tm), this.heading = this.popup.querySelector(em), this.newsletterField = this.popup.querySelector(sm), this.cookie = new wn(this.popup.getAttribute(rm), "newsletter_is_closed"), this.form = this.popup.querySelector(om), this.isTargeted = new Em(this.popup), this.popupActions = new cu(this.holder, this.holder, !1, !1), this.resetClassTimer = 0, this.init()
                    }
                }(t))
            }));
            this.container.querySelectorAll(im).forEach((t => {
                bm[this.id].push(new class {
                    init() {
                        !1 !== this.cookie.read() && !window.Shopify.designMode || (window.Shopify.designMode ? this.popupActions.popupOpen() : new wm(this.popup, this.popup, this.popupActions), this.popup.addEventListener("theme:popup:onclose", (() => this.cookie.write())))
                    }
                    onSelect() {
                        this.popupActions.popupOpen(), this.popup.classList.add(pm), this.popup.parentNode.classList.add(mm)
                    }
                    onDeselect() {
                        this.popupActions.popupClose(), this.popup.classList.remove(pm), this.popup.parentNode.classList.remove(mm)
                    }
                    constructor(t) {
                        this.popup = t, this.cookie = new wn(this.popup.getAttribute(rm), "user_has_closed"), this.isTargeted = new Em(this.popup), this.popupActions = new cu(this.popup, this.popup, !1, !1), this.init()
                    }
                }(t))
            }))
        },
        onBlockSelect(t) {
            bm[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        },
        onBlockDeselect(t) {
            bm[this.id].forEach((e => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
            }))
        },
        onSelect() {
            bm[this.id].forEach((t => {
                "function" == typeof t.onSelect && t.onSelect()
            }))
        },
        onDeselect() {
            bm[this.id].forEach((t => {
                "function" == typeof t.onDeselect && t.onDeselect()
            }))
        },
        onUnload() {
            bm[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        }
    };
    Po("popups", [Sm, xn]);
    const Lm = "[data-password-modal]",
        km = "#login_form .errors";
    Po("password-template", {
        onLoad() {
            new class {
                constructor(t) {
                    this.container = t.container, this.popupActions = new cu(this.container.querySelector(Lm), this.container, !0, !0), this.container.querySelector(km) && this.popupActions.popupOpen()
                }
            }(this)
        }
    }), Po("list-collections", [yn, sl]), Po("columns", [sl, yn]), Po("newsletter", xn), customElements.get("compare-images") || customElements.define("compare-images", Up);
    const Am = "[data-scroll-to]",
        Cm = "[data-tooltip]",
        Tm = "[data-collapsible-trigger]",
        qm = "open",
        xm = "data-scroll-to",
        Mm = "data-tooltip-stop-mouseenter",
        Pm = {};
    const Im = {
            onLoad() {
                Pm[this.id] = new class {
                    init() {
                        this.scrollToButtons.forEach((t => {
                            t.addEventListener("click", (() => {
                                const e = this.container.querySelector(t.getAttribute(xm));
                                e && "A" !== t.tagName && this.scrollToElement(e)
                            }))
                        }))
                    }
                    scrollToElement(t) {
                        bn(t.getBoundingClientRect().top + 1);
                        const e = t.nextElementSibling.matches("details") ? t.nextElementSibling : null;
                        if (e) {
                            const t = null == e ? void 0 : e.querySelector(Tm);
                            e.hasAttribute(qm) || null == t || t.dispatchEvent(new Event("click"))
                        }
                        const s = document.querySelectorAll(`${Cm}:not([${Mm}])`);
                        s.length && s.forEach((t => {
                            t.setAttribute(Mm, ""), setTimeout((() => {
                                t.removeAttribute(Mm)
                            }), 1e3)
                        }))
                    }
                    constructor(t) {
                        this.section = t, this.container = t.container, this.scrollToButtons = this.container.querySelectorAll(Am), this.scrollToButtons.length && this.init()
                    }
                }(this)
            }
        },
        Hm = "[data-scroll-spy]",
        Om = "is-selected",
        Bm = "data-scroll-spy",
        Dm = "data-scroll-spy-mobile",
        Fm = "data-scroll-spy-desktop",
        $m = "data-scroll-trigger-point",
        _m = {};
    const Nm = {
        onLoad() {
            var t;
            _m[this.id] = [], null === (t = this.container.querySelectorAll(Hm)) || void 0 === t || t.forEach((t => {
                const e = this.container.querySelector(t.getAttribute(Bm));
                _m[this.id].push(new class {
                    init() {
                        this.toggleScrollObserver(), document.addEventListener("theme:resize:width", this.toggleScrollObserver)
                    }
                    toggleScrollObserver() {
                        this.isEligible() ? this.initialized || (document.addEventListener("theme:scroll", this.scrollCallback), this.initialized = !0) : (document.removeEventListener("theme:scroll", this.scrollCallback), this.initialized = !1)
                    }
                    isEligible() {
                        const t = y();
                        return !t && this.anchor.hasAttribute(Dm) || t && this.anchor.hasAttribute(Fm) || !this.anchor.hasAttribute(Fm) && !this.anchor.hasAttribute(Dm)
                    }
                    onScroll() {
                        this.top = this.elementToSpy.getBoundingClientRect().top;
                        const t = Math.round(window.innerHeight),
                            e = Math.round(window.scrollY),
                            s = e + t,
                            i = Math.round(this.top + e),
                            o = this.elementToSpy.offsetHeight;
                        i < s && !(i + o < e) && this.triggerPointReached() && (this.anchorSiblings.forEach((t => {
                            t.matches(this.anchorSelector) || t.classList.remove(Om)
                        })), this.anchor.classList.add(Om))
                    }
                    triggerPointReached() {
                        let t = !1;
                        switch (this.triggerPoint) {
                            case "top":
                            default:
                                t = this.top <= 0;
                                break;
                            case "middle":
                                t = this.top <= window.innerHeight / 2;
                                break;
                            case "bottom":
                                t = this.top <= window.innerHeight
                        }
                        return t
                    }
                    onUnload() {
                        document.removeEventListener("theme:resize:width", this.toggleScrollObserver), document.removeEventListener("theme:scroll", this.scrollCallback)
                    }
                    constructor(t, e) {
                        this.container = t, this.elementToSpy = e, this.anchorSelector = `[${Bm}="#${this.elementToSpy.id}"]`, this.anchor = this.container.querySelector(this.anchorSelector), this.anchorSiblings = this.container.querySelectorAll(`[${Bm}]`), this.initialized = !1, this.anchor && (this.triggerPoint = this.anchor.getAttribute($m), this.scrollCallback = () => this.onScroll(), this.toggleScrollObserver = this.toggleScrollObserver.bind(this), this.init())
                    }
                }(this.container, e))
            }))
        },
        onUnload() {
            _m[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        }
    };
    Po("sidebar", [Im, Nm]);
    const Rm = "[data-hover-target]",
        zm = "[data-collection-image]",
        Wm = "data-hover-target",
        Um = "is-visible",
        Vm = "is-selected";
    let jm = {};
    Po("collections-hover", [{
        onLoad() {
            jm[this.id] = new class {
                init() {
                    this.buttons.length && this.buttons.forEach((t => {
                        t.addEventListener("mouseenter", (t => {
                            const e = t.currentTarget.getAttribute(Wm);
                            this.updateState(e)
                        }))
                    }))
                }
                updateState(t) {
                    const e = this.container.querySelector(`[${Wm}="${t}"]`),
                        s = this.container.querySelector(`#${t}:not(.${Um})`),
                        i = this.container.querySelector(`${Rm}.${Vm}`),
                        o = this.container.querySelector(`${zm}.${Um}`);
                    s && y() && (null == o || o.classList.remove(Um), null == i || i.classList.remove(Vm), s.classList.add(Um), e.classList.add(Vm))
                }
                onBlockSelect(t) {
                    this.updateState(t.target.id)
                }
                constructor(t) {
                    this.container = t.container, this.buttons = this.container.querySelectorAll(Rm), this.init()
                }
            }(this)
        },
        onBlockSelect(t) {
            jm[this.id].onBlockSelect(t)
        }
    }, Nm]);
    const Xm = "[data-featured-image]",
        Jm = "[data-featured-aside]",
        Ym = "[data-featured-content]",
        Qm = "[data-featured-wrapper]",
        Gm = "data-horizontal-scroll",
        Km = "data-horizontal-scroll-reversed",
        Zm = {};
    Po("featured-product", [{
        onLoad() {
            Zm[this.id] = new class {
                init() {
                    this.horizontalScroll && this.imagesHolder && (this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent), document.addEventListener("theme:scroll", this.scrollEvent)), this.wrapper && this.contentHolder && this.images.length && (this.calculateHeight(), document.addEventListener("theme:resize:width", this.calculateHeightEvent))
                }
                scrollEvents() {
                    this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent))
                }
                removeAnimationFrame() {
                    this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), this.requestAnimationSticky = null)
                }
                calculateHorizontalPosition() {
                    let t = window.scrollY + this.headerHeight;
                    const e = t + window.innerHeight,
                        s = this.imagesHolder.offsetTop,
                        i = this.imagesHolder.offsetHeight,
                        o = s + i + this.headerHeight,
                        n = i - (window.innerHeight - this.headerHeight),
                        r = this.horizontalScrollReversed ? 1 : -1;
                    let a = 0;
                    a = t >= s && e <= o ? (t - s) / n * 100 : t < s ? 0 : 100, a *= this.images.length - 1, this.container.style.setProperty("--translateX", a * r + "%"), this.lastPercent !== a ? this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent) : this.requestAnimationSticky && this.removeAnimationFrame(), this.lastPercent = a
                }
                calculateHeight() {
                    let {
                        stickyHeaderHeight: t
                    } = c();
                    this.container.style.removeProperty("--min-height"), this.container.style.setProperty("--min-height", `${this.wrapper.offsetHeight+this.contentHolder.offsetHeight}px`), this.headerHeight = t
                }
                onUnload() {
                    this.horizontalScroll && this.imagesHolder && document.removeEventListener("theme:scroll", this.calculateHorizontalPositionEvent), this.wrapper && this.contentHolder && this.images.length && document.removeEventListener("theme:resize:width", this.calculateHeightEvent)
                }
                constructor(t) {
                    this.container = t.container, this.horizontalScroll = this.container.hasAttribute(Gm), this.horizontalScrollReversed = this.container.hasAttribute(Km), this.images = this.container.querySelectorAll(Xm), this.imagesHolder = this.container.querySelector(Jm), this.contentHolder = this.container.querySelector(Ym), this.wrapper = this.container.querySelector(Qm), this.requestAnimationSticky = null, this.lastPercent = 0, this.scrollEvent = () => this.scrollEvents(), this.calculateHorizontalPositionEvent = () => this.calculateHorizontalPosition(), this.calculateHeightEvent = () => this.calculateHeight(), this.init()
                }
            }(this)
        },
        onUnload(t) {
            Zm[this.id].onUnload(t)
        }
    }]);
    const tv = "[data-timeline-holder]",
        ev = "[data-timeline-rows]",
        sv = "[data-timeline-row]",
        iv = "[data-timeline-row-editor]",
        ov = "[data-timeline-button]",
        nv = "[data-block-scroll]",
        rv = "is-selected",
        av = {};
    Po("timeline", [{
        onLoad() {
            av[this.id] = new class {
                init() {
                    this.calculateRowsDimensions(), this.requestAnimation = requestAnimationFrame((() => this.calculatePosition())), this.isDesktopView && !this.isScrollEnabled && (this.isScrollEnabled = !0, document.addEventListener("theme:scroll", this.scrollEvent)), this.rowsHolder.addEventListener("scroll", this.scrollEvent), document.addEventListener("theme:resize:width", this.resizeEvent), this.buttons.length && this.buttons.forEach(((t, e) => {
                        t.addEventListener("click", (t => {
                            t.preventDefault();
                            const s = t.currentTarget.closest(sv);
                            if (!s) return;
                            const i = Math.max(...this.rowsHeight),
                                o = this.holderHeight / this.rows.length,
                                n = this.holder.getBoundingClientRect().top,
                                r = e > 0 && i < o ? o * e + n : n,
                                a = y() ? r + 1 : s.getBoundingClientRect().top;
                            bn(a)
                        }))
                    }))
                }
                resizeEvents() {
                    this.holderTop = this.holder.getBoundingClientRect().top + window.scrollY, this.holderHeight = this.holder.offsetHeight, this.calculateRowsDimensions(), this.requestAnimation = requestAnimationFrame((() => this.calculatePosition()));
                    const t = y();
                    t && !this.isScrollEnabled ? (this.isScrollEnabled = !0, document.addEventListener("theme:scroll", this.scrollEvent)) : !t && this.isScrollEnabled && (this.isScrollEnabled = !1, document.removeEventListener("theme:scroll", this.scrollEvent))
                }
                scrollEvents(t) {
                    if (!this.requestAnimation) {
                        const e = t.currentTarget;
                        this.requestAnimation = requestAnimationFrame((() => this.calculatePosition(e)))
                    }
                }
                removeAnimationFrame() {
                    this.requestAnimation && (cancelAnimationFrame(this.requestAnimation), this.requestAnimation = null)
                }
                calculateRowsDimensions() {
                    if (this.rows.length) {
                        this.rowsHeight = [], this.rowsWidth = 0;
                        let t = 0;
                        this.rows.forEach(((e, s) => {
                            if (this.rowsHeight.push(e.offsetHeight), this.rowsWidth += e.offsetWidth + parseInt(getComputedStyle(e).marginRight), window.Shopify.designMode) {
                                const n = this.container.querySelectorAll(iv);
                                var i, o;
                                n.length && (t += e.offsetHeight, null === (i = n[s]) || void 0 === i || i.style.setProperty("--row-height-min", `${e.offsetHeight}px`), null === (o = n[s + 1]) || void 0 === o || o.style.setProperty("--row-top-mobile", `${t}px`))
                            }
                        }))
                    }
                }
                calculatePosition(t = null) {
                    this.removeAnimationFrame();
                    const e = y(),
                        s = this.holderHeight / this.rows.length;
                    let i = this.holderTop;
                    const o = window.innerHeight,
                        n = window.scrollY + o;
                    let r = 0;
                    if (!e && t) {
                        const e = t.scrollLeft - 16,
                            s = t.offsetWidth;
                        r = e / (this.rowsWidth - s) * 100, this.holder.style.setProperty("--percent-mobile", `${r}%`)
                    }
                    e && (n < this.holderTop || n > this.holderTop + this.holderHeight + o) || this.rows.forEach(((t, o) => {
                        if (o > 0) {
                            const o = t.offsetLeft / this.rowsWidth * 100;
                            let l = r > o;
                            var a;
                            e && (l = i + s < n, i - s < n && (null === (a = t.previousElementSibling) || void 0 === a || a.style.setProperty("--percent-desktop", (n - i) / s * 100 + "%"))), t.classList.toggle(rv, l)
                        }
                        i += s
                    }))
                }
                onUnload() {
                    this.isScrollEnabled && (this.isScrollEnabled = !1, document.removeEventListener("theme:scroll", this.scrollEvent)), this.rowsHolder.removeEventListener("scroll", this.scrollEvent), document.removeEventListener("theme:resize:width", this.resizeEvent)
                }
                onBlockSelect(t) {
                    const e = this.container.querySelector(nv);
                    if (e) {
                        const s = t.srcElement,
                            i = [...s.parentElement.children].indexOf(s),
                            o = this.rows[i];
                        o && e.scrollTo({
                            top: 0,
                            left: o.offsetLeft,
                            behavior: "smooth"
                        })
                    }
                }
                constructor(t) {
                    this.container = t.container, this.rows = this.container.querySelectorAll(sv), this.holder = this.container.querySelector(tv), this.rows.length < 2 || !this.holder || (this.rowsWidth = 0, this.rowsHeight = [], this.holderTop = this.holder.getBoundingClientRect().top + window.scrollY, this.holderHeight = this.holder.offsetHeight, this.buttons = this.container.querySelectorAll(ov), this.rowsHolder = this.container.querySelector(ev), this.requestAnimation = null, this.isDesktopView = y(), this.isScrollEnabled = !1, this.scrollEvent = t => this.scrollEvents(t), this.resizeEvent = () => this.resizeEvents(), this.init())
                }
            }(this)
        },
        onUnload(t) {
            av[this.id].onUnload(t)
        },
        onBlockSelect(t) {
            av[this.id].onBlockSelect(t)
        }
    }]), document.addEventListener("DOMContentLoaded", (function() {
        Io("*");
        const t = document.querySelector("[data-scroll-top-button]");
        t && (t.addEventListener("click", (() => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            })
        })), document.addEventListener("theme:scroll", (() => {
            t.classList.toggle("is-visible", window.scrollY > window.innerHeight)
        }))), window.self !== window.top && document.querySelector("html").classList.add("iframe"), "scrollBehavior" in document.documentElement.style || wu({
            url: window.theme.assets.smoothscroll
        })
    })), window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies"))
}(themeVendor.ScrollLock, themeVendor.themeAddresses, themeVendor.themeCurrency, themeVendor.Rellax, themeVendor.Flickity, themeVendor.FlickityFade, themeVendor.themeImages);